import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import React, { useState, useEffect, useRef, useCallback, memo, useMemo, createElement } from 'react';
import clsx from 'clsx';
import ReactTooltip from 'react-tooltip';
import { capitalize, useOutsideClick, usePrevious, useWindowSize, stringPathToObjectValue } from '@webbio/core-utils';
import { Manager, Reference, Popper as Popper$1 } from 'react-popper';
import { useDrop, useDrag, DndProvider } from 'react-dnd';
import { useDropzone } from 'react-dropzone';
import update from 'immutability-helper';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { ReactSVG } from 'react-svg';
import ReactDOM from 'react-dom';
import FocusLock from 'react-focus-lock';
import { useResizeDetector } from 'react-resize-detector';
import { ResponsiveContainer, PieChart as PieChart$1, Pie, Cell, Sector } from 'recharts';
import { toast, Flip, Zoom, Slide, Bounce, ToastContainer as ToastContainer$1 } from 'react-toastify';
import DatePickerComponent, { registerLocale } from 'react-datepicker';

var fails = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};

// Detect IE8's incomplete defineProperty implementation
var descriptors = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] != 7;
});

var commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var check = function (it) {
  return it && it.Math == Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global_1 =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof commonjsGlobal == 'object' && commonjsGlobal) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || Function('return this')();

var isObject = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};

var document$1 = global_1.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document$1) && isObject(document$1.createElement);

var documentCreateElement = function (it) {
  return EXISTS ? document$1.createElement(it) : {};
};

// Thank's IE8 for his funny defineProperty
var ie8DomDefine = !descriptors && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- requied for testing
  return Object.defineProperty(documentCreateElement('div'), 'a', {
    get: function () { return 7; }
  }).a != 7;
});

var anObject = function (it) {
  if (!isObject(it)) {
    throw TypeError(String(it) + ' is not an object');
  } return it;
};

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
var toPrimitive = function (input, PREFERRED_STRING) {
  if (!isObject(input)) return input;
  var fn, val;
  if (PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  if (typeof (fn = input.valueOf) == 'function' && !isObject(val = fn.call(input))) return val;
  if (!PREFERRED_STRING && typeof (fn = input.toString) == 'function' && !isObject(val = fn.call(input))) return val;
  throw TypeError("Can't convert object to primitive value");
};

// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
var f = descriptors ? $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (ie8DomDefine) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};

var objectDefineProperty = {
	f: f
};

var defineProperty = objectDefineProperty.f;

var FunctionPrototype = Function.prototype;
var FunctionPrototypeToString = FunctionPrototype.toString;
var nameRE = /^\s*function ([^ (]*)/;
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (descriptors && !(NAME in FunctionPrototype)) {
  defineProperty(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return FunctionPrototypeToString.call(this).match(nameRE)[1];
      } catch (error) {
        return '';
      }
    }
  });
}

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
var f$1 = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;

var objectPropertyIsEnumerable = {
	f: f$1
};

var createPropertyDescriptor = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};

var toString = {}.toString;

var classofRaw = function (it) {
  return toString.call(it).slice(8, -1);
};

var split = ''.split;

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var indexedObject = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classofRaw(it) == 'String' ? split.call(it, '') : Object(it);
} : Object;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
var requireObjectCoercible = function (it) {
  if (it == undefined) throw TypeError("Can't call method on " + it);
  return it;
};

// toObject with fallback for non-array-like ES3 strings



var toIndexedObject = function (it) {
  return indexedObject(requireObjectCoercible(it));
};

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
var toObject = function (argument) {
  return Object(requireObjectCoercible(argument));
};

var hasOwnProperty = {}.hasOwnProperty;

var has = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty.call(toObject(it), key);
};

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
var f$2 = descriptors ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPrimitive(P, true);
  if (ie8DomDefine) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (has(O, P)) return createPropertyDescriptor(!objectPropertyIsEnumerable.f.call(O, P), O[P]);
};

var objectGetOwnPropertyDescriptor = {
	f: f$2
};

var createNonEnumerableProperty = descriptors ? function (object, key, value) {
  return objectDefineProperty.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};

var setGlobal = function (key, value) {
  try {
    createNonEnumerableProperty(global_1, key, value);
  } catch (error) {
    global_1[key] = value;
  } return value;
};

var SHARED = '__core-js_shared__';
var store = global_1[SHARED] || setGlobal(SHARED, {});

var sharedStore = store;

var functionToString = Function.toString;

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (typeof sharedStore.inspectSource != 'function') {
  sharedStore.inspectSource = function (it) {
    return functionToString.call(it);
  };
}

var inspectSource = sharedStore.inspectSource;

var WeakMap = global_1.WeakMap;

var nativeWeakMap = typeof WeakMap === 'function' && /native code/.test(inspectSource(WeakMap));

var shared = createCommonjsModule(function (module) {
(module.exports = function (key, value) {
  return sharedStore[key] || (sharedStore[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.15.2',
  mode:  'global',
  copyright: '© 2021 Denis Pushkarev (zloirock.ru)'
});
});

var id = 0;
var postfix = Math.random();

var uid = function (key) {
  return 'Symbol(' + String(key === undefined ? '' : key) + ')_' + (++id + postfix).toString(36);
};

var keys = shared('keys');

var sharedKey = function (key) {
  return keys[key] || (keys[key] = uid(key));
};

var hiddenKeys = {};

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var WeakMap$1 = global_1.WeakMap;
var set, get, has$1;

var enforce = function (it) {
  return has$1(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (nativeWeakMap || sharedStore.state) {
  var store$1 = sharedStore.state || (sharedStore.state = new WeakMap$1());
  var wmget = store$1.get;
  var wmhas = store$1.has;
  var wmset = store$1.set;
  set = function (it, metadata) {
    if (wmhas.call(store$1, it)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    wmset.call(store$1, it, metadata);
    return metadata;
  };
  get = function (it) {
    return wmget.call(store$1, it) || {};
  };
  has$1 = function (it) {
    return wmhas.call(store$1, it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (has(it, STATE)) throw new TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return has(it, STATE) ? it[STATE] : {};
  };
  has$1 = function (it) {
    return has(it, STATE);
  };
}

var internalState = {
  set: set,
  get: get,
  has: has$1,
  enforce: enforce,
  getterFor: getterFor
};

var redefine = createCommonjsModule(function (module) {
var getInternalState = internalState.get;
var enforceInternalState = internalState.enforce;
var TEMPLATE = String(String).split('String');

(module.exports = function (O, key, value, options) {
  var unsafe = options ? !!options.unsafe : false;
  var simple = options ? !!options.enumerable : false;
  var noTargetGet = options ? !!options.noTargetGet : false;
  var state;
  if (typeof value == 'function') {
    if (typeof key == 'string' && !has(value, 'name')) {
      createNonEnumerableProperty(value, 'name', key);
    }
    state = enforceInternalState(value);
    if (!state.source) {
      state.source = TEMPLATE.join(typeof key == 'string' ? key : '');
    }
  }
  if (O === global_1) {
    if (simple) O[key] = value;
    else setGlobal(key, value);
    return;
  } else if (!unsafe) {
    delete O[key];
  } else if (!noTargetGet && O[key]) {
    simple = true;
  }
  if (simple) O[key] = value;
  else createNonEnumerableProperty(O, key, value);
// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
})(Function.prototype, 'toString', function toString() {
  return typeof this == 'function' && getInternalState(this).source || inspectSource(this);
});
});

var path = global_1;

var aFunction = function (variable) {
  return typeof variable == 'function' ? variable : undefined;
};

var getBuiltIn = function (namespace, method) {
  return arguments.length < 2 ? aFunction(path[namespace]) || aFunction(global_1[namespace])
    : path[namespace] && path[namespace][method] || global_1[namespace] && global_1[namespace][method];
};

var ceil = Math.ceil;
var floor = Math.floor;

// `ToInteger` abstract operation
// https://tc39.es/ecma262/#sec-tointeger
var toInteger = function (argument) {
  return isNaN(argument = +argument) ? 0 : (argument > 0 ? floor : ceil)(argument);
};

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
var toLength = function (argument) {
  return argument > 0 ? min(toInteger(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};

var max = Math.max;
var min$1 = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
var toAbsoluteIndex = function (index, length) {
  var integer = toInteger(index);
  return integer < 0 ? max(integer + length, 0) : min$1(integer, length);
};

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

var arrayIncludes = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};

var indexOf = arrayIncludes.indexOf;


var objectKeysInternal = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !has(hiddenKeys, key) && has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~indexOf(result, key) || result.push(key);
  }
  return result;
};

// IE8- don't enum bug keys
var enumBugKeys = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];

var hiddenKeys$1 = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
var f$3 = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return objectKeysInternal(O, hiddenKeys$1);
};

var objectGetOwnPropertyNames = {
	f: f$3
};

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
var f$4 = Object.getOwnPropertySymbols;

var objectGetOwnPropertySymbols = {
	f: f$4
};

// all object keys, includes non-enumerable and symbols
var ownKeys = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = objectGetOwnPropertyNames.f(anObject(it));
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  return getOwnPropertySymbols ? keys.concat(getOwnPropertySymbols(it)) : keys;
};

var copyConstructorProperties = function (target, source) {
  var keys = ownKeys(source);
  var defineProperty = objectDefineProperty.f;
  var getOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!has(target, key)) defineProperty(target, key, getOwnPropertyDescriptor(source, key));
  }
};

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value == POLYFILL ? true
    : value == NATIVE ? false
    : typeof detection == 'function' ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

var isForced_1 = isForced;

var getOwnPropertyDescriptor$1 = objectGetOwnPropertyDescriptor.f;






/*
  options.target      - name of the target object
  options.global      - target is the global object
  options.stat        - export as static methods of target
  options.proto       - export as prototype methods of target
  options.real        - real prototype method for the `pure` version
  options.forced      - export even if the native feature is available
  options.bind        - bind methods to the target, required for the `pure` version
  options.wrap        - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe      - use the simple assignment of property instead of delete + defineProperty
  options.sham        - add a flag to not completely full polyfills
  options.enumerable  - export as enumerable property
  options.noTargetGet - prevent calling a getter on target
*/
var _export = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global_1;
  } else if (STATIC) {
    target = global_1[TARGET] || setGlobal(TARGET, {});
  } else {
    target = (global_1[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.noTargetGet) {
      descriptor = getOwnPropertyDescriptor$1(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced_1(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty === typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    // extend global
    redefine(target, key, sourceProperty, options);
  }
};

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
var objectKeys = Object.keys || function keys(O) {
  return objectKeysInternal(O, enumBugKeys);
};

// eslint-disable-next-line es/no-object-assign -- safe
var $assign = Object.assign;
// eslint-disable-next-line es/no-object-defineproperty -- required for testing
var defineProperty$1 = Object.defineProperty;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
var objectAssign = !$assign || fails(function () {
  // should have correct order of operations (Edge bug)
  if (descriptors && $assign({ b: 1 }, $assign(defineProperty$1({}, 'a', {
    enumerable: true,
    get: function () {
      defineProperty$1(this, 'b', {
        value: 3,
        enumerable: false
      });
    }
  }), { b: 2 })).b !== 1) return true;
  // should work with symbols and should have deterministic property order (V8 bug)
  var A = {};
  var B = {};
  // eslint-disable-next-line es/no-symbol -- safe
  var symbol = Symbol();
  var alphabet = 'abcdefghijklmnopqrst';
  A[symbol] = 7;
  alphabet.split('').forEach(function (chr) { B[chr] = chr; });
  return $assign({}, A)[symbol] != 7 || objectKeys($assign({}, B)).join('') != alphabet;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars -- required for `.length`
  var T = toObject(target);
  var argumentsLength = arguments.length;
  var index = 1;
  var getOwnPropertySymbols = objectGetOwnPropertySymbols.f;
  var propertyIsEnumerable = objectPropertyIsEnumerable.f;
  while (argumentsLength > index) {
    var S = indexedObject(arguments[index++]);
    var keys = getOwnPropertySymbols ? objectKeys(S).concat(getOwnPropertySymbols(S)) : objectKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!descriptors || propertyIsEnumerable.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;

// `Object.assign` method
// https://tc39.es/ecma262/#sec-object.assign
// eslint-disable-next-line es/no-object-assign -- required for testing
_export({ target: 'Object', stat: true, forced: Object.assign !== objectAssign }, {
  assign: objectAssign
});

var quot = /"/g;

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
var createHtml = function (string, tag, attribute, value) {
  var S = String(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
var stringHtmlForced = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
_export({ target: 'String', proto: true, forced: stringHtmlForced('link') }, {
  link: function link(url) {
    return createHtml(this, 'a', 'href', url);
  }
});

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var withStyling = function withStyling(Component) {
  return /*#__PURE__*/function (_React$Component) {
    _inherits(WithStyling, _React$Component);

    var _super = _createSuper(WithStyling);

    function WithStyling(props) {
      var _this;

      _classCallCheck(this, WithStyling);

      _this = _super.call(this, props);
      _this.state = {
        styleUtil: new StylingOverrideUtil(props.propStyles)
      };
      return _this;
    }

    _createClass(WithStyling, [{
      key: "render",
      value: function render() {
        var _a = this.props,
            propStyles = _a.propStyles,
            rest = __rest(_a, ["propStyles"]);

        return jsx(Component, Object.assign({}, rest, {
          styling: this.state.styleUtil
        }), void 0);
      }
    }]);

    return WithStyling;
  }(React.Component);
};

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
var isArray = Array.isArray || function isArray(arg) {
  return classofRaw(arg) == 'Array';
};

var createProperty = function (object, key, value) {
  var propertyKey = toPrimitive(key);
  if (propertyKey in object) objectDefineProperty.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};

var engineUserAgent = getBuiltIn('navigator', 'userAgent') || '';

var process = global_1.process;
var versions = process && process.versions;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  version = match[0] < 4 ? 1 : match[0] + match[1];
} else if (engineUserAgent) {
  match = engineUserAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = engineUserAgent.match(/Chrome\/(\d+)/);
    if (match) version = match[1];
  }
}

var engineV8Version = version && +version;

/* eslint-disable es/no-symbol -- required for testing */



// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
var nativeSymbol = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol();
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  return !String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && engineV8Version && engineV8Version < 41;
});

/* eslint-disable es/no-symbol -- required for testing */


var useSymbolAsUid = nativeSymbol
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';

var WellKnownSymbolsStore = shared('wks');
var Symbol$1 = global_1.Symbol;
var createWellKnownSymbol = useSymbolAsUid ? Symbol$1 : Symbol$1 && Symbol$1.withoutSetter || uid;

var wellKnownSymbol = function (name) {
  if (!has(WellKnownSymbolsStore, name) || !(nativeSymbol || typeof WellKnownSymbolsStore[name] == 'string')) {
    if (nativeSymbol && has(Symbol$1, name)) {
      WellKnownSymbolsStore[name] = Symbol$1[name];
    } else {
      WellKnownSymbolsStore[name] = createWellKnownSymbol('Symbol.' + name);
    }
  } return WellKnownSymbolsStore[name];
};

var SPECIES = wellKnownSymbol('species');

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
var arraySpeciesCreate = function (originalArray, length) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return new (C === undefined ? Array : C)(length === 0 ? 0 : length);
};

var SPECIES$1 = wellKnownSymbol('species');

var arrayMethodHasSpeciesSupport = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return engineV8Version >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES$1] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_INDEX_EXCEEDED = 'Maximum allowed index exceeded';

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = engineV8Version >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('concat');

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !SPECIES_SUPPORT;

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
_export({ target: 'Array', proto: true, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = toLength(E.length);
        if (n + len > MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        if (n >= MAX_SAFE_INTEGER) throw TypeError(MAXIMUM_ALLOWED_INDEX_EXCEEDED);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});

var aFunction$1 = function (it) {
  if (typeof it != 'function') {
    throw TypeError(String(it) + ' is not a function');
  } return it;
};

// optional / simple context binding
var functionBindContext = function (fn, that, length) {
  aFunction$1(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 0: return function () {
      return fn.call(that);
    };
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};

var push = [].push;

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterOut }` methods implementation
var createMethod$1 = function (TYPE) {
  var IS_MAP = TYPE == 1;
  var IS_FILTER = TYPE == 2;
  var IS_SOME = TYPE == 3;
  var IS_EVERY = TYPE == 4;
  var IS_FIND_INDEX = TYPE == 6;
  var IS_FILTER_OUT = TYPE == 7;
  var NO_HOLES = TYPE == 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = indexedObject(O);
    var boundFunction = functionBindContext(callbackfn, that, 3);
    var length = toLength(self.length);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_OUT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push.call(target, value); // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push.call(target, value); // filterOut
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

var arrayIteration = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod$1(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod$1(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod$1(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod$1(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod$1(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod$1(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod$1(6),
  // `Array.prototype.filterOut` method
  // https://github.com/tc39/proposal-array-filtering
  filterOut: createMethod$1(7)
};

var $filter = arrayIteration.filter;


var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var arrayMethodIsStrict = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call,no-throw-literal -- required for testing
    method.call(null, argument || function () { throw 1; }, 1);
  });
};

var $forEach = arrayIteration.forEach;


var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
var arrayForEach = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;

// `Array.prototype.forEach` method
// https://tc39.es/ecma262/#sec-array.prototype.foreach
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
_export({ target: 'Array', proto: true, forced: [].forEach != arrayForEach }, {
  forEach: arrayForEach
});

/* eslint-disable es/no-array-prototype-indexof -- required for testing */

var $indexOf = arrayIncludes.indexOf;


var nativeIndexOf = [].indexOf;

var NEGATIVE_ZERO = !!nativeIndexOf && 1 / [1].indexOf(1, -0) < 0;
var STRICT_METHOD$1 = arrayMethodIsStrict('indexOf');

// `Array.prototype.indexOf` method
// https://tc39.es/ecma262/#sec-array.prototype.indexof
_export({ target: 'Array', proto: true, forced: NEGATIVE_ZERO || !STRICT_METHOD$1 }, {
  indexOf: function indexOf(searchElement /* , fromIndex = 0 */) {
    return NEGATIVE_ZERO
      // convert -0 to +0
      ? nativeIndexOf.apply(this, arguments) || 0
      : $indexOf(this, searchElement, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var nativeJoin = [].join;

var ES3_STRINGS = indexedObject != Object;
var STRICT_METHOD$2 = arrayMethodIsStrict('join', ',');

// `Array.prototype.join` method
// https://tc39.es/ecma262/#sec-array.prototype.join
_export({ target: 'Array', proto: true, forced: ES3_STRINGS || !STRICT_METHOD$2 }, {
  join: function join(separator) {
    return nativeJoin.call(toIndexedObject(this), separator === undefined ? ',' : separator);
  }
});

// `Array.prototype.{ reduce, reduceRight }` methods implementation
var createMethod$2 = function (IS_RIGHT) {
  return function (that, callbackfn, argumentsLength, memo) {
    aFunction$1(callbackfn);
    var O = toObject(that);
    var self = indexedObject(O);
    var length = toLength(O.length);
    var index = IS_RIGHT ? length - 1 : 0;
    var i = IS_RIGHT ? -1 : 1;
    if (argumentsLength < 2) while (true) {
      if (index in self) {
        memo = self[index];
        index += i;
        break;
      }
      index += i;
      if (IS_RIGHT ? index < 0 : length <= index) {
        throw TypeError('Reduce of empty array with no initial value');
      }
    }
    for (;IS_RIGHT ? index >= 0 : length > index; index += i) if (index in self) {
      memo = callbackfn(memo, self[index], index, O);
    }
    return memo;
  };
};

var arrayReduce = {
  // `Array.prototype.reduce` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduce
  left: createMethod$2(false),
  // `Array.prototype.reduceRight` method
  // https://tc39.es/ecma262/#sec-array.prototype.reduceright
  right: createMethod$2(true)
};

var engineIsNode = classofRaw(global_1.process) == 'process';

var $reduce = arrayReduce.left;




var STRICT_METHOD$3 = arrayMethodIsStrict('reduce');
// Chrome 80-82 has a critical bug
// https://bugs.chromium.org/p/chromium/issues/detail?id=1049982
var CHROME_BUG = !engineIsNode && engineV8Version > 79 && engineV8Version < 83;

// `Array.prototype.reduce` method
// https://tc39.es/ecma262/#sec-array.prototype.reduce
_export({ target: 'Array', proto: true, forced: !STRICT_METHOD$3 || CHROME_BUG }, {
  reduce: function reduce(callbackfn /* , initialValue */) {
    return $reduce(this, callbackfn, arguments.length, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var FAILS_ON_PRIMITIVES = fails(function () { objectKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
_export({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return objectKeys(toObject(it));
  }
});

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
var regexpFlags = function () {
  var that = anObject(this);
  var result = '';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.sticky) result += 'y';
  return result;
};

// babel-minify transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError,
var RE = function (s, f) {
  return RegExp(s, f);
};

var UNSUPPORTED_Y = fails(function () {
  var re = RE('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') != null;
});

var BROKEN_CARET = fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = RE('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') != null;
});

var regexpStickyHelpers = {
	UNSUPPORTED_Y: UNSUPPORTED_Y,
	BROKEN_CARET: BROKEN_CARET
};

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
var objectDefineProperties = descriptors ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) objectDefineProperty.f(O, key = keys[index++], Properties[key]);
  return O;
};

var html = getBuiltIn('document', 'documentElement');

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    /* global ActiveXObject -- old IE */
    activeXDocument = document.domain && new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = activeXDocument ? NullProtoObjectViaActiveX(activeXDocument) : NullProtoObjectViaIFrame();
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
var objectCreate = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : objectDefineProperties(result, Properties);
};

var regexpUnsupportedDotAll = fails(function () {
  // babel-minify transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
  var re = RegExp('.', (typeof '').charAt(0));
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});

var regexpUnsupportedNcg = fails(function () {
  // babel-minify transpiles RegExp('.', 'g') -> /./g and it causes SyntaxError
  var re = RegExp('(?<a>b)', (typeof '').charAt(5));
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});

/* eslint-disable regexp/no-assertion-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */




var getInternalState = internalState.get;



var nativeExec = RegExp.prototype.exec;
var nativeReplace = shared('native-string-replace', String.prototype.replace);

var patchedExec = nativeExec;

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  nativeExec.call(re1, 'a');
  nativeExec.call(re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y$1 = regexpStickyHelpers.UNSUPPORTED_Y || regexpStickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y$1 || regexpUnsupportedDotAll || regexpUnsupportedNcg;

if (PATCH) {
  // eslint-disable-next-line max-statements -- TODO
  patchedExec = function exec(str) {
    var re = this;
    var state = getInternalState(re);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = patchedExec.call(raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y$1 && re.sticky;
    var flags = regexpFlags.call(re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = flags.replace('y', '');
      if (flags.indexOf('g') === -1) {
        flags += 'g';
      }

      strCopy = String(str).slice(re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && str[re.lastIndex - 1] !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = nativeExec.call(sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = match.input.slice(charsAdded);
        match[0] = match[0].slice(charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn' work for /(.?)?/
      nativeReplace.call(match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = objectCreate(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

var regexpExec = patchedExec;

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
_export({ target: 'RegExp', proto: true, forced: /./.exec !== regexpExec }, {
  exec: regexpExec
});

// TODO: Remove from `core-js@4` since it's moved to entry points







var SPECIES$2 = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

var fixRegexpWellKnownSymbolLogic = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) != 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES$2] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var nativeRegExpMethod = /./[SYMBOL];
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: nativeRegExpMethod.call(regexp, str, arg2) };
        }
        return { done: true, value: nativeMethod.call(str, regexp, arg2) };
      }
      return { done: false };
    });

    redefine(String.prototype, KEY, methods[0]);
    redefine(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
var isRegexp = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classofRaw(it) == 'RegExp');
};

var SPECIES$3 = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
var speciesConstructor = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || (S = anObject(C)[SPECIES$3]) == undefined ? defaultConstructor : aFunction$1(S);
};

// `String.prototype.{ codePointAt, at }` methods implementation
var createMethod$3 = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = String(requireObjectCoercible($this));
    var position = toInteger(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = S.charCodeAt(position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = S.charCodeAt(position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING ? S.charAt(position) : first
        : CONVERT_TO_STRING ? S.slice(position, position + 2) : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

var stringMultibyte = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod$3(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod$3(true)
};

var charAt = stringMultibyte.charAt;

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
var advanceStringIndex = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
var regexpExecAbstract = function (R, S) {
  var exec = R.exec;
  if (typeof exec === 'function') {
    var result = exec.call(R, S);
    if (typeof result !== 'object') {
      throw TypeError('RegExp exec method returned something other than an Object or null');
    }
    return result;
  }

  if (classofRaw(R) !== 'RegExp') {
    throw TypeError('RegExp#exec called on incompatible receiver');
  }

  return regexpExec.call(R, S);
};

var UNSUPPORTED_Y$2 = regexpStickyHelpers.UNSUPPORTED_Y;
var arrayPush = [].push;
var min$2 = Math.min;
var MAX_UINT32 = 0xFFFFFFFF;

// Chrome 51 has a buggy "split" implementation when RegExp#exec !== nativeExec
// Weex JS has frozen built-in prototypes, so use try / catch wrapper
var SPLIT_WORKS_WITH_OVERWRITTEN_EXEC = !fails(function () {
  // eslint-disable-next-line regexp/no-empty-group -- required for testing
  var re = /(?:)/;
  var originalExec = re.exec;
  re.exec = function () { return originalExec.apply(this, arguments); };
  var result = 'ab'.split(re);
  return result.length !== 2 || result[0] !== 'a' || result[1] !== 'b';
});

// @@split logic
fixRegexpWellKnownSymbolLogic('split', function (SPLIT, nativeSplit, maybeCallNative) {
  var internalSplit;
  if (
    'abbc'.split(/(b)*/)[1] == 'c' ||
    // eslint-disable-next-line regexp/no-empty-group -- required for testing
    'test'.split(/(?:)/, -1).length != 4 ||
    'ab'.split(/(?:ab)*/).length != 2 ||
    '.'.split(/(.?)(.?)/).length != 4 ||
    // eslint-disable-next-line regexp/no-assertion-capturing-group, regexp/no-empty-group -- required for testing
    '.'.split(/()()/).length > 1 ||
    ''.split(/.?/).length
  ) {
    // based on es5-shim implementation, need to rework it
    internalSplit = function (separator, limit) {
      var string = String(requireObjectCoercible(this));
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (separator === undefined) return [string];
      // If `separator` is not a regex, use native split
      if (!isRegexp(separator)) {
        return nativeSplit.call(string, separator, lim);
      }
      var output = [];
      var flags = (separator.ignoreCase ? 'i' : '') +
                  (separator.multiline ? 'm' : '') +
                  (separator.unicode ? 'u' : '') +
                  (separator.sticky ? 'y' : '');
      var lastLastIndex = 0;
      // Make `global` and avoid `lastIndex` issues by working with a copy
      var separatorCopy = new RegExp(separator.source, flags + 'g');
      var match, lastIndex, lastLength;
      while (match = regexpExec.call(separatorCopy, string)) {
        lastIndex = separatorCopy.lastIndex;
        if (lastIndex > lastLastIndex) {
          output.push(string.slice(lastLastIndex, match.index));
          if (match.length > 1 && match.index < string.length) arrayPush.apply(output, match.slice(1));
          lastLength = match[0].length;
          lastLastIndex = lastIndex;
          if (output.length >= lim) break;
        }
        if (separatorCopy.lastIndex === match.index) separatorCopy.lastIndex++; // Avoid an infinite loop
      }
      if (lastLastIndex === string.length) {
        if (lastLength || !separatorCopy.test('')) output.push('');
      } else output.push(string.slice(lastLastIndex));
      return output.length > lim ? output.slice(0, lim) : output;
    };
  // Chakra, V8
  } else if ('0'.split(undefined, 0).length) {
    internalSplit = function (separator, limit) {
      return separator === undefined && limit === 0 ? [] : nativeSplit.call(this, separator, limit);
    };
  } else internalSplit = nativeSplit;

  return [
    // `String.prototype.split` method
    // https://tc39.es/ecma262/#sec-string.prototype.split
    function split(separator, limit) {
      var O = requireObjectCoercible(this);
      var splitter = separator == undefined ? undefined : separator[SPLIT];
      return splitter !== undefined
        ? splitter.call(separator, O, limit)
        : internalSplit.call(String(O), separator, limit);
    },
    // `RegExp.prototype[@@split]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@split
    //
    // NOTE: This cannot be properly polyfilled in engines that don't support
    // the 'y' flag.
    function (string, limit) {
      var res = maybeCallNative(internalSplit, this, string, limit, internalSplit !== nativeSplit);
      if (res.done) return res.value;

      var rx = anObject(this);
      var S = String(string);
      var C = speciesConstructor(rx, RegExp);

      var unicodeMatching = rx.unicode;
      var flags = (rx.ignoreCase ? 'i' : '') +
                  (rx.multiline ? 'm' : '') +
                  (rx.unicode ? 'u' : '') +
                  (UNSUPPORTED_Y$2 ? 'g' : 'y');

      // ^(? + rx + ) is needed, in combination with some S slicing, to
      // simulate the 'y' flag.
      var splitter = new C(UNSUPPORTED_Y$2 ? '^(?:' + rx.source + ')' : rx, flags);
      var lim = limit === undefined ? MAX_UINT32 : limit >>> 0;
      if (lim === 0) return [];
      if (S.length === 0) return regexpExecAbstract(splitter, S) === null ? [S] : [];
      var p = 0;
      var q = 0;
      var A = [];
      while (q < S.length) {
        splitter.lastIndex = UNSUPPORTED_Y$2 ? 0 : q;
        var z = regexpExecAbstract(splitter, UNSUPPORTED_Y$2 ? S.slice(q) : S);
        var e;
        if (
          z === null ||
          (e = min$2(toLength(splitter.lastIndex + (UNSUPPORTED_Y$2 ? q : 0)), S.length)) === p
        ) {
          q = advanceStringIndex(S, q, unicodeMatching);
        } else {
          A.push(S.slice(p, q));
          if (A.length === lim) return A;
          for (var i = 1; i <= z.length - 1; i++) {
            A.push(z[i]);
            if (A.length === lim) return A;
          }
          q = p = e;
        }
      }
      A.push(S.slice(p));
      return A;
    }
  ];
}, !SPLIT_WORKS_WITH_OVERWRITTEN_EXEC, UNSUPPORTED_Y$2);

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
var domIterables = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};

for (var COLLECTION_NAME in domIterables) {
  var Collection = global_1[COLLECTION_NAME];
  var CollectionPrototype = Collection && Collection.prototype;
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== arrayForEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', arrayForEach);
  } catch (error) {
    CollectionPrototype.forEach = arrayForEach;
  }
}

var StylingOverrideUtil = /*#__PURE__*/function () {
  function StylingOverrideUtil(propsStyle) {
    _classCallCheck(this, StylingOverrideUtil);

    this.propsStyle = propsStyle;
  }

  _createClass(StylingOverrideUtil, [{
    key: "getStyle",
    value: function getStyle(moduleStyle, name) {
      if (!this.propsStyle) {
        return moduleStyle[name];
      }

      if (!this.mergedStyles) {
        this.mergedStyles = this.merge(this.propsStyle, moduleStyle);
      }

      return this.mergedStyles[name];
    }
  }, {
    key: "merge",
    value: function merge(original, newStyle) {
      var _this = this;

      // make a copy to avoid mutations of nested objects
      // also strip all functions injected by isomorphic-style-loader
      var result = Object.keys(original).reduce(function (acc, key) {
        var value = original[key];

        if (typeof value !== 'function') {
          acc[key] = value;
        }

        return acc;
      }, {}); // traverse mixin keys and merge them to resulting theme

      Object.keys(newStyle).forEach(function (key) {
        // there's no need to set any defaults here
        var originalValue = result[key];
        var mixinValue = newStyle[key];

        switch (typeof mixinValue) {
          case 'object':
            {
              // possibly nested theme object
              switch (typeof originalValue) {
                case 'object':
                  {
                    // exactly nested theme object - go recursive
                    result[key] = _this.merge(originalValue, mixinValue);
                    break;
                  }

                case 'undefined':
                  {
                    // original does not contain this nested key - just take it as is
                    result[key] = mixinValue;
                    break;
                  }

                default:
                  {
                    // can't merge an object with a non-object
                    throw new Error("You are merging object ".concat(key, " with a non-object ").concat(originalValue));
                  }
              }

              break;
            }

          case 'undefined': // fallthrough - handles accidentally unset values which may come from props

          case 'function':
            {
              // this handles issue when isomorphic-style-loader addes helper functions to css-module
              break; // just skip
            }

          default:
            {
              // plain values
              switch (typeof originalValue) {
                case 'object':
                  {
                    // can't merge a non-object with an object
                    throw new Error("You are merging non-object ".concat(mixinValue, " with an object ").concat(key));
                  }

                case 'undefined':
                  {
                    // mixin key is new to original theme - take it as is
                    result[key] = mixinValue;
                    break;
                  }

                case 'function':
                  {
                    // this handles issue when isomorphic-style-loader addes helper functions to css-module
                    break; // just skip
                  }

                default:
                  {
                    // finally we can merge
                    result[key] = originalValue.split(' ').concat(mixinValue.split(' ')).filter(function (item, pos, self) {
                      return self.indexOf(item) === pos && item !== '';
                    }).join(' ');
                  }
              }
            }
        }
      });
      return result;
    }
  }]);

  return StylingOverrideUtil;
}();

var styles = {"buttonBase":"button-base-module_buttonBase__1Nd1_","sizeSmall":"button-base-module_sizeSmall__5ZuTL","sizeBig":"button-base-module_sizeBig__2qMKQ","loading":"button-base-module_loading__tjSNb","squared":"button-base-module_squared__XEst-","fullWidth":"button-base-module_fullWidth__yLJET","tooltip":"button-base-module_tooltip__2wvaQ"};

var component = function component(props) {
  var children = props.children,
      fullWidth = props.fullWidth,
      link = props.link,
      _props$size = props.size,
      size = _props$size === void 0 ? props.size || 'medium' : _props$size,
      squared = props.squared,
      _props$type = props.type,
      type = _props$type === void 0 ? props.type || 'button' : _props$type,
      disabled = props.disabled,
      disableNoreferrer = props.disableNoreferrer,
      linkTarget = props.linkTarget,
      loading = props.loading,
      className = props.className,
      tooltip = props.tooltip,
      tooltipPlace = props.tooltipPlace,
      borderRadius = props.borderRadius,
      name = props.name,
      ariaLabel = props.ariaLabel,
      isNextJsLink = props.isNextJsLink,
      rest = __rest(props, ["children", "fullWidth", "link", "size", "squared", "type", "disabled", "disableNoreferrer", "linkTarget", "loading", "className", "tooltip", "tooltipPlace", "borderRadius", "name", "ariaLabel", "isNextJsLink"]);

  var classNames = clsx(props.styling.getStyle(styles, 'buttonBase'), className, size !== 'medium' && props.styling.getStyle(styles, "size".concat(capitalize(size))), fullWidth && props.styling.getStyle(styles, 'fullWidth'), squared && props.styling.getStyle(styles, 'squared'), loading && props.styling.getStyle(styles, 'loading'));

  var renderLink = function renderLink() {
    var extraLinkProperties = getExternalLinkProperties(link, disableNoreferrer, linkTarget);
    var anchorProps = Object.assign(Object.assign(Object.assign({
      children: children,
      className: classNames,
      'data-tip': tooltip
    }, extraLinkProperties), rest), {
      styling: undefined
    });
    var elementIsNextJsLink = link && isNextJsLink && link.type !== 'a';

    if (!link) {
      return jsx(Fragment, {}, void 0);
    }

    return jsx(Fragment, {
      children: elementIsNextJsLink ? /*#__PURE__*/React.cloneElement(link, {
        children: jsx("a", Object.assign({}, anchorProps), void 0)
      }) : /*#__PURE__*/React.cloneElement(link, anchorProps)
    }, void 0);
  };

  var renderButton = function renderButton() {
    var restWithoutStyling = Object.assign(Object.assign({}, rest), {
      styling: undefined
    });
    return (// eslint-disable-next-line react/button-has-type
      jsx("button", Object.assign({
        disabled: disabled,
        "aria-disabled": disabled,
        type: type,
        className: classNames,
        onClick: props.onClick,
        tabIndex: props.tabIndex,
        "data-tip": tooltip,
        style: {
          borderRadius: borderRadius
        },
        name: name,
        "aria-label": props.ariaLabel
      }, restWithoutStyling, {
        children: children
      }), void 0)
    );
  };

  return jsx(Fragment, {
    children: tooltip && disabled ? jsxs("span", Object.assign({
      "data-tip": tooltip
    }, {
      children: [link ? renderLink() : renderButton(), tooltip && jsx(ReactTooltip, {
        place: tooltipPlace,
        effect: "solid",
        multiline: true
      }, void 0)]
    }), void 0) : jsxs(Fragment, {
      children: [link ? renderLink() : renderButton(), tooltip && jsx(ReactTooltip, {
        place: tooltipPlace,
        effect: "solid",
        multiline: true
      }, void 0)]
    }, void 0)
  }, void 0);
};

var getExternalLinkProperties = function getExternalLinkProperties(link, disableNoreferrer, linkTarget) {
  if (link && link.type === 'a') {
    var noReferrerProps = Object.assign({}, !disableNoreferrer && {
      rel: 'noreferrer noopener'
    });
    var linkTargetProps = Object.assign({}, linkTarget && {
      target: linkTarget
    });
    return Object.assign(Object.assign({}, noReferrerProps), linkTargetProps);
  }

  return {};
};

var ButtonBase = withStyling(component);

var styles$1 = {"border":"border-module_border__OCeSi"};

var component$1 = function component(props) {
  return jsx("div", Object.assign({
    className: props.styling.getStyle(styles$1, 'border'),
    style: {
      borderColor: "".concat(props.borderColor),
      borderRadius: "".concat(props.borderRadius),
      borderWidth: "".concat(props.borderWidth),
      borderStyle: "".concat(props.borderStyle),
      borderTop: "".concat(props.borderTop),
      borderRight: "".concat(props.borderRight),
      borderBottom: "".concat(props.borderBottom),
      borderLeft: "".concat(props.borderLeft),
      border: "".concat(props.borderBorder),
      boxShadow: "".concat(props.borderShadow)
    }
  }, {
    children: props.children
  }), void 0);
};

var Border = withStyling(component$1);

var styles$2 = {"textAreaInput":"text-area-module_textAreaInput__27mLa","delete":"text-area-module_delete__1PxZj","error":"text-area-module_error__32dx6","readOnly":"text-area-module_readOnly__2lBYS","disabled":"text-area-module_disabled__OnVtn","withIconLeft":"text-area-module_withIconLeft__3kBgg","withIconRight":"text-area-module_withIconRight__1D6Tm","icon":"text-area-module_icon__3BMSp","iconRight":"text-area-module_iconRight__1Fe6B"};

var component$2 = function component(props) {
  var _props$iconPosition = props.iconPosition,
      iconPosition = _props$iconPosition === void 0 ? 'left' : _props$iconPosition;
  var inputClassnames = clsx(props.isInvalid && props.styling.getStyle(styles$2, 'error'), props.readOnly && props.styling.getStyle(styles$2, 'readOnly'), props.disabled && props.styling.getStyle(styles$2, 'disabled'), props.icon && (iconPosition === 'left' ? props.styling.getStyle(styles$2, 'withIconLeft') : props.styling.getStyle(styles$2, 'withIconRight')));
  var inputWrapperClassnames = clsx(props.styling.getStyle(styles$2, 'textAreaInput'));
  var iconClassNames = clsx(props.styling.getStyle(styles$2, 'icon'), iconPosition === 'right' && props.styling.getStyle(styles$2, 'iconRight'));
  return jsxs("div", Object.assign({
    className: inputWrapperClassnames
  }, {
    children: [jsx("textarea", {
      className: inputClassnames,
      rows: props.rows,
      "aria-label": props.ariaLabel,
      name: props.id,
      id: props.id,
      onChange: props.onChange,
      value: props.value,
      placeholder: props.placeholder || '',
      disabled: props.disabled,
      readOnly: props.readOnly,
      onBlur: props.onBlur,
      onFocus: props.onFocus,
      maxLength: props.maxLength
    }, void 0), props.icon && jsx("span", Object.assign({
      className: iconClassNames
    }, {
      children: props.icon
    }), void 0), props.deleteIcon && props.value && jsx("span", Object.assign({
      role: "button",
      className: props.styling.getStyle(styles$2, 'delete'),
      onClick: props.onDelete
    }, {
      children: props.deleteIcon
    }), void 0)]
  }), void 0);
};

var TextArea = withStyling(component$2);

var styles$3 = {"textFieldInput":"text-field-module_textFieldInput__2gn0H","delete":"text-field-module_delete__gn_vy","length":"text-field-module_length__Ewv7n","error":"text-field-module_error__2G53Q","readOnly":"text-field-module_readOnly__3qQgC","disabled":"text-field-module_disabled__yhD_m","withIconLeft":"text-field-module_withIconLeft__SvUHj","withIconRight":"text-field-module_withIconRight__h1ah8","showLengthInput":"text-field-module_showLengthInput__zSf41","icon":"text-field-module_icon__Y9UR-","iconRight":"text-field-module_iconRight__3WuXa"};

var component$3 = function component(_a) {
  var _b;

  var ariaLabel = _a.ariaLabel,
      icon = _a.icon,
      _a$iconPosition = _a.iconPosition,
      iconPosition = _a$iconPosition === void 0 ? 'left' : _a$iconPosition,
      isInvalid = _a.isInvalid,
      showLength = _a.showLength,
      styling = _a.styling,
      wrapperClassName = _a.wrapperClassName,
      iconClassName = _a.iconClassName,
      deleteIcon = _a.deleteIcon,
      onDelete = _a.onDelete,
      css = _a.css,
      inputElementProps = __rest(_a, ["ariaLabel", "icon", "iconPosition", "isInvalid", "showLength", "styling", "wrapperClassName", "iconClassName", "deleteIcon", "onDelete", "css"]);

  var inputClassNames = clsx(isInvalid && styling.getStyle(styles$3, 'error'), inputElementProps.readOnly && styling.getStyle(styles$3, 'readOnly'), inputElementProps.disabled && styling.getStyle(styles$3, 'disabled'), icon && (iconPosition === 'left' ? styling.getStyle(styles$3, 'withIconLeft') : styling.getStyle(styles$3, 'withIconRight')), showLength && styling.getStyle(styles$3, 'showLengthInput'), inputElementProps.className);
  var inputWrapperClassNames = clsx(styling.getStyle(styles$3, 'textFieldInput'), wrapperClassName);
  var iconClassNames = clsx(styling.getStyle(styles$3, 'icon'), iconPosition === 'right' && styling.getStyle(styles$3, 'iconRight'), iconClassName);
  return jsxs("div", Object.assign({
    className: inputWrapperClassNames
  }, {
    children: [jsx("input", Object.assign({}, inputElementProps, {
      "aria-label": ariaLabel || inputElementProps['aria-label'],
      className: inputClassNames
    }), void 0), icon && jsx("span", Object.assign({
      className: iconClassNames
    }, {
      children: icon
    }), void 0), deleteIcon && inputElementProps.value && jsx("span", Object.assign({
      role: "button",
      className: styling.getStyle(styles$3, 'delete'),
      onClick: onDelete
    }, {
      children: deleteIcon
    }), void 0), showLength && inputElementProps.value && jsx("span", Object.assign({
      className: styling.getStyle(styles$3, 'length')
    }, {
      children: (_b = String(inputElementProps.value)) === null || _b === void 0 ? void 0 : _b.length
    }), void 0)]
  }), void 0);
};

var TextField = withStyling(component$3);

var styles$4 = {"container":"container-module_container__1FRM2"};

var component$4 = function component(props) {
  return jsx("div", Object.assign({
    className: props.styling.getStyle(styles$4, 'container')
  }, {
    children: props.children
  }), void 0);
};

var Container = withStyling(component$4);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] == undefined) {
  objectDefineProperty.f(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: objectCreate(null)
  });
}

// add a key to Array.prototype[@@unscopables]
var addToUnscopables = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};

var $findIndex = arrayIteration.findIndex;


var FIND_INDEX = 'findIndex';
var SKIPS_HOLES = true;

// Shouldn't skip holes
if (FIND_INDEX in []) Array(1)[FIND_INDEX](function () { SKIPS_HOLES = false; });

// `Array.prototype.findIndex` method
// https://tc39.es/ecma262/#sec-array.prototype.findindex
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  findIndex: function findIndex(callbackfn /* , that = undefined */) {
    return $findIndex(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND_INDEX);

var $map = arrayIteration.map;


var HAS_SPECIES_SUPPORT$1 = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$1 }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

var slice = [].slice;
var MSIE = /MSIE .\./.test(engineUserAgent); // <- dirty ie9- check

var wrap = function (scheduler) {
  return function (handler, timeout /* , ...arguments */) {
    var boundArgs = arguments.length > 2;
    var args = boundArgs ? slice.call(arguments, 2) : undefined;
    return scheduler(boundArgs ? function () {
      // eslint-disable-next-line no-new-func -- spec requirement
      (typeof handler == 'function' ? handler : Function(handler)).apply(this, args);
    } : handler, timeout);
  };
};

// ie9- setTimeout & setInterval additional parameters fix
// https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#timers
_export({ global: true, bind: true, forced: MSIE }, {
  // `setTimeout` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-settimeout
  setTimeout: wrap(global_1.setTimeout),
  // `setInterval` method
  // https://html.spec.whatwg.org/multipage/timers-and-user-prompts.html#dom-setinterval
  setInterval: wrap(global_1.setInterval)
});

var styles$5 = {"popperButton":"popper-module_popperButton__3kNCE"};

var component$5 = function component(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      updatePopper = _useState2[0],
      setUpdatePopper = _useState2[1];

  var _children = props.children,
      toggleButton = props.toggleButton,
      toggleButtonFullWidth = props.toggleButtonFullWidth,
      placementOffset = props.placementOffset,
      zIndex = props.zIndex;
  useEffect(function () {
    setUpdatePopper(!updatePopper);
  }, [props.updatePopper]);
  return jsxs(Manager, {
    children: [jsx(Reference, {
      children: function children(_ref) {
        var ref = _ref.ref;
        return jsx("div", Object.assign({
          className: props.styling.getStyle(styles$5, 'popperButton'),
          ref: ref,
          style: {
            width: toggleButtonFullWidth ? '100%' : 'initial'
          }
        }, {
          children: toggleButton
        }), void 0);
      }
    }, void 0), props.isOpen && jsx(Popper$1, Object.assign({
      placement: props.placement || 'bottom-start',
      modifiers: [{
        name: 'preventOverflow',
        enabled: false
      }, {
        name: 'hide',
        enabled: false
      }, {
        name: 'offset',
        options: {
          offset: placementOffset || [0, 0]
        }
      }, {
        name: 'updatePopperOnPropertyChange',
        enabled: updatePopper,
        phase: 'afterRead'
      } // The property will change based on the updatePopper prop and will then update the popper.
      ]
    }, {
      children: function children(_ref2) {
        var placement = _ref2.placement,
            ref = _ref2.ref,
            style = _ref2.style;
        return jsx("div", Object.assign({
          ref: ref,
          style: Object.assign(Object.assign({}, style), zIndex && {
            zIndex: zIndex
          }),
          "data-placement": placement
        }, {
          children: _children
        }), void 0);
      }
    }), void 0)]
  }, void 0);
};

var Popper = withStyling(component$5);

var styles$6 = {"contextMenu":"context-menu-module_contextMenu__3Lzm1","body":"context-menu-module_body__3As3K","menuItem":"context-menu-module_menuItem__2_OdZ","icon":"context-menu-module_icon__19VmL","text":"context-menu-module_text__3tH26","arrow":"context-menu-module_arrow__1Pm1C","disabled":"context-menu-module_disabled__JQUmi","divider":"context-menu-module_divider__3MDS7","line":"context-menu-module_line__31RAp"};

var SUBMENU_SHOW_DELAY = 200;
var MENU_ITEM_POPPER_ID_NAME = 'contextMenuItem';

var DEFAULT_ARROW_SVG = jsx("svg", Object.assign({
  width: "4",
  height: "8",
  viewBox: "0 0 4 8",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: jsx("path", {
    d: "M0 0L7.03335e-06 8L4 4L0 0Z",
    fill: "black"
  }, void 0)
}), void 0);

var component$6 = function component(props) {
  var _useState = useState(props.isOpen || false),
      _useState2 = _slicedToArray(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      openMenuIds = _useState4[0],
      setOpenMenuIds = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      timerIds = _useState6[0],
      setTimerIds = _useState6[1];

  var wrapperRef = useRef(null);
  var clickable = props.toggleButton && /*#__PURE__*/React.cloneElement(props.toggleButton, {
    onClick: function onClick(e) {
      return onToggleButtonClick(e);
    }
  });
  var classNames = clsx(props.styling.getStyle(styles$6, 'contextMenu'));
  useEffect(function () {
    if (!isOpen) {
      setOpenMenuIds([]);
    }
  }, [isOpen]);
  useEffect(function () {
    setIsOpen(Boolean(props.isOpen));
  }, [props.isOpen]);
  useOutsideClick(wrapperRef, function () {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  var onToggleButtonClick = function onToggleButtonClick(event) {
    event.stopPropagation();
    setIsOpen(!isOpen);
  };

  var clearTimers = function clearTimers() {
    var ids = timerIds;

    while (ids.length) {
      clearTimeout(ids.pop());
    }

    setTimerIds([]);
  };

  var setIsHovering = function setIsHovering(id) {
    clearTimers();
    var findItem = openMenuIds.findIndex(function (openMenuId) {
      return openMenuId === id;
    });

    if (findItem === -1) {
      setOpenMenuIds(returnOpenMenuIds(id));
      var hoverItemId = setTimeout(function () {
        setOpenMenuIds([].concat(_toConsumableArray(returnOpenMenuIds(id)), [id]));
      }, SUBMENU_SHOW_DELAY);
      setTimerIds([].concat(_toConsumableArray(timerIds), [hoverItemId]));
    }
  };

  var unsetIsHovering = function unsetIsHovering() {
    clearTimers();
  };

  var returnOpenMenuIds = function returnOpenMenuIds(id) {
    var levelOfItem = id.split('-').length;
    return openMenuIds.filter(function (openMenuId) {
      return openMenuId.split('-').length !== levelOfItem && openMenuId.split('-').length < levelOfItem;
    });
  };

  var setRemainingOpenMenuIds = function setRemainingOpenMenuIds(id) {
    setOpenMenuIds(returnOpenMenuIds(id));
  };

  var handleClick = function handleClick(event, onClick, closeOnClick) {
    event.stopPropagation();
    onClick();

    if (closeOnClick) {
      setIsOpen(false);
    }
  };

  var handleKeyPress = function handleKeyPress(event, onClick, closeOnClick) {
    if (event.key === 'Enter') {
      onClick();

      if (closeOnClick) {
        setIsOpen(false);
      }
    }
  };

  var renderDefaultItem = function renderDefaultItem(id, text, onClick, icon, disabled, closeOnClick) {
    return jsxs("span", Object.assign({
      role: "button",
      className: clsx(props.styling.getStyle(styles$6, 'menuItem'), disabled && props.styling.getStyle(styles$6, 'disabled')),
      onMouseEnter: function onMouseEnter() {
        return setRemainingOpenMenuIds(id);
      },
      onMouseLeave: function onMouseLeave() {
        return unsetIsHovering();
      },
      onClick: onClick && function (e) {
        e.stopPropagation();

        if (!disabled) {
          handleClick(e, onClick, closeOnClick);
        }

        setIsOpen(false);
      },
      onKeyDown: onClick && function (e) {
        e.stopPropagation();

        if (!disabled) {
          handleKeyPress(e, onClick, closeOnClick);
        }
      },
      onFocus: function onFocus() {
        return setRemainingOpenMenuIds(id);
      },
      onBlur: function onBlur() {
        return unsetIsHovering();
      },
      tabIndex: 0
    }, {
      children: [icon && jsx("span", Object.assign({
        className: props.styling.getStyle(styles$6, 'icon')
      }, {
        children: icon
      }), void 0), text]
    }), id);
  };

  var renderItemWithChildren = function renderItemWithChildren(id, text, children, onClick, icon) {
    return jsx(Popper, Object.assign({
      id: "".concat(MENU_ITEM_POPPER_ID_NAME, "#").concat(id),
      zIndex: props.zIndex,
      toggleButton: jsxs("span", Object.assign({
        role: "button",
        className: props.styling.getStyle(styles$6, 'menuItem'),
        onMouseEnter: function onMouseEnter() {
          return setIsHovering("".concat(id));
        },
        onMouseLeave: function onMouseLeave() {
          return unsetIsHovering();
        },
        onClick: onClick && function (e) {
          return handleClick(e, onClick);
        },
        onKeyDown: onClick && function (e) {
          return handleKeyPress(e, onClick);
        },
        onFocus: function onFocus() {
          return setIsHovering("".concat(id));
        },
        onBlur: function onBlur() {
          return unsetIsHovering();
        },
        tabIndex: 0
      }, {
        children: [jsxs("span", Object.assign({
          className: props.styling.getStyle(styles$6, 'content')
        }, {
          children: [icon && jsx("span", Object.assign({
            className: props.styling.getStyle(styles$6, 'icon')
          }, {
            children: icon
          }), void 0), jsx("span", Object.assign({
            className: props.styling.getStyle(styles$6, 'text')
          }, {
            children: text
          }), void 0)]
        }), void 0), jsx("span", Object.assign({
          className: props.styling.getStyle(styles$6, 'arrow')
        }, {
          children: props.moreItemsIcon || DEFAULT_ARROW_SVG
        }), void 0)]
      }), void 0),
      toggleButtonFullWidth: true,
      isOpen: checkIsOpenMenu("".concat(id), openMenuIds),
      placement: "right-start"
    }, {
      children: jsx("div", Object.assign({
        className: props.styling.getStyle(styles$6, 'body')
      }, {
        children: children.map(function (childItem, index) {
          var itemId = "".concat(id, "-").concat(index);

          if (childItem.children) {
            return renderItemWithChildren(itemId, childItem.text, childItem.children, childItem.onClick, childItem.icon);
          }

          return renderDefaultItem(itemId, childItem.text, childItem.onClick, childItem.icon, childItem.disabled, childItem.closeOnClick);
        })
      }), void 0)
    }), id);
  };

  var renderDivider = function renderDivider(id, line, text) {
    return jsxs("span", Object.assign({
      className: props.styling.getStyle(styles$6, 'divider')
    }, {
      children: [line && jsx("span", {
        className: props.styling.getStyle(styles$6, 'line')
      }, void 0), text && jsx("span", Object.assign({
        className: props.styling.getStyle(styles$6, 'text')
      }, {
        children: text
      }), void 0)]
    }), id);
  };

  var renderAllItems = function renderAllItems() {
    var items = props.items.filter(Boolean);
    return items.map(function (menuItem, index) {
      var id = "".concat(index + 1);

      if (menuItem.type === 'listItem') {
        if (!menuItem.children) {
          return renderDefaultItem(id, menuItem.text, menuItem.onClick, menuItem.icon, menuItem.disabled, menuItem.closeOnClick);
        }

        return renderItemWithChildren(id, menuItem.text, menuItem.children, menuItem.onClick, menuItem.icon);
      }

      return renderDivider(id, menuItem.line, menuItem.text);
    });
  };

  return jsx("div", Object.assign({
    className: classNames
  }, {
    children: jsx(Popper, Object.assign({
      id: "contextMenu",
      toggleButton: clickable,
      isOpen: isOpen,
      zIndex: props.zIndex,
      placementOffset: props.placementOffset
    }, {
      children: jsx("div", Object.assign({
        className: props.styling.getStyle(styles$6, 'body'),
        ref: wrapperRef
      }, {
        children: renderAllItems()
      }), void 0)
    }), void 0)
  }), void 0);
};

var checkIsOpenMenu = function checkIsOpenMenu(id, openMenuIds) {
  if (!openMenuIds) return false;
  return openMenuIds.findIndex(function (openMenuId) {
    return openMenuId === id;
  }) > -1;
};

var ContextMenu = withStyling(component$6);

var ItemTypes = {
  IMAGE: 'image',
  TABLE_ROW: 'tableRow'
};

var style = {
  cursor: 'move'
};

var component$7 = function component(props) {
  var ref = useRef(null);

  var _useDrop = useDrop({
    accept: ItemTypes.IMAGE ,
    hover: function hover(item, monitor) {
      var _a, _b;

      if (!ref.current) {
        return;
      }

      var dragIndex = item.index;
      var hoverIndex = props.index;

      if (dragIndex === hoverIndex) {
        return;
      }

      if (props.itemType === ItemTypes.IMAGE) {
        var hoverBoundingRect = (_a = ref.current) === null || _a === void 0 ? void 0 : _a.getBoundingClientRect();
        var hoverMiddleRight = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 4;
        var hoverMiddleLeft = (hoverBoundingRect.bottom - hoverBoundingRect.top) * 4;
        var clientOffset = monitor.getClientOffset();
        var hoverClientY = clientOffset.y - hoverBoundingRect.top;

        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleRight) {
          return;
        }

        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleLeft) {
          return;
        }

        props.moveElement(dragIndex, hoverIndex);
        /* eslint-disable no-param-reassign */

        /* eslint-disable no-param-reassign */
        item.index = hoverIndex;
      } else if (props.itemType === ItemTypes.TABLE_ROW) {
        var _hoverBoundingRect = (_b = ref.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();

        var hoverMiddleY = (_hoverBoundingRect.bottom - _hoverBoundingRect.top) / 2;

        var _clientOffset = monitor.getClientOffset();

        var _hoverClientY = _clientOffset.y - _hoverBoundingRect.top;

        if (dragIndex < hoverIndex && _hoverClientY < hoverMiddleY) {
          return;
        }

        if (dragIndex > hoverIndex && _hoverClientY > hoverMiddleY) {
          return;
        }

        props.moveElement(dragIndex, hoverIndex);
        /* eslint-disable no-param-reassign */

        /* eslint-disable no-param-reassign */
        item.index = hoverIndex;
      }
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      drop = _useDrop2[1];

  var id = props.id,
      index = props.index,
      element = props.element;

  var _useDrag = useDrag({
    item: {
      type: ItemTypes.IMAGE ,
      id: id,
      index: index
    },
    end: function end() {
      if (props.onDrop) {
        props.onDrop();
      }
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 2),
      isDragging = _useDrag2[0].isDragging,
      drag = _useDrag2[1];

  var opacity = isDragging ? 0 : 1;
  drag(drop(ref));

  if (props.itemType === ItemTypes.IMAGE) {
    return jsx("div", Object.assign({
      ref: ref,
      style: Object.assign(Object.assign({}, style), {
        opacity: opacity
      })
    }, {
      children: element
    }), void 0);
  } // else if item type is row


  return jsx("tr", Object.assign({
    ref: ref,
    style: Object.assign(Object.assign({}, style), {
      opacity: opacity
    }),
    className: clsx(props.customStyles, props.customRowStyle && props.styling.getStyle(props.customStyles, props.customRowStyle.className))
  }, {
    children: element
  }), props.index);
};

var DraggableComponent = withStyling(component$7);

var $includes = arrayIncludes.includes;


// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
_export({ target: 'Array', proto: true }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');

// TODO: use something more complex like timsort?
var floor$1 = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor$1(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    mergeSort(array.slice(0, middle), comparefn),
    mergeSort(array.slice(middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;
  var result = [];

  while (lindex < llength || rindex < rlength) {
    if (lindex < llength && rindex < rlength) {
      result.push(comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]);
    } else {
      result.push(lindex < llength ? left[lindex++] : right[rindex++]);
    }
  } return result;
};

var arraySort = mergeSort;

var firefox = engineUserAgent.match(/firefox\/(\d+)/i);

var engineFfVersion = !!firefox && +firefox[1];

var engineIsIeOrEdge = /MSIE|Trident/.test(engineUserAgent);

var webkit = engineUserAgent.match(/AppleWebKit\/(\d+)\./);

var engineWebkitVersion = !!webkit && +webkit[1];

var test = [];
var nativeSort = test.sort;

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD$4 = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (engineV8Version) return engineV8Version < 70;
  if (engineFfVersion && engineFfVersion > 3) return;
  if (engineIsIeOrEdge) return true;
  if (engineWebkitVersion) return engineWebkitVersion < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED$1 = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD$4 || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return String(x) > String(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
_export({ target: 'Array', proto: true, forced: FORCED$1 }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aFunction$1(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort.call(array) : nativeSort.call(array, comparefn);

    var items = [];
    var arrayLength = toLength(array.length);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) items.push(array[index]);
    }

    items = arraySort(items, getSortCompare(comparefn));
    itemsLength = items.length;
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) delete array[index++];

    return array;
  }
});

var HAS_SPECIES_SUPPORT$2 = arrayMethodHasSpeciesSupport('splice');

var max$1 = Math.max;
var min$3 = Math.min;
var MAX_SAFE_INTEGER$1 = 0x1FFFFFFFFFFFFF;
var MAXIMUM_ALLOWED_LENGTH_EXCEEDED = 'Maximum allowed length exceeded';

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$2 }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = toLength(O.length);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min$3(max$1(toInteger(deleteCount), 0), len - actualStart);
    }
    if (len + insertCount - actualDeleteCount > MAX_SAFE_INTEGER$1) {
      throw TypeError(MAXIMUM_ALLOWED_LENGTH_EXCEEDED);
    }
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) delete O[k - 1];
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else delete O[to];
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    O.length = len - actualDeleteCount + insertCount;
    return A;
  }
});

var DatePrototype = Date.prototype;
var INVALID_DATE = 'Invalid Date';
var TO_STRING = 'toString';
var nativeDateToString = DatePrototype[TO_STRING];
var getTime = DatePrototype.getTime;

// `Date.prototype.toString` method
// https://tc39.es/ecma262/#sec-date.prototype.tostring
if (new Date(NaN) + '' != INVALID_DATE) {
  redefine(DatePrototype, TO_STRING, function toString() {
    var value = getTime.call(this);
    // eslint-disable-next-line no-self-compare -- NaN check
    return value === value ? nativeDateToString.call(this) : INVALID_DATE;
  });
}

var aPossiblePrototype = function (it) {
  if (!isObject(it) && it !== null) {
    throw TypeError("Can't set " + String(it) + ' as a prototype');
  } return it;
};

/* eslint-disable no-proto -- safe */



// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var objectSetPrototypeOf = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    setter = Object.getOwnPropertyDescriptor(Object.prototype, '__proto__').set;
    setter.call(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter.call(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);

// makes subclassing work correct for wrapped built-ins
var inheritIfRequired = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    objectSetPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    typeof (NewTarget = dummy.constructor) == 'function' &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) objectSetPrototypeOf($this, NewTargetPrototype);
  return $this;
};

// a string of all valid unicode whitespaces
var whitespaces = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';

var whitespace = '[' + whitespaces + ']';
var ltrim = RegExp('^' + whitespace + whitespace + '*');
var rtrim = RegExp(whitespace + whitespace + '*$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod$4 = function (TYPE) {
  return function ($this) {
    var string = String(requireObjectCoercible($this));
    if (TYPE & 1) string = string.replace(ltrim, '');
    if (TYPE & 2) string = string.replace(rtrim, '');
    return string;
  };
};

var stringTrim = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod$4(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod$4(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod$4(3)
};

var getOwnPropertyNames = objectGetOwnPropertyNames.f;
var getOwnPropertyDescriptor$2 = objectGetOwnPropertyDescriptor.f;
var defineProperty$2 = objectDefineProperty.f;
var trim = stringTrim.trim;

var NUMBER = 'Number';
var NativeNumber = global_1[NUMBER];
var NumberPrototype = NativeNumber.prototype;

// Opera ~12 has broken Object#toString
var BROKEN_CLASSOF = classofRaw(objectCreate(NumberPrototype)) == NUMBER;

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, false);
  var first, third, radix, maxCode, digits, length, index, code;
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = it.charCodeAt(0);
    if (first === 43 || first === 45) {
      third = it.charCodeAt(2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (it.charCodeAt(1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = it.slice(2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = digits.charCodeAt(index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
if (isForced_1(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'))) {
  var NumberWrapper = function Number(value) {
    var it = arguments.length < 1 ? 0 : value;
    var dummy = this;
    return dummy instanceof NumberWrapper
      // check on 1..constructor(foo) case
      && (BROKEN_CLASSOF ? fails(function () { NumberPrototype.valueOf.call(dummy); }) : classofRaw(dummy) != NUMBER)
        ? inheritIfRequired(new NativeNumber(toNumber(it)), dummy, NumberWrapper) : toNumber(it);
  };
  for (var keys$1 = descriptors ? getOwnPropertyNames(NativeNumber) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' +
    'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys$1.length > j; j++) {
    if (has(NativeNumber, key = keys$1[j]) && !has(NumberWrapper, key)) {
      defineProperty$2(NumberWrapper, key, getOwnPropertyDescriptor$2(NativeNumber, key));
    }
  }
  NumberWrapper.prototype = NumberPrototype;
  NumberPrototype.constructor = NumberWrapper;
  redefine(global_1, NUMBER, NumberWrapper);
}

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test$1 = {};

test$1[TO_STRING_TAG] = 'z';

var toStringTagSupport = String(test$1) === '[object z]';

var TO_STRING_TAG$1 = wellKnownSymbol('toStringTag');
// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
var classof = toStringTagSupport ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = Object(it), TO_STRING_TAG$1)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : result;
};

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
var objectToString = toStringTagSupport ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!toStringTagSupport) {
  redefine(Object.prototype, 'toString', objectToString, { unsafe: true });
}

var TO_STRING$1 = 'toString';
var RegExpPrototype$1 = RegExp.prototype;
var nativeToString = RegExpPrototype$1[TO_STRING$1];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) != '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = nativeToString.name != TO_STRING$1;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  redefine(RegExp.prototype, TO_STRING$1, function toString() {
    var R = anObject(this);
    var p = String(R.source);
    var rf = R.flags;
    var f = String(rf === undefined && R instanceof RegExp && !('flags' in RegExpPrototype$1) ? regexpFlags.call(R) : rf);
    return '/' + p + '/' + f;
  }, { unsafe: true });
}

var notARegexp = function (it) {
  if (isRegexp(it)) {
    throw TypeError("The method doesn't accept regular expressions");
  } return it;
};

var MATCH$1 = wellKnownSymbol('match');

var correctIsRegexpLogic = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH$1] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
_export({ target: 'String', proto: true, forced: !correctIsRegexpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~String(requireObjectCoercible(this))
      .indexOf(notARegexp(searchString), arguments.length > 1 ? arguments[1] : undefined);
  }
});

var runtime_1 = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var runtime = (function (exports) {

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined$1; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  function define(obj, key, value) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
    return obj[key];
  }
  try {
    // IE 8 has a broken Object.defineProperty that only works on DOM objects.
    define({}, "");
  } catch (err) {
    define = function(obj, key, value) {
      return obj[key] = value;
    };
  }

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  exports.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunction.displayName = define(
    GeneratorFunctionPrototype,
    toStringTagSymbol,
    "GeneratorFunction"
  );

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      define(prototype, method, function(arg) {
        return this._invoke(method, arg);
      });
    });
  }

  exports.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  exports.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      define(genFun, toStringTagSymbol, "GeneratorFunction");
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  exports.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return PromiseImpl.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return PromiseImpl.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration.
          result.value = unwrapped;
          resolve(result);
        }, function(error) {
          // If a rejected Promise was yielded, throw the rejection back
          // into the async generator function so it can be handled there.
          return invoke("throw", error, resolve, reject);
        });
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new PromiseImpl(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  exports.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    if (PromiseImpl === void 0) PromiseImpl = Promise;

    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList),
      PromiseImpl
    );

    return exports.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined$1) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        // Note: ["return"] must be used for ES3 parsing compatibility.
        if (delegate.iterator["return"]) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined$1;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined$1;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  define(Gp, toStringTagSymbol, "Generator");

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  exports.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined$1;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  exports.values = values;

  function doneResult() {
    return { value: undefined$1, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined$1;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined$1;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined$1;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined$1;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined$1;
      }

      return ContinueSentinel;
    }
  };

  // Regardless of whether this script is executing as a CommonJS module
  // or not, return the runtime object so that we can declare the variable
  // regeneratorRuntime in the outer scope, which allows this module to be
  // injected easily by `bin/regenerator --include-runtime script.js`.
  return exports;

}(
  // If this script is executing as a CommonJS module, use module.exports
  // as the regeneratorRuntime namespace. Otherwise create a new empty
  // object. Either way, the resulting object will be used to initialize
  // the regeneratorRuntime variable at the top of this file.
   module.exports 
));

try {
  regeneratorRuntime = runtime;
} catch (accidentalStrictMode) {
  // This module should not be running in strict mode, so the above
  // assignment should always work unless something is misconfigured. Just
  // in case runtime.js accidentally runs in strict mode, we can escape
  // strict mode using a global Function call. This could conceivably fail
  // if a Content Security Policy forbids using Function, but in that case
  // the proper solution is to fix the accidental strict mode problem. If
  // you've misconfigured your bundler to force strict mode and applied a
  // CSP to forbid Function, and you're not willing to fix either of those
  // problems, please detail your unique predicament in a GitHub issue.
  Function("r", "regeneratorRuntime = r")(runtime);
}
});

var styles$7 = {"uploadComponent":"file-upload-module_uploadComponent__2m-Ev","uploadContainer":"file-upload-module_uploadContainer__yjiqy","imageRemoveIcon":"file-upload-module_imageRemoveIcon__27YI4","sideDescription":"file-upload-module_sideDescription__3C0Og","topPadding":"file-upload-module_topPadding__34KsK","imageTile":"file-upload-module_imageTile__xOhpf","overlay":"file-upload-module_overlay__28XqB","imageLoadTile":"file-upload-module_imageLoadTile__2eYNO","buttonLoader":"file-upload-module_buttonLoader__1i-Zv","uploadedFilesContainer":"file-upload-module_uploadedFilesContainer__1LC00","uploadedFiles":"file-upload-module_uploadedFiles__1gVPj","imageUpload":"file-upload-module_imageUpload__1hcvf","fileUpload":"file-upload-module_fileUpload__345L4","dragActive":"file-upload-module_dragActive__RDORY","error":"file-upload-module_error__T4hwZ","icon":"file-upload-module_icon__1K71Z","iconDescription":"file-upload-module_iconDescription__27tpW","file":"file-upload-module_file__rdTU-","fileLoader":"file-upload-module_fileLoader__3Y34Z","files":"file-upload-module_files__3jlj9","fileRemoveIcon":"file-upload-module_fileRemoveIcon__2w8hi"};

var component$8 = function component(props) {
  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      files = _useState2[0],
      setFiles = _useState2[1];

  var previousFiles = usePrevious(files);
  useEffect(function () {
    if (props.files && props.files !== files) {
      setFiles(sortFiles(props.files));
    }
  }, []);
  useEffect(function () {
    if (previousFiles !== null && previousFiles !== files) {
      props.onChange(files, props.id);
    }
  }, [files]);
  var valueRef = useRef(files);
  useEffect(function () {
    valueRef.current = files;
  }, [files]);
  var onDrop = useCallback(function (acceptedFiles) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var loadingFiles, acceptedFilesLimit, i, currentFilesArray, filesToSet, _currentFilesArray, _filesToSet;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              loadingFiles = [];
              acceptedFilesLimit = props.isMulti ? acceptedFiles : [acceptedFiles[0]];

              for (i = 0; i < acceptedFilesLimit.length; i += 1) {
                loadingFiles.push({
                  showLoader: true
                });
              }

              if (props.isImage) {
                currentFilesArray = props.isMulti && valueRef.current ? _toConsumableArray(valueRef.current) : [];
                filesToSet = [].concat(_toConsumableArray(currentFilesArray), loadingFiles);
                setFiles(filesToSet);
                acceptedFilesLimit.forEach(function (newFile) {
                  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
                    var uploadedImage, currentFiles, newFilesToSet;
                    return regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            if (!newFile.type.includes('image')) {
                              _context.next = 5;
                              break;
                            }

                            _context.next = 3;
                            return props.uploadApi(newFile);

                          case 3:
                            uploadedImage = _context.sent;

                            if (currentFilesArray && uploadedImage) {
                              currentFiles = removeSingleLoadingItem(valueRef.current ? _toConsumableArray(valueRef.current) : []);
                              newFilesToSet = [].concat(_toConsumableArray(currentFiles === null || currentFiles === void 0 ? void 0 : currentFiles.filter(function (item) {
                                return !isLoadingFile(item);
                              })), [uploadedImage], _toConsumableArray(currentFiles === null || currentFiles === void 0 ? void 0 : currentFiles.filter(function (item) {
                                return isLoadingFile(item);
                              })));
                              setFiles(newFilesToSet);
                            } else {
                              setFiles([]);
                            }

                          case 5:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));
                });
              } else {
                _currentFilesArray = props.isMulti && valueRef.current ? _toConsumableArray(valueRef.current) : [];
                _filesToSet = [].concat(_toConsumableArray(_currentFilesArray), loadingFiles);
                setFiles(_filesToSet);
                acceptedFilesLimit.forEach(function (newFile) {
                  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
                    var uploadedFile, currentFiles;
                    return regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            _context2.next = 2;
                            return props.uploadApi(newFile);

                          case 2:
                            uploadedFile = _context2.sent;

                            if (_currentFilesArray && uploadedFile) {
                              currentFiles = removeSingleLoadingItem(valueRef.current ? _toConsumableArray(valueRef.current) : []);
                              setFiles([].concat(_toConsumableArray(currentFiles === null || currentFiles === void 0 ? void 0 : currentFiles.filter(function (item) {
                                return !isLoadingFile(item);
                              })), [uploadedFile], _toConsumableArray(currentFiles === null || currentFiles === void 0 ? void 0 : currentFiles.filter(function (item) {
                                return isLoadingFile(item);
                              }))));
                              props.onChange([].concat(_toConsumableArray(currentFiles === null || currentFiles === void 0 ? void 0 : currentFiles.filter(function (item) {
                                return !isLoadingFile(item);
                              })), [uploadedFile]), props.id);
                            } else {
                              setFiles([]);
                            }

                          case 4:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));
                });
              }

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
  }, []);

  var onRemoveImage = function onRemoveImage(file) {
    var array = files ? _toConsumableArray(files) : [];
    var index = array.indexOf(file);

    if (index !== -1) {
      array.splice(index, 1);
      setFiles(array);
    }
  };

  var onRemoveFile = function onRemoveFile(id) {
    var newFiles = files === null || files === void 0 ? void 0 : files.filter(function (item) {
      return !isLoadingFile(item) && item.id !== id;
    });
    setFiles(newFiles);
  };

  var moveElement = useCallback(function (dragIndex, hoverIndex) {
    if (files) {
      var dragFile = files[dragIndex];
      var newFiles = update(files, {
        $splice: [[dragIndex, 1], [hoverIndex, 0, dragFile]]
      });
      newFiles = newFiles.map(function (item, index) {
        return Object.assign(Object.assign({}, item), {
          index: index
        });
      });
      setFiles(newFiles);
    }
  }, [files]);

  var _useDropzone = useDropzone({
    onDrop: onDrop
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive;

  return jsx("div", Object.assign({
    className: clsx(props.styling.getStyle(styles$7, 'uploadComponent'), props.className && props.styling.getStyle(styles$7, props.className))
  }, {
    children: props.isImage ? jsxs(Fragment, {
      children: [jsxs("div", Object.assign({
        className: props.styling.getStyle(styles$7, 'uploadContainer')
      }, {
        children: [props.label, jsxs("div", Object.assign({}, getRootProps(), {
          className: clsx(props.styling.getStyle(styles$7, 'imageUpload'), isDragActive && props.styling.getStyle(styles$7, 'dragActive'))
        }, {
          children: [jsx("input", Object.assign({}, getInputProps(), {
            type: "file",
            multiple: props.isMulti,
            accept: props.acceptFileFormat || 'image/x-png,image/png,image/jpg,image/jpeg',
            onBlur: props.onBlur
          }), void 0), jsxs("div", Object.assign({
            className: props.styling.getStyle(styles$7, 'icon')
          }, {
            children: [props.uploadIcon, jsxs("span", Object.assign({
              className: props.styling.getStyle(styles$7, 'iconDescription')
            }, {
              children: [" ", props.uploadDescription]
            }), void 0)]
          }), void 0)]
        }), void 0), jsxs("div", Object.assign({
          className: props.styling.getStyle(styles$7, 'uploadedFilesContainer')
        }, {
          children: [jsx("div", {
            className: clsx(props.isInvalid && props.styling.getStyle(styles$7, 'error'))
          }, void 0), files && files.length > 0 && jsx(DndProvider, Object.assign({
            backend: HTML5Backend
          }, {
            children: files.map(function (file, index) {
              if (isLoadingFile(file)) {
                return jsx("div", Object.assign({
                  className: props.styling.getStyle(styles$7, 'uploadedFiles')
                }, {
                  children: jsx("div", Object.assign({
                    className: props.styling.getStyle(styles$7, 'imageTile')
                  }, {
                    children: jsx("div", Object.assign({
                      className: props.styling.getStyle(styles$7, 'imageLoadTile')
                    }, {
                      children: jsx("span", Object.assign({
                        className: props.styling.getStyle(styles$7, 'buttonLoader')
                      }, {
                        children: props.loader
                      }), void 0)
                    }), void 0)
                  }), void 0)
                }), index);
              }

              return jsx("div", Object.assign({
                className: props.styling.getStyle(styles$7, 'uploadedFiles')
              }, {
                children: jsxs("div", Object.assign({
                  className: props.styling.getStyle(styles$7, 'imageTile')
                }, {
                  children: [jsx("div", {
                    className: props.styling.getStyle(styles$7, 'overlay')
                  }, void 0), props.isDraggable && file && file.id !== null && jsx(DraggableComponent, {
                    id: file.id,
                    index: index,
                    element: jsx("img", {
                      alt: "uploaded_image",
                      src: file.url || ''
                    }, void 0),
                    moveElement: moveElement,
                    itemType: "image"
                  }, file.id), !props.isDraggable && file && file.id !== null && jsx("img", {
                    alt: "uploaded_image",
                    src: file.url || ''
                  }, void 0), jsx("span", Object.assign({
                    role: "button",
                    className: props.styling.getStyle(styles$7, 'imageRemoveIcon'),
                    onClick: function onClick() {
                      return onRemoveImage(file);
                    }
                  }, {
                    children: props.deleteIcon
                  }), void 0)]
                }), void 0)
              }), index);
            })
          }), void 0)]
        }), void 0)]
      }), void 0), jsx("div", Object.assign({
        className: clsx(props.styling.getStyle(styles$7, 'sideDescription'), props.label && props.styling.getStyle(styles$7, 'topPadding'))
      }, {
        children: props.sideDescription
      }), void 0)]
    }, void 0) : jsxs(Fragment, {
      children: [jsxs("div", Object.assign({
        className: props.styling.getStyle(styles$7, 'uploadContainer')
      }, {
        children: [props.label, jsxs("div", Object.assign({}, getRootProps(), {
          className: clsx(props.styling.getStyle(styles$7, 'fileUpload'), isDragActive && props.styling.getStyle(styles$7, 'dragActive'))
        }, {
          children: [jsx("input", Object.assign({}, getInputProps(), {
            type: "file",
            multiple: props.isMulti,
            accept: props.acceptFileFormat || '*',
            onBlur: props.onBlur
          }), void 0), jsxs("div", Object.assign({
            className: props.styling.getStyle(styles$7, 'icon')
          }, {
            children: [props.uploadIcon, jsx("span", Object.assign({
              className: props.styling.getStyle(styles$7, 'iconDescription')
            }, {
              children: props.uploadDescription
            }), void 0)]
          }), void 0)]
        }), void 0), jsx("div", {
          className: clsx(props.isInvalid && props.styling.getStyle(styles$7, 'error'))
        }, void 0), jsx("div", Object.assign({
          className: props.styling.getStyle(styles$7, 'files')
        }, {
          children: files && files.length > 0 && files.map(function (file, index) {
            var _a;

            if (!isLoadingFile(file)) {
              return jsxs("div", Object.assign({
                className: props.styling.getStyle(styles$7, 'file')
              }, {
                children: [file.fileName || file.name, jsx("span", Object.assign({
                  role: "row",
                  className: props.styling.getStyle(styles$7, 'fileRemoveIcon'),
                  onClick: function onClick() {
                    return onRemoveFile(Number(file.id));
                  }
                }, {
                  children: props.deleteIcon
                }), void 0)]
              }), ((_a = file.id) === null || _a === void 0 ? void 0 : _a.toString()) || index);
            }

            return jsxs("div", Object.assign({
              className: props.styling.getStyle(styles$7, 'fileLoader')
            }, {
              children: [props.loader, props.uploadText]
            }), index);
          })
        }), void 0)]
      }), void 0), jsx("div", Object.assign({
        className: clsx(props.styling.getStyle(styles$7, 'sideDescription'), props.label && props.styling.getStyle(styles$7, 'topPadding'))
      }, {
        children: props.sideDescription
      }), void 0)]
    }, void 0)
  }), void 0);
};

var removeSingleLoadingItem = function removeSingleLoadingItem(files) {
  for (var i = 0; i < files.length; i += 1) {
    var currentImage = files[i];

    if (isLoadingFile(currentImage)) {
      files.splice(i, 1);
      return files;
    }
  }

  return files;
};

function isLoadingFile(object) {
  return 'showLoader' in object;
}

var sortFiles = function sortFiles(values) {
  if (!values || values.length === 0) {
    return [];
  }

  var valuesArray = _toConsumableArray(values);

  var result = valuesArray.sort(function (a, b) {
    return (a.index ? a.index : 0) - (b.index ? b.index : 0);
  });
  return result;
};

var FileUpload = withStyling(component$8);

var styles$8 = {"icon-svg":"icon-module_icon-svg__1rDJJ","icon-svg--outline":"icon-module_icon-svg--outline__3Lwrg","icon-svg--stroke-width":"icon-module_icon-svg--stroke-width__1kD3L","icon-svg--filled":"icon-module_icon-svg--filled__2gYYM"};

var component$9 = function component(props) {
  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      iconStyleClassName = _useState2[0],
      setIconStyleClassName = _useState2[1];

  useEffect(function () {
    var fillColor = props.fillColor,
        strokeColor = props.strokeColor,
        strokeWidth = props.strokeWidth;
    var defaultStyle = 'icon-svg';
    var fillClassName = typeof fillColor !== 'undefined' ? styles$8["".concat(defaultStyle, "--filled")] : '';
    var strokeWidthClassName = typeof strokeWidth !== 'undefined' ? styles$8["".concat(defaultStyle, "--stroke-width")] : '';
    var outlineClassName = typeof strokeColor !== 'undefined' ? styles$8["".concat(defaultStyle, "--outline")] : '';
    var className = clsx(styles$8[defaultStyle], fillClassName, outlineClassName, strokeWidthClassName);
    setIconStyleClassName(className);
  }, [props.fillColor, props.strokeColor, props.strokeWidth]);
  return jsx(ReactSVG, {
    src: props.icon,
    fallback: function fallback() {
      return jsx("span", {
        children: "Error!"
      }, void 0);
    },
    loading: function loading() {
      return jsx("span", {}, void 0);
    },
    renumerateIRIElements: true,
    wrapper: "span",
    style: {
      fill: props.fillColor,
      height: props.size,
      stroke: props.strokeColor,
      strokeWidth: props.strokeWidth,
      width: props.size
    },
    className: iconStyleClassName
  }, void 0);
};

var Icon = /*#__PURE__*/memo(withStyling(component$9));

var styles$9 = {"label":"interactive-label-module_label__2vTjC","withIcon":"interactive-label-module_withIcon__1b-Ki","labelText":"interactive-label-module_labelText__1xJ0y"};

var component$a = function component(props) {
  var handleClick = function handleClick(event) {
    if (props.onClick) {
      props.onClick(props.id, props.label, event);
    }
  };

  return jsxs("button", Object.assign({
    type: "button",
    className: clsx(props.styling.getStyle(styles$9, 'label'), props.icon && props.styling.getStyle(styles$9, 'withIcon'), props.className),
    onClick: handleClick,
    tabIndex: props.disableTabIndex ? -1 : 0
  }, {
    children: [props === null || props === void 0 ? void 0 : props.icon, jsx("span", Object.assign({
      className: props.styling.getStyle(styles$9, 'labelText')
    }, {
      children: props.label
    }), void 0)]
  }), void 0);
};

var InteractiveLabel = withStyling(component$a);

var loaderTypes = {
  BUTTON_LOADER: 'buttonLoader',
  SPINNER_LOADER: 'spinnerLoader',
  TWIN_LOADER: 'twinLoader'
};

var buttonLoaderStyling = {"spinner":"button-loader-module_spinner__2A7VV","parent":"button-loader-module_parent__cPDfb"};

var twinLoaderStyling = {"spinner":"twin-loader-module_spinner__3AfKW","spinner-r":"twin-loader-module_spinner-r__2P6JL","spinner-s":"twin-loader-module_spinner-s__19jt9","loadingio-spinner-interwind-4o7gqu16yfw":"twin-loader-module_loadingio-spinner-interwind-4o7gqu16yfw__kExRJ","parent":"twin-loader-module_parent__r03-y"};

var spinnerLoaderStyling = {"spinner":"spinner-loader-module_spinner__2un_R","parent":"spinner-loader-module_parent__38xYy"};

var component$b = function component(props) {
  return jsxs(Fragment, {
    children: [props.loaderType === loaderTypes.BUTTON_LOADER && jsx("div", Object.assign({
      className: props.styling.getStyle(buttonLoaderStyling, 'parent')
    }, {
      children: jsx("div", Object.assign({
        className: props.styling.getStyle(buttonLoaderStyling, 'spinner')
      }, {
        children: jsx("div", {
          style: {
            width: props.primarySize,
            height: props.primarySize,
            border: "2px solid ".concat(props.primaryColor),
            borderTopColor: 'transparent'
          }
        }, void 0)
      }), void 0)
    }), void 0), props.loaderType === loaderTypes.SPINNER_LOADER && jsx("div", Object.assign({
      className: props.styling.getStyle(spinnerLoaderStyling, 'parent')
    }, {
      children: jsxs("div", Object.assign({
        className: props.styling.getStyle(spinnerLoaderStyling, 'spinner')
      }, {
        children: [jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0), jsx("div", {
          style: {
            background: props.primaryColor
          }
        }, void 0)]
      }), void 0)
    }), void 0), props.loaderType === loaderTypes.TWIN_LOADER && jsx("div", Object.assign({
      className: props.styling.getStyle(twinLoaderStyling, 'parent')
    }, {
      children: jsx("div", Object.assign({
        className: props.styling.getStyle(twinLoaderStyling, 'spinner')
      }, {
        children: jsxs("div", {
          children: [jsx("div", {
            children: jsx("div", {
              children: jsx("div", {
                style: {
                  width: props.primarySize,
                  height: props.primarySize,
                  background: props.primaryColor
                }
              }, void 0)
            }, void 0)
          }, void 0), jsx("div", {
            children: jsx("div", {
              children: jsx("div", {
                style: {
                  width: props.secondarySize,
                  height: props.secondarySize,
                  background: props.secondaryColor
                }
              }, void 0)
            }, void 0)
          }, void 0)]
        }, void 0)
      }), void 0)
    }), void 0)]
  }, void 0);
};

var Loader = withStyling(component$b);

var styles$a = {"wrapper":"modal-module_wrapper__Awr68","overlay":"modal-module_overlay__1Vkcq","modalDialog":"modal-module_modalDialog__1LVtr","slideIn":"modal-module_slideIn__3EpPG","modalContent":"modal-module_modalContent__1f0sR","header":"modal-module_header__1NTt2","noJsxHeader":"modal-module_noJsxHeader__1wV2p","close":"modal-module_close__3pXb7","body":"modal-module_body__1NVcC","footer":"modal-module_footer__2ShFr","buttons":"modal-module_buttons__3sYhG","buttonsRight":"modal-module_buttonsRight__30Dhi"};

var MODAL_PADDING = 16;
var BODY_PADDING = 16;

var Wrapper = function Wrapper(props) {
  if (typeof document === 'undefined' || !props.isOpen) return jsx(Fragment, {}, void 0);
  return jsx(InnerModal, Object.assign({}, props), void 0);
};

var InnerModal = function InnerModal(props) {
  var _props$closeOnEscapeK = props.closeOnEscapeKey,
      closeOnEscapeKey = _props$closeOnEscapeK === void 0 ? true : _props$closeOnEscapeK,
      _props$closeOnOutside = props.closeOnOutsideClick,
      closeOnOutsideClick = _props$closeOnOutside === void 0 ? true : _props$closeOnOutside;
  var footerRef = useRef(null);
  var headerRef = useRef(null);

  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      bodyMaxCssHeight = _useState2[0],
      setBodyMaxCssHeight = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      bodyMaxHeight = _useState4[0],
      setBodyMaxHeight = _useState4[1];

  var _useState5 = useState(0),
      _useState6 = _slicedToArray(_useState5, 2),
      bodyRefHeightWithPadding = _useState6[0],
      setBodyRefHeightWithPadding = _useState6[1];

  var _useResizeDetector = useResizeDetector(),
      bodyRefHeight = _useResizeDetector.height,
      bodyRef = _useResizeDetector.ref;

  var _useResizeDetector2 = useResizeDetector(),
      modalRefHeight = _useResizeDetector2.height,
      modalRef = _useResizeDetector2.ref; // eslint-disable-next-line consistent-return


  useEffect(function () {
    var scrollbarSize = window.innerWidth - document.documentElement.clientWidth;
    var otherModalIsOpen = document.body.style.overflow === 'hidden';

    if (typeof window !== 'undefined') {
      window.addEventListener('keydown', handleEscapeKey);

      if (!otherModalIsOpen) {
        document.body.style.overflow = 'hidden';
        document.body.style.paddingRight = "".concat(scrollbarSize, "px");
      }

      return function () {
        window.removeEventListener('keydown', handleEscapeKey);

        if (!otherModalIsOpen) {
          document.body.style.overflow = 'auto';
          document.body.style.paddingRight = '0px';
        }
      };
    }
  }, []);

  var handleEscapeKey = function handleEscapeKey(e) {
    if (e.key === 'Escape' && closeOnEscapeKey) {
      props.onClose();
    }
  };

  useEffect(function () {
    var _a, _b;

    var bodyPadding = (_b = (_a = props.bodyPadding) === null || _a === void 0 ? void 0 : _a[0]) !== null && _b !== void 0 ? _b : BODY_PADDING;
    setBodyRefHeightWithPadding(bodyRefHeight + bodyPadding * 2);
  }, [bodyRefHeight, props.bodyPadding]);
  useEffect(function () {
    var _a, _b;

    var headerHeight = ((_a = headerRef.current) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
    var footerHeight = ((_b = footerRef.current) === null || _b === void 0 ? void 0 : _b.clientHeight) || 0;
    var parentHeight = modalRefHeight ? "".concat(modalRefHeight, "px") : '100vh';
    setBodyMaxCssHeight("calc(".concat(parentHeight, " - ").concat(headerHeight, "px - ").concat(footerHeight, "px)"));

    if (typeof window !== 'undefined') {
      setBodyMaxHeight((modalRefHeight || window.innerHeight) - headerHeight - footerHeight);
    }
  }, [headerRef, footerRef, bodyRefHeight, props.bodyPadding, modalRefHeight]);
  return /*#__PURE__*/ReactDOM.createPortal(jsx(FocusLock, Object.assign({
    autoFocus: false
  }, {
    children: jsxs("div", Object.assign({
      ref: modalRef,
      className: clsx(props.styling.getStyle(styles$a, 'wrapper'), props.className),
      style: {
        padding: "".concat(MODAL_PADDING, "px")
      }
    }, {
      children: [jsx("div", {
        role: "button",
        tabIndex: -1,
        "aria-label": "closeOverlay",
        onClick: function onClick() {
          if (!props.isLoading && closeOnOutsideClick) {
            props.onClose();
          }
        },
        className: props.styling.getStyle(styles$a, 'overlay')
      }, void 0), jsx("div", Object.assign({
        className: props.styling.getStyle(styles$a, 'modalDialog'),
        role: "document",
        style: {
          maxWidth: props.maxWidth ? "".concat(props.maxWidth, "px") : '500px'
        }
      }, {
        children: jsxs("div", Object.assign({
          className: props.styling.getStyle(styles$a, 'modalContent')
        }, {
          children: [jsxs("div", Object.assign({
            ref: headerRef,
            className: clsx(props.styling.getStyle(styles$a, 'header'), typeof props.title === 'string' && props.styling.getStyle(styles$a, 'noJsxHeader'))
          }, {
            children: [typeof props.title === 'string' ? jsx("h2", {
              children: props.title
            }, void 0) : props.title, props.closeIcon !== false && jsx("button", Object.assign({
              onClick: props.onClose,
              className: props.styling.getStyle(styles$a, 'close'),
              type: "button",
              disabled: props.isLoading
            }, {
              children: props.closeIcon || 'x'
            }), void 0)]
          }), void 0), jsx("div", Object.assign({
            className: props.styling.getStyle(styles$a, 'body'),
            style: {
              maxHeight: bodyMaxCssHeight || '50vh',
              overflow: (bodyRefHeightWithPadding || 0) + MODAL_PADDING * 2 >= bodyMaxHeight ? 'auto' : 'visible'
            }
          }, {
            children: jsx("div", Object.assign({
              className: props.styling.getStyle(styles$a, 'measure'),
              ref: bodyRef,
              style: {
                padding: props.bodyPadding ? "".concat(props.bodyPadding[0], "px ").concat(props.bodyPadding[1], "px") : BODY_PADDING
              }
            }, {
              children: props.children
            }), void 0)
          }), void 0), (props.footerButtons || props.customFooter) && jsx("div", Object.assign({
            className: props.styling.getStyle(styles$a, 'footer'),
            ref: footerRef
          }, {
            children: props.customFooter ? props.customFooter : renderFooter(props.styling, props.onClose, props.isLoading, props.footerButtons.cancelButton, props.footerButtons.submitButton, props.footerButtons.dangerButton)
          }), void 0)]
        }), void 0)
      }), void 0)]
    }), void 0)
  }), void 0), document.body);
};

var Modal = withStyling(Wrapper);

var renderFooter = function renderFooter(styling, onClose, isLoading, cancel, submit, danger) {
  if (!cancel && !submit && !danger) return jsx(Fragment, {}, void 0);
  var cancelButtonElement = cancel ? /*#__PURE__*/React.cloneElement(cancel, Object.assign(Object.assign({}, cancel.props), {
    onClick: cancel.props.onClick ? cancel.props.onClick : onClose,
    disabled: isLoading
  })) : jsx(Fragment, {}, void 0);
  var submitButtonElement = submit ? /*#__PURE__*/React.cloneElement(submit, Object.assign(Object.assign({}, submit.props), {
    isLoading: isLoading
  })) : jsx(Fragment, {}, void 0);
  var dangerButtonElement = danger ? /*#__PURE__*/React.cloneElement(danger, Object.assign(Object.assign({}, danger.props), {
    disabled: isLoading
  })) : jsx(Fragment, {}, void 0);
  return jsxs("div", Object.assign({
    className: styling.getStyle(styles$a, 'buttons')
  }, {
    children: [jsx("div", Object.assign({
      className: styling.getStyle(styles$a, 'buttonsLeft')
    }, {
      children: dangerButtonElement
    }), void 0), jsxs("div", Object.assign({
      className: styling.getStyle(styles$a, 'buttonsRight')
    }, {
      children: [cancelButtonElement, submitButtonElement]
    }), void 0)]
  }), void 0);
};

var floor$2 = Math.floor;

// `Number.isInteger` method implementation
// https://tc39.es/ecma262/#sec-number.isinteger
var isInteger = function isInteger(it) {
  return !isObject(it) && isFinite(it) && floor$2(it) === it;
};

// `Number.isInteger` method
// https://tc39.es/ecma262/#sec-number.isinteger
_export({ target: 'Number', stat: true }, {
  isInteger: isInteger
});

/* eslint-disable */
function calculatePages(totalPages, currentPage) {
  var totalPagesRounded = 0;
  var CURRENT_PAGE = currentPage; // tslint:disable-next-line

  if (Number.isInteger(totalPages)) totalPagesRounded = totalPages;else {
    for (totalPagesRounded; totalPagesRounded <= totalPages; totalPagesRounded += 1) {}
  }
  /**
   * totalNumbers: the total page numbers to show on the control
   * totalBlocks: totalNumbers + 2 to cover for the left(<) and right(>) controls
   */

  var pageNeighbours = 1;
  var totalNumbers = pageNeighbours * 2 + 3;
  var totalBlocks = totalNumbers + 2;

  if (totalPagesRounded > totalBlocks) {
    var startPage = Math.max(2, CURRENT_PAGE - pageNeighbours);
    var endPage = Math.min(totalPagesRounded - 1, CURRENT_PAGE + pageNeighbours);
    var pages = range(startPage, endPage);
    /**
     * hasLeftSpill: has hidden pages to the left
     * hasRightSpill: has hidden pages to the right
     * spillOffset: number of hidden pages either to the left or to the right
     */

    var hasLeftSpill = startPage > 2;
    var hasRightSpill = totalPagesRounded - endPage > 1;
    var spillOffset = totalNumbers - (pages.length + 1); // handle: (1) ... {5 6} [7] {8 9} (10)

    if (hasLeftSpill && !hasRightSpill) {
      var extraPages = range(startPage - spillOffset, startPage - 1);
      pages = [].concat(_toConsumableArray(extraPages), _toConsumableArray(pages));
    } else if (!hasLeftSpill && hasRightSpill) {
      // handle: (1) {2 3} [4] {5 6} ... (10)
      var _extraPages = range(endPage + 1, endPage + spillOffset);

      pages = [].concat(_toConsumableArray(pages), _toConsumableArray(_extraPages));
    } else if (hasLeftSpill && hasRightSpill) {
      // handle: (1) ... {4 5} [6] {7 8} ... (10)
      pages = _toConsumableArray(pages);
    }

    return [1].concat(_toConsumableArray(pages), [totalPagesRounded]);
  }

  return range(1, totalPagesRounded);
}

var range = function range(from, to) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
  var i = from;
  var resultArray = [];

  while (i <= to) {
    resultArray.push(i);
    i += step;
  }

  return resultArray;
};

var styles$b = {"pagination":"pagination-module_pagination__2-5YN","pageNumber":"pagination-module_pageNumber__3dW2S","pageNumbers":"pagination-module_pageNumbers__HINVd","absoluteCenter":"pagination-module_absoluteCenter__1CxQm","skip":"pagination-module_skip__1qR7N","isSelected":"pagination-module_isSelected__35IBk","icon":"pagination-module_icon__UqvQH","prev":"pagination-module_prev__3y8U0","next":"pagination-module_next__2Y70x","label":"pagination-module_label__3BYVu","iconOnly":"pagination-module_iconOnly__Mdj9a","disabled":"pagination-module_disabled__1oJ9D","mobileCenterText":"pagination-module_mobileCenterText__3dP7t","autoWidth":"pagination-module_autoWidth__2t1ji"};

var component$c = function component(props) {
  var _a, _b;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      pages = _useState2[0],
      setPages = _useState2[1];

  useEffect(function () {
    setPages(calculatePages(props.totalPages, props.currentPage));
  }, [props.totalPages, props.currentPage]);

  if (props.totalPages <= 1) {
    return jsx(Fragment, {}, void 0);
  }

  return jsxs("div", Object.assign({
    className: clsx(props.styling.getStyle(styles$b, 'pagination'), props.isMobile && props.styling.getStyle(styles$b, 'isMobile'), props.autoWidth && props.styling.getStyle(styles$b, 'autoWidth'))
  }, {
    children: [((_a = props.skipButtons) === null || _a === void 0 ? void 0 : _a.prev) && renderSkipElement('prev', props), jsx("div", Object.assign({
      className: clsx(props.styling.getStyle(styles$b, 'pageNumbers'), props.absoluteCenterPages && props.styling.getStyle(styles$b, 'absoluteCenter'))
    }, {
      children: props.isMobile ? jsxs(Fragment, {
        children: [jsx("span", Object.assign({
          className: clsx(props.styling.getStyle(styles$b, 'pageNumber'), props.styling.getStyle(styles$b, 'isSelected'))
        }, {
          children: props.currentPage
        }), void 0), jsx("span", Object.assign({
          className: props.styling.getStyle(styles$b, 'mobileCenterText')
        }, {
          children: props.mobileCenterText
        }), void 0), jsx("span", Object.assign({
          className: props.styling.getStyle(styles$b, 'pageNumber')
        }, {
          children: props.totalPages
        }), void 0)]
      }, void 0) : pages.map(function (page, index) {
        return jsxs(React.Fragment, {
          children: [renderPageElement(page, props), page + 1 !== pages[index + 1] && index !== pages.length - 1 && jsx("span", Object.assign({
            className: props.styling.getStyle(styles$b, 'pageNumber')
          }, {
            children: "..."
          }), void 0)]
        }, page);
      })
    }), void 0), ((_b = props.skipButtons) === null || _b === void 0 ? void 0 : _b.next) && renderSkipElement('next', props)]
  }), void 0);
};

var Pagination = withStyling(component$c);

var renderPageElement = function renderPageElement(page, props) {
  var classNames = clsx(props.styling.getStyle(styles$b, 'pageNumber'), page === props.currentPage && props.styling.getStyle(styles$b, 'isSelected'));

  if (props.href) {
    return cloneLinkElement(page, "".concat(props.href).concat(page), props.linkElement, {
      className: classNames
    }, props.elementIsNextJsLink);
  }

  return jsx("button", Object.assign({
    className: classNames,
    type: "button",
    onClick: function onClick() {
      return props.onPageChange(page);
    }
  }, {
    children: page
  }), void 0);
};

var renderSkipElement = function renderSkipElement(type, props) {
  var _a, _b, _c, _d;

  var isDisabled = type === 'prev' ? props.currentPage === 1 : props.currentPage === props.totalPages;
  var hasIcon = (_a = props.skipButtons) === null || _a === void 0 ? void 0 : _a[type].icon;
  var hasLabel = (_b = props.skipButtons) === null || _b === void 0 ? void 0 : _b[type].label;
  var newPage = getNewPage(type, props.currentPage, props.totalPages);
  var sameProps = {
    className: clsx(props.styling.getStyle(styles$b, 'skip'), props.styling.getStyle(styles$b, type), isDisabled && props.styling.getStyle(styles$b, 'disabled'), hasIcon && !hasLabel && props.styling.getStyle(styles$b, 'iconOnly')),
    tabIndex: isDisabled ? -1 : 0
  };

  var content = jsxs(Fragment, {
    children: [((_c = props.skipButtons) === null || _c === void 0 ? void 0 : _c[type].icon) && jsx("div", Object.assign({
      className: props.styling.getStyle(styles$b, 'icon')
    }, {
      children: props.skipButtons[type].icon
    }), void 0), ((_d = props.skipButtons) === null || _d === void 0 ? void 0 : _d[type].label) && jsx("div", Object.assign({
      className: clsx(props.styling.getStyle(styles$b, 'label'))
    }, {
      children: props.skipButtons[type].label
    }), void 0)]
  }, void 0);

  if (props.href && props.linkElement) {
    return renderSkipLink(props, content, sameProps, newPage);
  }

  return renderSkipButton(props, content, sameProps, newPage);
};

var renderSkipButton = function renderSkipButton(props, content, buttonProps, newPage) {
  return jsx("button", Object.assign({}, buttonProps, {
    type: "button",
    onClick: function onClick() {
      if (typeof newPage !== 'undefined') {
        props.onPageChange(newPage);
      }
    }
  }, {
    children: content
  }), void 0);
};

var renderSkipLink = function renderSkipLink(props, content, linkProps, newPage) {
  var href = newPage && props.href ? "".concat(props.href).concat(newPage) : '';
  return cloneLinkElement(content, href, props.linkElement, linkProps, props.elementIsNextJsLink);
};

var getNewPage = function getNewPage(type, currentPage, totalPages) {
  if (type === 'prev') {
    if (currentPage - 1 >= 1) {
      return currentPage - 1;
    }
  } else if (currentPage + 1 <= totalPages) {
    return currentPage + 1;
  }

  return undefined;
};

var cloneLinkElement = function cloneLinkElement(children, href, linkElement, anchorProps, elementIsNextJsLink) {
  return elementIsNextJsLink ? /*#__PURE__*/React.cloneElement(linkElement, {
    href: href,
    children: jsx("a", Object.assign({}, anchorProps, {
      href: href,
      children: children
    }), void 0)
  }) : /*#__PURE__*/React.cloneElement(linkElement, Object.assign(Object.assign({}, anchorProps), {
    children: children,
    href: href,
    to: href
  }));
};

// `Array.prototype.fill` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.fill
var arrayFill = function fill(value /* , start = 0, end = @length */) {
  var O = toObject(this);
  var length = toLength(O.length);
  var argumentsLength = arguments.length;
  var index = toAbsoluteIndex(argumentsLength > 1 ? arguments[1] : undefined, length);
  var end = argumentsLength > 2 ? arguments[2] : undefined;
  var endPos = end === undefined ? length : toAbsoluteIndex(end, length);
  while (endPos > index) O[index++] = value;
  return O;
};

// `Array.prototype.fill` method
// https://tc39.es/ecma262/#sec-array.prototype.fill
_export({ target: 'Array', proto: true }, {
  fill: arrayFill
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('fill');

var styles$c = {"pieChart":"pie-chart-module_pieChart__1RnEX","chartWrapper":"pie-chart-module_chartWrapper__2MJ1R","responsiveContainer":"pie-chart-module_responsiveContainer__2kSSZ","centerLabel":"pie-chart-module_centerLabel__2ZA6M","text":"pie-chart-module_text__1I3Q6","header":"pie-chart-module_header__Gw-nd","value":"pie-chart-module_value__1SvUt"};

var styles$d = {"legend":"legend-module_legend__2n-OF","legendItem":"legend-module_legendItem__38dPa","active":"legend-module_active__b11nw","color":"legend-module_color__2OCSn","name":"legend-module_name__3mjHM","value":"legend-module_value__gOqlD"};

var component$d = function component(props) {
  var _a;

  if (!props.items || ((_a = props.items) === null || _a === void 0 ? void 0 : _a.length) === 0) return jsx(Fragment, {}, void 0);
  return jsx("div", Object.assign({
    className: props.styling.getStyle(styles$d, 'legend')
  }, {
    children: props.items.map(function (item, index) {
      return jsxs("div", Object.assign({
        className: clsx(props.styling.getStyle(styles$d, 'legendItem'), props.activeIndex === index && props.styling.getStyle(styles$d, 'active')),
        onMouseEnter: function onMouseEnter() {
          return props.onHover(index);
        },
        onMouseLeave: function onMouseLeave() {
          return props.onHover(undefined);
        }
      }, {
        children: [jsx("span", {
          className: props.styling.getStyle(styles$d, 'color'),
          style: {
            backgroundColor: item.color || props.defaultColor
          }
        }, void 0), jsx("span", Object.assign({
          className: props.styling.getStyle(styles$d, 'name')
        }, {
          children: item.name
        }), void 0), jsx("span", Object.assign({
          className: props.styling.getStyle(styles$d, 'value')
        }, {
          children: item.value
        }), void 0)]
      }), index);
    })
  }), void 0);
};

var Legend = withStyling(component$d);

var DEFAULT_COLOR_SCHEME = ['#003f5c', '#2f4b7c', '#665191', '#a05195', '#d45087', '#f95d6a', '#ff7c43', '#ffa600'];
var CHART_SIZE = 230;
var CHART_INNER_SIZE = 136;

var component$e = function component(props) {
  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      activeIndex = _useState2[0],
      setActiveIndex = _useState2[1];

  var DEFAULT_COLOR = '#003f5c';
  var data = mapDataWithColor(props.data, props.customColorScheme || DEFAULT_COLOR_SCHEME);
  var centerTotal = getDataTotal(data);
  return jsxs("div", Object.assign({
    className: props.styling.getStyle(styles$c, 'pieChart')
  }, {
    children: [jsxs("div", Object.assign({
      className: props.styling.getStyle(styles$c, 'chartWrapper')
    }, {
      children: [jsx(ResponsiveContainer, Object.assign({
        width: CHART_SIZE,
        aspect: 1,
        className: props.styling.getStyle(styles$c, 'responsiveContainer')
      }, {
        children: jsx(PieChart$1, {
          children: jsx(Pie, Object.assign({
            data: data,
            startAngle: 90,
            endAngle: -360,
            activeIndex: activeIndex,
            activeShape: renderActiveShape,
            dataKey: "value",
            nameKey: "name",
            cx: 110,
            cy: 110,
            innerRadius: "70",
            outerRadius: "100",
            fill: DEFAULT_COLOR,
            animationDuration: 500,
            blendStroke: true,
            onMouseEnter: function onMouseEnter(_, index) {
              return setActiveIndex(index);
            },
            onMouseLeave: function onMouseLeave() {
              return setActiveIndex(undefined);
            }
          }, {
            children: data.map(function (item, index) {
              return jsx(Cell, {
                fill: item.color
              }, index);
            })
          }), void 0)
        }, void 0)
      }), void 0), (props.showCenterTotal || props.centerLabel) && jsx("div", Object.assign({
        className: props.styling.getStyle(styles$c, 'centerLabel'),
        style: {
          width: CHART_SIZE,
          height: CHART_SIZE
        }
      }, {
        children: jsxs("div", Object.assign({
          className: props.styling.getStyle(styles$c, 'text'),
          style: {
            maxWidth: CHART_INNER_SIZE,
            maxHeight: CHART_INNER_SIZE
          }
        }, {
          children: [props.centerLabel && jsx("span", Object.assign({
            className: props.styling.getStyle(styles$c, 'header')
          }, {
            children: props.centerLabel
          }), void 0), props.showCenterTotal && jsx("span", Object.assign({
            className: props.styling.getStyle(styles$c, 'value')
          }, {
            children: centerTotal
          }), void 0)]
        }), void 0)
      }), void 0)]
    }), void 0), jsx(Legend, {
      items: data,
      onHover: function onHover(item) {
        return setActiveIndex(item);
      },
      activeIndex: activeIndex,
      defaultColor: DEFAULT_COLOR
    }, void 0)]
  }), void 0);
};

var PieChart = withStyling(component$e);

var mapDataWithColor = function mapDataWithColor(data, colorScheme) {
  var currentColorSchemeIndex = 0;
  return data.map(function (item) {
    var newItem = Object.assign(Object.assign({}, item), {
      color: item.color || colorScheme[currentColorSchemeIndex]
    });

    if (!item.color) {
      var newColorSchemeIndex = currentColorSchemeIndex + 1;

      if (colorScheme[newColorSchemeIndex]) {
        currentColorSchemeIndex = newColorSchemeIndex;
      } else {
        currentColorSchemeIndex = 0;
      }
    }

    return newItem;
  });
};

var renderActiveShape = function renderActiveShape(props) {
  var cx = props.cx,
      cy = props.cy,
      innerRadius = props.innerRadius,
      outerRadius = props.outerRadius,
      startAngle = props.startAngle,
      endAngle = props.endAngle,
      fill = props.fill;
  return jsx("g", {
    children: jsx(Sector, {
      cx: cx,
      cy: cy,
      innerRadius: innerRadius - 5,
      outerRadius: outerRadius + 5,
      startAngle: startAngle,
      endAngle: endAngle,
      fill: fill
    }, void 0)
  }, void 0);
};

var getDataTotal = function getDataTotal(data) {
  if (!data || data.length === 0) return 0;
  var numbers = data.map(function (item) {
    return item.value;
  });
  return numbers.reduce(function (a, b) {
    return a + b;
  }, 0);
};

var styles$e = {"selectedLabelsList":"selected-labels-list-module_selectedLabelsList__tQfgL","title":"selected-labels-list-module_title__2XZe-","showMoreLabels":"selected-labels-list-module_showMoreLabels__3fKcb","buttonText":"selected-labels-list-module_buttonText__1q28i","buttonIcon":"selected-labels-list-module_buttonIcon__3WwSJ","labels":"selected-labels-list-module_labels__1T5mb","show":"selected-labels-list-module_show__Xsd1f","noFiltersSelected":"selected-labels-list-module_noFiltersSelected__3yQdO","label":"selected-labels-list-module_label__2YHte"};

var component$f = function component(props) {
  var _a, _b, _c;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showToggleButton = _useState2[0],
      setShowToggleButton = _useState2[1];

  var _useState3 = useState(0),
      _useState4 = _slicedToArray(_useState3, 2),
      minimumLabelHeight = _useState4[0],
      setMinimumLabelHeight = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      enableMultiline = _useState6[0],
      setEnableMultiline = _useState6[1];

  var windowSize = useWindowSize(300);

  var defaultStyling = function defaultStyling(className) {
    return props.styling.getStyle(styles$e, className);
  };

  var labelListRef = useRef(null);
  useEffect(function () {
    setListToggle();
  }, [props.items, windowSize, props.rowToggle]);

  var setListToggle = function setListToggle() {
    if (labelListRef && labelListRef.current) {
      var _labelListRef$current = labelListRef.current,
          labelListWidth = _labelListRef$current.clientWidth,
          labelListScrollWidth = _labelListRef$current.scrollWidth,
          labelListOverflowStyle = _labelListRef$current.style.overflow,
          labelListHeight = _labelListRef$current.clientHeight;

      if (labelListWidth < labelListScrollWidth) {
        setMinimumLabelHeight(labelListHeight);
        setShowToggleButton(true);
      } else if (labelListOverflowStyle === 'hidden' || labelListHeight <= minimumLabelHeight) {
        setShowToggleButton(false);
        setEnableMultiline(false);
      }
    }
  };

  return jsxs("div", Object.assign({
    className: defaultStyling('selectedLabelsList')
  }, {
    children: [jsxs("div", Object.assign({
      className: defaultStyling('title')
    }, {
      children: [jsxs("span", Object.assign({
        className: defaultStyling('titleText')
      }, {
        children: [(_a = props.texts) === null || _a === void 0 ? void 0 : _a.selectedFiltersTitle, " ", (((_b = props.items) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0 ? "(".concat(props.items.length, ")") : '']
      }), void 0), props.rowToggle && jsx("div", Object.assign({
        className: defaultStyling('showMoreLabels'),
        style: {
          visibility: showToggleButton ? 'visible' : 'hidden'
        }
      }, {
        children: jsxs("button", Object.assign({
          type: "button",
          onClick: function onClick() {
            return setEnableMultiline(!enableMultiline);
          }
        }, {
          children: [jsx("span", Object.assign({
            className: defaultStyling('buttonText')
          }, {
            children: enableMultiline ? props.texts.toggleMultilineLess : props.texts.toggleMultilineMore
          }), void 0), jsx("span", Object.assign({
            className: defaultStyling('buttonIcon'),
            style: {
              transform: enableMultiline ? 'rotate(-180deg)' : 'rotate(0deg)'
            }
          }, {
            children: props.showMoreIcon
          }), void 0)]
        }), void 0)
      }), void 0)]
    }), void 0), jsx("div", Object.assign({
      className: clsx(defaultStyling('labels'), (!props.rowToggle || enableMultiline) && defaultStyling('show')),
      ref: labelListRef
    }, {
      children: props.items && props.items.length > 0 ? props.items.map(function (item) {
        return jsx("div", Object.assign({
          className: defaultStyling('label')
        }, {
          children: jsx(InteractiveLabel, {
            id: item.id,
            label: item.label,
            icon: props.interactiveLabelIcon,
            onClick: props.onLabelClick
          }, void 0)
        }), item.id);
      }) : jsx("span", Object.assign({
        className: defaultStyling('noFiltersSelected')
      }, {
        children: (_c = props.texts) === null || _c === void 0 ? void 0 : _c.noFiltersSelected
      }), void 0)
    }), void 0)]
  }), void 0);
};

var SelectedLabelsList = withStyling(component$f);

var $find = arrayIteration.find;


var FIND = 'find';
var SKIPS_HOLES$1 = true;

// Shouldn't skip holes
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES$1 = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
_export({ target: 'Array', proto: true, forced: SKIPS_HOLES$1 }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);

// `FlattenIntoArray` abstract operation
// https://tc39.github.io/proposal-flatMap/#sec-FlattenIntoArray
var flattenIntoArray = function (target, original, source, sourceLen, start, depth, mapper, thisArg) {
  var targetIndex = start;
  var sourceIndex = 0;
  var mapFn = mapper ? functionBindContext(mapper, thisArg, 3) : false;
  var element;

  while (sourceIndex < sourceLen) {
    if (sourceIndex in source) {
      element = mapFn ? mapFn(source[sourceIndex], sourceIndex, original) : source[sourceIndex];

      if (depth > 0 && isArray(element)) {
        targetIndex = flattenIntoArray(target, original, element, toLength(element.length), targetIndex, depth - 1) - 1;
      } else {
        if (targetIndex >= 0x1FFFFFFFFFFFFF) throw TypeError('Exceed the acceptable array length');
        target[targetIndex] = element;
      }

      targetIndex++;
    }
    sourceIndex++;
  }
  return targetIndex;
};

var flattenIntoArray_1 = flattenIntoArray;

// `Array.prototype.flat` method
// https://tc39.es/ecma262/#sec-array.prototype.flat
_export({ target: 'Array', proto: true }, {
  flat: function flat(/* depthArg = 1 */) {
    var depthArg = arguments.length ? arguments[0] : undefined;
    var O = toObject(this);
    var sourceLen = toLength(O.length);
    var A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray_1(A, O, O, sourceLen, 0, depthArg === undefined ? 1 : toInteger(depthArg));
    return A;
  }
});

var iteratorClose = function (iterator) {
  var returnMethod = iterator['return'];
  if (returnMethod !== undefined) {
    return anObject(returnMethod.call(iterator)).value;
  }
};

// call something on iterator step with safe closing on error
var callWithSafeIterationClosing = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator);
    throw error;
  }
};

var iterators = {};

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype$1 = Array.prototype;

// check on default Array iterator
var isArrayIteratorMethod = function (it) {
  return it !== undefined && (iterators.Array === it || ArrayPrototype$1[ITERATOR] === it);
};

var ITERATOR$1 = wellKnownSymbol('iterator');

var getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR$1]
    || it['@@iterator']
    || iterators[classof(it)];
};

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
var arrayFrom = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var C = typeof this == 'function' ? this : Array;
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  if (mapping) mapfn = functionBindContext(mapfn, argumentsLength > 2 ? arguments[2] : undefined, 2);
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod != undefined && !(C == Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = iteratorMethod.call(O);
    next = iterator.next;
    result = new C();
    for (;!(step = next.call(iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = toLength(O.length);
    result = new C(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};

var ITERATOR$2 = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR$2] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

var checkCorrectnessOfIteration = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR$2] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
_export({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: arrayFrom
});

// this method was added to unscopables after implementation
// in popular engines, so it's moved to a separate module


// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('flat');

var correctPrototypeGetter = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});

var IE_PROTO$1 = sharedKey('IE_PROTO');
var ObjectPrototype = Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
var objectGetPrototypeOf = correctPrototypeGetter ? Object.getPrototypeOf : function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO$1)) return O[IE_PROTO$1];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectPrototype : null;
};

var ITERATOR$3 = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

var returnThis = function () { return this; };

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = objectGetPrototypeOf(objectGetPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = IteratorPrototype == undefined || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR$3].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if ( !has(IteratorPrototype, ITERATOR$3)) {
  createNonEnumerableProperty(IteratorPrototype, ITERATOR$3, returnThis);
}

var iteratorsCore = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};

var defineProperty$3 = objectDefineProperty.f;



var TO_STRING_TAG$2 = wellKnownSymbol('toStringTag');

var setToStringTag = function (it, TAG, STATIC) {
  if (it && !has(it = STATIC ? it : it.prototype, TO_STRING_TAG$2)) {
    defineProperty$3(it, TO_STRING_TAG$2, { configurable: true, value: TAG });
  }
};

var IteratorPrototype$1 = iteratorsCore.IteratorPrototype;





var returnThis$1 = function () { return this; };

var createIteratorConstructor = function (IteratorConstructor, NAME, next) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = objectCreate(IteratorPrototype$1, { next: createPropertyDescriptor(1, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false);
  iterators[TO_STRING_TAG] = returnThis$1;
  return IteratorConstructor;
};

var IteratorPrototype$2 = iteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS$1 = iteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR$4 = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis$2 = function () { return this; };

var defineIterator = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS$1 && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR$4]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS$1 && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME == 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = objectGetPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (IteratorPrototype$2 !== Object.prototype && CurrentIteratorPrototype.next) {
      if ( objectGetPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype$2) {
        if (objectSetPrototypeOf) {
          objectSetPrototypeOf(CurrentIteratorPrototype, IteratorPrototype$2);
        } else if (typeof CurrentIteratorPrototype[ITERATOR$4] != 'function') {
          createNonEnumerableProperty(CurrentIteratorPrototype, ITERATOR$4, returnThis$2);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true);
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (DEFAULT == VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    INCORRECT_VALUES_NAME = true;
    defaultIterator = function values() { return nativeIterator.call(this); };
  }

  // define iterator
  if ( IterablePrototype[ITERATOR$4] !== defaultIterator) {
    createNonEnumerableProperty(IterablePrototype, ITERATOR$4, defaultIterator);
  }
  iterators[NAME] = defaultIterator;

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        redefine(IterablePrototype, KEY, methods[KEY]);
      }
    } else _export({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS$1 || INCORRECT_VALUES_NAME }, methods);
  }

  return methods;
};

var charAt$1 = stringMultibyte.charAt;



var STRING_ITERATOR = 'String Iterator';
var setInternalState = internalState.set;
var getInternalState$1 = internalState.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: String(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState$1(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return { value: undefined, done: true };
  point = charAt$1(string, index);
  state.index += point.length;
  return { value: point, done: false };
});

var styles$f = {"grid":"table-module_grid__lrRq9","table":"table-module_table__3_o2R","alignLeft":"table-module_alignLeft__24ZT-","alignCenter":"table-module_alignCenter__1B8N2","alignRight":"table-module_alignRight__2-1Lw","headers":"table-module_headers__2C5gz","clickableColumn":"table-module_clickableColumn__3j5lx","sortNone":"table-module_sortNone__qFOrY","sortAsc":"table-module_sortAsc__3ZB0L","sortDesc":"table-module_sortDesc__2B6-7","sortIndicator":"table-module_sortIndicator__3XjNH","rows":"table-module_rows__3jQIo","loader":"table-module_loader__10LrH","emptyState":"table-module_emptyState__CAjKV","tooltip":"table-module_tooltip__3sqlV","checkboxColumn":"table-module_checkboxColumn__3Xj_9","checkedRow":"table-module_checkedRow__3LvT9"};

var flatten = function flatten(childrenObj) {
  var flat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var newFlat = [].concat(_toConsumableArray(flat), _toConsumableArray(React.Children.toArray(childrenObj)));

  if (childrenObj && childrenObj.props && childrenObj.props.children) {
    return flatten(childrenObj.props.children, newFlat);
  } // Exclude props with react components to prevent circular structure


  return newFlat.map(function (_a) {
    var key = _a.key,
        ref = _a.ref,
        type = _a.type,
        _b = _a.props,
        children = _b.children,
        title = _b.title,
        cell = _b.cell,
        sortIndicator = _b.sortIndicator,
        props = __rest(_b, ["children", "title", "cell", "sortIndicator"]);

    return {
      key: key,
      ref: ref,
      type: type,
      props: props
    };
  });
};

var styles$g = {"checkbox":"checkbox-module_checkbox__225C4","centerAlignLabel":"checkbox-module_centerAlignLabel__1ewdZ","label":"checkbox-module_label__DXLAd","input":"checkbox-module_input__12BY9"};

var component$g = function component(_a) {
  var name = _a.name,
      checked = _a.checked,
      disabled = _a.disabled,
      onChange = _a.onChange,
      onClick = _a.onClick,
      onLabelClick = _a.onLabelClick,
      styling = _a.styling,
      centerAlignLabel = _a.centerAlignLabel,
      fullWidth = _a.fullWidth,
      children = _a.children,
      rest = __rest(_a, ["name", "checked", "disabled", "onChange", "onClick", "onLabelClick", "styling", "centerAlignLabel", "fullWidth", "children"]);

  var fullWidthStyle = fullWidth ? {
    width: '100%'
  } : {
    width: 'auto'
  };
  var checkboxClassNames = clsx(styling.getStyle(styles$g, 'checkbox'));
  return jsxs("div", Object.assign({
    className: clsx(checkboxClassNames, centerAlignLabel && styling.getStyle(styles$g, 'centerAlignLabel')),
    style: fullWidthStyle
  }, rest, {
    children: [jsx("input", {
      "aria-checked": checked,
      checked: checked,
      className: styling.getStyle(styles$g, 'input'),
      disabled: disabled,
      id: name,
      name: name,
      onChange: onChange,
      type: "checkbox",
      onClick: onClick
    }, void 0), children && jsx("label", Object.assign({
      className: styling.getStyle(styles$g, 'label'),
      htmlFor: name,
      style: fullWidthStyle,
      onClick: onLabelClick
    }, {
      children: children
    }), void 0)]
  }), void 0);
};

var Checkbox = withStyling(component$g);

var component$h = function component(props) {
  var _useState = useState(),
      _useState2 = _slicedToArray(_useState, 2),
      clickedColumn = _useState2[0],
      setClickedColumn = _useState2[1];

  var _useState3 = useState(props.defaultSort),
      _useState4 = _slicedToArray(_useState3, 2),
      sorting = _useState4[0],
      setSorting = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      columns = _useState6[0],
      setColumns = _useState6[1];

  var _useState7 = useState([]),
      _useState8 = _slicedToArray(_useState7, 2),
      rows = _useState8[0],
      setRows = _useState8[1];

  var _useState9 = useState(undefined),
      _useState10 = _slicedToArray(_useState9, 2),
      isAllSelected = _useState10[0],
      setIsAllSelected = _useState10[1];

  var _useState11 = useState([]),
      _useState12 = _slicedToArray(_useState11, 2),
      selected = _useState12[0],
      setSelected = _useState12[1];

  var _useState13 = useState(false),
      _useState14 = _slicedToArray(_useState13, 2),
      isDragging = _useState14[0],
      setIsDragging = _useState14[1]; // Check prev props vs. next props to prevent multiple re-renders


  var previousData = usePrevious(props.dataSource);
  var previousColumns = usePrevious(columns);
  var columnsChanged = useMemo(function () {
    if (previousColumns) {
      return JSON.stringify(flatten(_toConsumableArray(columns))) !== JSON.stringify(flatten(_toConsumableArray(previousColumns)));
    }

    return false;
  }, [columns]);
  var dataChanged = useMemo(function () {
    return JSON.stringify(props.dataSource) !== JSON.stringify(previousData);
  }, [props.dataSource]);
  useEffect(function () {
    var propColumns = getColumns(props.children, props.onSort && handleSort, props.sortIndicator, sorting, props.hiddenColumnIds);
    setColumns(propColumns);
  }, [props.children, sorting, props.hiddenColumnIds]);
  useEffect(function () {
    if (columnsChanged) {
      ReactTooltip.rebuild();
    }
  }, [columns]);
  useEffect(function () {
    if (dataChanged) {
      setRows(props.dataSource);
      setSelected([]);
    }
  }, [props.dataSource]);
  useEffect(function () {
    if (isAllSelected !== undefined) {
      setRows(props.dataSource.map(function (row) {
        return Object.assign(Object.assign({}, row), {
          isSelected: isAllSelected
        });
      }));
    }
  }, [isAllSelected]);
  useEffect(function () {
    if (rows.length && isAllSelected === true && rows.find(function (row) {
      return !row.isSelected;
    })) {
      setIsAllSelected(undefined);
    }

    if (rows.length && rows.find(function (row) {
      return !row.isSelected;
    }) === undefined) {
      setIsAllSelected(true);
    }
  }, [rows]);
  useEffect(function () {
    if (props.onDrop && !isDragging && columns.length > 0) {
      props.onDrop(rows);
    }
  }, [isDragging]);
  var moveRow = useCallback(function (dragIndex, hoverIndex) {
    return __awaiter(void 0, void 0, void 0, /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var dragRow, newRows;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              dragRow = rows[dragIndex];
              newRows = update(rows, {
                $splice: [[dragIndex, 1], [hoverIndex, 0, dragRow]]
              });
              setIsDragging(true);
              _context.next = 5;
              return setRows(newRows);

            case 5:
              if (props.onDrag) {
                props.onDrag(newRows);
              }

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
  }, [rows]);

  var onRowDrop = function onRowDrop() {
    setIsDragging(false);
  };

  useEffect(function () {
    if ((clickedColumn === null || clickedColumn === void 0 ? void 0 : clickedColumn.id) && props.onSort) {
      var sortDirection = getSortingDirection(clickedColumn.id, sorting === null || sorting === void 0 ? void 0 : sorting.column, sorting === null || sorting === void 0 ? void 0 : sorting.direction);
      setSorting({
        column: clickedColumn.id,
        direction: sortDirection
      });
      props.onSort(clickedColumn.id, sortDirection);
    }
  }, [clickedColumn]);

  var handleSort = function handleSort(columnId) {
    return setClickedColumn({
      id: columnId
    });
  };

  var handleItemSelect = function handleItemSelect(index) {
    var position = selected.indexOf(index);
    var exists = position >= 0;
    var newSelection = selected;

    if (exists) {
      newSelection.splice(position, 1);
    } else {
      newSelection = [].concat(_toConsumableArray(newSelection), [index]);
    }

    if (props.onSelect) {
      props.onSelect(newSelection);
    }

    setSelected(newSelection);
    setRows(rows.map(function (row, rowIndex) {
      return Object.assign(Object.assign({}, row), {
        isSelected: rowIndex === index ? !row.isSelected : row.isSelected
      });
    }));
  };

  var handleItemSelectAll = function handleItemSelectAll() {
    var newSelection;

    if (isAllSelected) {
      newSelection = [];
    } else {
      newSelection = Array.from({
        length: props.dataSource.length
      }, function (_, index) {
        return index;
      });
    }

    if (props.onSelect !== undefined) {
      props.onSelect(newSelection);
    }

    setSelected(newSelection);
    setIsAllSelected(!isAllSelected);
  };

  var mapColumnCells = function mapColumnCells(item, index) {
    return jsx(Fragment, {
      children: columns.map(function (column, i) {
        var _column$props = column.props,
            field = _column$props.field,
            minWidth = _column$props.minWidth,
            maxWidth = _column$props.maxWidth,
            width = _column$props.width,
            cell = _column$props.cell,
            align = _column$props.align,
            className = _column$props.className,
            onTdClick = _column$props.onTdClick;
        var itemValue = stringPathToObjectValue(item, field);
        return jsxs(React.Fragment, {
          children: [i === 0 && props.onSelect !== undefined && jsx("td", Object.assign({
            align: align,
            role: "presentation",
            className: clsx(props.styling.getStyle(styles$f, 'checkboxColumn'), className),
            onClick: function onClick() {
              return handleItemSelect(index);
            }
          }, {
            children: jsx(Checkbox, {
              name: "Checkbox row ".concat(i),
              onChange: function onChange() {},
              checked: item.isSelected === true
            }, void 0)
          }), void 0), jsx("td", Object.assign({
            align: align,
            role: "presentation",
            className: clsx(className),
            style: {
              minWidth: minWidth,
              maxWidth: maxWidth,
              width: width
            },
            onClick: function onClick() {
              return onTdClick ? onTdClick(item) : props.onChange && props.onChange(item);
            }
          }, {
            children: cell ? cell(itemValue, index) : itemValue
          }), void 0)]
        }, i);
      })
    }, void 0);
  };

  if (!columns || columns.length === 0) {
    return jsx(Fragment, {}, void 0);
  }

  return jsxs("div", Object.assign({
    className: clsx(props.styling.getStyle(styles$f, 'grid'), props.isLoading && props.styling.getStyle(styles$f, 'isLoading')),
    style: {
      background: props.backgroundColor
    }
  }, {
    children: [props.isLoading && props.loadingSpinner && jsx("div", Object.assign({
      className: props.styling.getStyle(styles$f, 'loader')
    }, {
      children: props.loadingSpinner || 'No loading spinner defined'
    }), void 0), !props.isLoading && (!props.dataSource || props.dataSource.length === 0) && jsx("div", Object.assign({
      className: props.styling.getStyle(styles$f, 'emptyState')
    }, {
      children: props.emptyState
    }), void 0), jsxs("table", Object.assign({
      className: props.styling.getStyle(styles$f, 'table')
    }, {
      children: [jsx("thead", {
        children: jsxs("tr", Object.assign({
          className: props.styling.getStyle(styles$f, 'headers')
        }, {
          children: [props.onSelect !== undefined && jsx("th", Object.assign({
            className: props.styling.getStyle(styles$f, 'checkboxColumn'),
            onClick: handleItemSelectAll
          }, {
            children: jsx(Checkbox, {
              name: "Checkbox select all",
              onChange: function onChange() {},
              checked: isAllSelected === true
            }, void 0)
          }), void 0), columns.map(function (column) {
            return column;
          })]
        }), void 0)
      }, void 0), (!props.isLoading || props.isLoading && !props.loadingSpinner) && jsx("tbody", {
        children: jsx(DndProvider, Object.assign({
          backend: HTML5Backend
        }, {
          children: rows.map(function (item, index) {
            var _a;

            var customRowStyle = (_a = props.customRowsStyles) === null || _a === void 0 ? void 0 : _a.find(function (style) {
              return style.index === index;
            });
            return jsx(React.Fragment, {
              children: props.isDraggable && item && item.id !== null ? jsx(DraggableComponent, {
                id: item.id,
                index: index,
                element: jsx(Fragment, {
                  children: mapColumnCells(item, index)
                }, void 0),
                moveElement: moveRow,
                itemType: "tableRow",
                customStyles: props.styling.getStyle(styles$f, 'rows'),
                customRowStyle: customRowStyle,
                onDrop: onRowDrop
              }, item.id) :
              /*#__PURE__*/
              // eslint-disable-next-line
              createElement("tr", Object.assign({}, item.rowProps, {
                key: (item === null || item === void 0 ? void 0 : item.id) || index,
                role: "button",
                className: clsx(props.styling.getStyle(styles$f, 'rows'), customRowStyle && props.styling.getStyle(styles$f, customRowStyle.className), item.isSelected === true && props.styling.getStyle(styles$f, 'checkedRow'))
              }), mapColumnCells(item, index))
            }, index);
          })
        }), void 0)
      }, void 0)]
    }), void 0), jsx(ReactTooltip, {
      className: props.styling.getStyle(styles$f, 'tooltip'),
      place: props.tooltipPlace || 'bottom',
      effect: "solid",
      multiline: true
    }, void 0)]
  }), void 0);
};

var getColumns = function getColumns(children, onSort, sortIndicator, sorting, hiddenColumns) {
  var flattenedColumns = children.flat();
  var columns = flattenedColumns.filter(function (item) {
    var _a;

    return !!((_a = item === null || item === void 0 ? void 0 : item.props) === null || _a === void 0 ? void 0 : _a.field);
  }).map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, Object.assign(Object.assign({}, child.props), {
      key: index,
      onClick: !child.props.isNotSortable && onSort ? onSort : undefined,
      sortIndicator: sortIndicator,
      sortStatus: (sorting === null || sorting === void 0 ? void 0 : sorting.column) === child.props.sortField || !child.props.sortField && (sorting === null || sorting === void 0 ? void 0 : sorting.column) === child.props.field ? sorting === null || sorting === void 0 ? void 0 : sorting.direction : undefined
    }));
  });
  return columns.filter(function (column) {
    var columnIsHidden = column.props.isHidden || (hiddenColumns === null || hiddenColumns === void 0 ? void 0 : hiddenColumns.find(function (hiddenColumn) {
      return hiddenColumn === column.props.id;
    }));
    return !columnIsHidden;
  });
};

var getSortingDirection = function getSortingDirection(newColumnId, oldColumnId, oldDirection) {
  if (newColumnId !== oldColumnId) return 'ASC';
  if (!oldDirection) return 'ASC';
  if (oldDirection === 'ASC') return 'DESC';
  return undefined;
};

var columnHeaderComponent = function columnHeaderComponent(props) {
  return props.onClick && !props.isNotSortable ? jsx("th", Object.assign({
    style: {
      minWidth: props.minWidth,
      maxWidth: props.maxWidth,
      width: props.width
    },
    align: props.align || 'left',
    className: clsx(props.styling.getStyle(styles$f, 'clickableColumn'), props.className),
    onClick: function onClick() {
      return props.onClick && props.onClick(props.sortField || props.field);
    },
    role: "button",
    tabIndex: 0,
    onKeyDown: function onKeyDown(event) {
      return event.keyCode === 13 && props.onClick && props.onClick(props.sortField || props.field);
    }
  }, {
    children: jsxs("span", Object.assign({
      "data-tip": props.tooltip,
      className: props.styling.getStyle(styles$f, getCellAlignmentClass(props.align))
    }, {
      children: [jsx("span", Object.assign({
        className: props.styling.getStyle(styles$f, 'tableHeaderTitle')
      }, {
        children: props.title
      }), void 0), jsx("span", Object.assign({
        className: clsx(props.styling.getStyle(styles$f, 'sortIndicator'), props.sortIndicator && props.styling.getStyle(styles$f, 'sortIndicatorIcon'), getSortStyle(props.sortStatus, props.styling))
      }, {
        children: props.sortIndicator || '▾'
      }), void 0)]
    }), void 0)
  }), void 0) : jsx("th", Object.assign({
    className: clsx(props.className),
    style: {
      minWidth: props.minWidth,
      maxWidth: props.maxWidth,
      width: props.width
    },
    align: props.align || 'left'
  }, {
    children: jsx("span", Object.assign({
      "data-tip": props.tooltip,
      className: props.styling.getStyle(styles$f, getCellAlignmentClass(props.align))
    }, {
      children: props.title
    }), void 0)
  }), void 0);
};

var getSortStyle = function getSortStyle(sortStatus, styling) {
  if (sortStatus === 'ASC') {
    return styling.getStyle(styles$f, 'sortAsc');
  }

  if (sortStatus === 'DESC') {
    return styling.getStyle(styles$f, 'sortDesc');
  }

  return styling.getStyle(styles$f, 'sortNone');
};

var getCellAlignmentClass = function getCellAlignmentClass(alignment) {
  switch (alignment) {
    case 'left':
      return 'alignLeft';

    case 'right':
      return 'alignRight';

    case 'center':
      return 'alignCenter';

    case 'justify':
      return 'alignLeft';

    case 'char':
      return 'alignCenter';

    default:
      return 'alignLeft';
  }
};

var Table = withStyling(component$h);
var Column = withStyling(columnHeaderComponent);

var PRESETS;

(function (PRESETS) {
  PRESETS["SUCCESS"] = "success";
  PRESETS["ERROR"] = "error";
  PRESETS["WARNING"] = "warning";
  PRESETS["INFO"] = "info";
  PRESETS["DARK"] = "dark";
})(PRESETS || (PRESETS = {}));

var TRANSITIONS;

(function (TRANSITIONS) {
  TRANSITIONS["BOUNCE"] = "bounce";
  TRANSITIONS["SLIDE"] = "slide";
  TRANSITIONS["ZOOM"] = "zoom";
  TRANSITIONS["FLIP"] = "flip";
})(TRANSITIONS || (TRANSITIONS = {}));

var POSITIONS;

(function (POSITIONS) {
  POSITIONS["TOP_RIGHT"] = "top-right";
  POSITIONS["TOP_CENTER"] = "top-center";
  POSITIONS["TOP_LEFT"] = "top-left";
  POSITIONS["BOTTOM_RIGHT"] = "bottom-right";
  POSITIONS["BOTTOM_CENTER"] = "bottom-center";
  POSITIONS["BOTTOM_LEFT"] = "bottom-left";
})(POSITIONS || (POSITIONS = {}));

var getTransition = function getTransition(transition) {
  switch (transition) {
    case TRANSITIONS.BOUNCE:
      return Bounce;

    case TRANSITIONS.SLIDE:
      return Slide;

    case TRANSITIONS.ZOOM:
      return Zoom;

    case TRANSITIONS.FLIP:
      return Flip;

    default:
      return undefined;
  }
};
var getPosition = function getPosition(position) {
  switch (position) {
    case POSITIONS.TOP_RIGHT:
      return toast.POSITION.TOP_RIGHT;

    case POSITIONS.TOP_CENTER:
      return toast.POSITION.TOP_CENTER;

    case POSITIONS.TOP_LEFT:
      return toast.POSITION.TOP_LEFT;

    case POSITIONS.BOTTOM_RIGHT:
      return toast.POSITION.BOTTOM_RIGHT;

    case POSITIONS.BOTTOM_CENTER:
      return toast.POSITION.BOTTOM_CENTER;

    case POSITIONS.BOTTOM_LEFT:
      return toast.POSITION.BOTTOM_LEFT;

    default:
      return undefined;
  }
};
var getToast = function getToast(props) {
  var rest = __rest(props, []);

  switch (rest.preset) {
    case PRESETS.SUCCESS:
      return toast.success(rest.message, {
        transition: getTransition(rest.transition),
        position: getPosition(rest.position),
        draggable: rest.draggable,
        closeButton: rest.closeButton
      });

    case PRESETS.ERROR:
      return toast.error(rest.message, {
        transition: getTransition(rest.transition),
        position: getPosition(rest.position),
        draggable: rest.draggable,
        closeButton: rest.closeButton
      });

    case PRESETS.WARNING:
      return toast.warn(rest.message, {
        transition: getTransition(rest.transition),
        position: getPosition(rest.position),
        draggable: rest.draggable,
        closeButton: rest.closeButton
      });

    case PRESETS.INFO:
      return toast.info(rest.message, {
        transition: getTransition(rest.transition),
        position: getPosition(rest.position),
        draggable: rest.draggable,
        closeButton: rest.closeButton
      });

    case PRESETS.DARK:
      return toast.dark(rest.message, {
        transition: getTransition(rest.transition),
        position: getPosition(rest.position),
        draggable: rest.draggable,
        closeButton: rest.closeButton
      });

    default:
      return toast(rest.message, {
        transition: getTransition(rest.transition),
        position: getPosition(rest.position),
        draggable: rest.draggable,
        closeButton: rest.closeButton
      });
  }
};

var showToast = function showToast(props) {
  var rest = __rest(props, []);

  return getToast(Object.assign({}, rest));
};

var component$i = function component(props) {
  return jsx(ToastContainer$1, Object.assign({
    transition: getTransition(props.animation)
  }, props), void 0);
};

var ToastContainer = withStyling(component$i);

/* eslint-disable es/no-object-getownpropertynames -- safe */

var $getOwnPropertyNames = objectGetOwnPropertyNames.f;

var toString$1 = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return windowNames.slice();
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var f$5 = function getOwnPropertyNames(it) {
  return windowNames && toString$1.call(it) == '[object Window]'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};

var objectGetOwnPropertyNamesExternal = {
	f: f$5
};

var f$6 = wellKnownSymbol;

var wellKnownSymbolWrapped = {
	f: f$6
};

var defineProperty$4 = objectDefineProperty.f;

var defineWellKnownSymbol = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!has(Symbol, NAME)) defineProperty$4(Symbol, NAME, {
    value: wellKnownSymbolWrapped.f(NAME)
  });
};

var $forEach$1 = arrayIteration.forEach;

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE$1 = 'prototype';
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var setInternalState$1 = internalState.set;
var getInternalState$2 = internalState.getterFor(SYMBOL);
var ObjectPrototype$1 = Object[PROTOTYPE$1];
var $Symbol = global_1.Symbol;
var $stringify = getBuiltIn('JSON', 'stringify');
var nativeGetOwnPropertyDescriptor = objectGetOwnPropertyDescriptor.f;
var nativeDefineProperty = objectDefineProperty.f;
var nativeGetOwnPropertyNames = objectGetOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = objectPropertyIsEnumerable.f;
var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');
var WellKnownSymbolsStore$1 = shared('wks');
var QObject = global_1.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE$1] || !QObject[PROTOTYPE$1].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = descriptors && fails(function () {
  return objectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype$1, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype$1[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype$1) {
    nativeDefineProperty(ObjectPrototype$1, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap$1 = function (tag, description) {
  var symbol = AllSymbols[tag] = objectCreate($Symbol[PROTOTYPE$1]);
  setInternalState$1(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!descriptors) symbol.description = description;
  return symbol;
};

var isSymbol = useSymbolAsUid ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return Object(it) instanceof $Symbol;
};

var $defineProperty$1 = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype$1) $defineProperty$1(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPrimitive(P, true);
  anObject(Attributes);
  if (has(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!has(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (has(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = objectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach$1(keys, function (key) {
    if (!descriptors || $propertyIsEnumerable$1.call(properties, key)) $defineProperty$1(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? objectCreate(O) : $defineProperties(objectCreate(O), Properties);
};

var $propertyIsEnumerable$1 = function propertyIsEnumerable(V) {
  var P = toPrimitive(V, true);
  var enumerable = nativePropertyIsEnumerable.call(this, P);
  if (this === ObjectPrototype$1 && has(AllSymbols, P) && !has(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !has(this, P) || !has(AllSymbols, P) || has(this, HIDDEN) && this[HIDDEN][P] ? enumerable : true;
};

var $getOwnPropertyDescriptor$1 = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPrimitive(P, true);
  if (it === ObjectPrototype$1 && has(AllSymbols, key) && !has(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames$1 = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (!has(AllSymbols, key) && !has(hiddenKeys, key)) result.push(key);
  });
  return result;
};

var $getOwnPropertySymbols = function getOwnPropertySymbols(O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype$1;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach$1(names, function (key) {
    if (has(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || has(ObjectPrototype$1, key))) {
      result.push(AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!nativeSymbol) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : String(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype$1) setter.call(ObjectPrototypeSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (descriptors && USE_SETTER) setSymbolDescriptor(ObjectPrototype$1, tag, { configurable: true, set: setter });
    return wrap$1(tag, description);
  };

  redefine($Symbol[PROTOTYPE$1], 'toString', function toString() {
    return getInternalState$2(this).tag;
  });

  redefine($Symbol, 'withoutSetter', function (description) {
    return wrap$1(uid(description), description);
  });

  objectPropertyIsEnumerable.f = $propertyIsEnumerable$1;
  objectDefineProperty.f = $defineProperty$1;
  objectGetOwnPropertyDescriptor.f = $getOwnPropertyDescriptor$1;
  objectGetOwnPropertyNames.f = objectGetOwnPropertyNamesExternal.f = $getOwnPropertyNames$1;
  objectGetOwnPropertySymbols.f = $getOwnPropertySymbols;

  wellKnownSymbolWrapped.f = function (name) {
    return wrap$1(wellKnownSymbol(name), name);
  };

  if (descriptors) {
    // https://github.com/tc39/proposal-Symbol-description
    nativeDefineProperty($Symbol[PROTOTYPE$1], 'description', {
      configurable: true,
      get: function description() {
        return getInternalState$2(this).description;
      }
    });
    {
      redefine(ObjectPrototype$1, 'propertyIsEnumerable', $propertyIsEnumerable$1, { unsafe: true });
    }
  }
}

_export({ global: true, wrap: true, forced: !nativeSymbol, sham: !nativeSymbol }, {
  Symbol: $Symbol
});

$forEach$1(objectKeys(WellKnownSymbolsStore$1), function (name) {
  defineWellKnownSymbol(name);
});

_export({ target: SYMBOL, stat: true, forced: !nativeSymbol }, {
  // `Symbol.for` method
  // https://tc39.es/ecma262/#sec-symbol.for
  'for': function (key) {
    var string = String(key);
    if (has(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = $Symbol(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  },
  // `Symbol.keyFor` method
  // https://tc39.es/ecma262/#sec-symbol.keyfor
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol');
    if (has(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  },
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol, sham: !descriptors }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty$1,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor$1
});

_export({ target: 'Object', stat: true, forced: !nativeSymbol }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames$1,
  // `Object.getOwnPropertySymbols` method
  // https://tc39.es/ecma262/#sec-object.getownpropertysymbols
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
_export({ target: 'Object', stat: true, forced: fails(function () { objectGetOwnPropertySymbols.f(1); }) }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return objectGetOwnPropertySymbols.f(toObject(it));
  }
});

// `JSON.stringify` method behavior with symbols
// https://tc39.es/ecma262/#sec-json.stringify
if ($stringify) {
  var FORCED_JSON_STRINGIFY = !nativeSymbol || fails(function () {
    var symbol = $Symbol();
    // MS Edge converts symbol values to JSON as {}
    return $stringify([symbol]) != '[null]'
      // WebKit converts symbol values to JSON as null
      || $stringify({ a: symbol }) != '{}'
      // V8 throws on boxed symbols
      || $stringify(Object(symbol)) != '{}';
  });

  _export({ target: 'JSON', stat: true, forced: FORCED_JSON_STRINGIFY }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = [it];
      var index = 1;
      var $replacer;
      while (arguments.length > index) args.push(arguments[index++]);
      $replacer = replacer;
      if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
      if (!isArray(replacer)) replacer = function (key, value) {
        if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
        if (!isSymbol(value)) return value;
      };
      args[1] = replacer;
      return $stringify.apply(null, args);
    }
  });
}

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
if (!$Symbol[PROTOTYPE$1][TO_PRIMITIVE]) {
  createNonEnumerableProperty($Symbol[PROTOTYPE$1], TO_PRIMITIVE, $Symbol[PROTOTYPE$1].valueOf);
}
// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;

var defineProperty$5 = objectDefineProperty.f;


var NativeSymbol = global_1.Symbol;

if (descriptors && typeof NativeSymbol == 'function' && (!('description' in NativeSymbol.prototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : String(arguments[0]);
    var result = this instanceof SymbolWrapper
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };
  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  var symbolPrototype = SymbolWrapper.prototype = NativeSymbol.prototype;
  symbolPrototype.constructor = SymbolWrapper;

  var symbolToString = symbolPrototype.toString;
  var native = String(NativeSymbol('test')) == 'Symbol(test)';
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  defineProperty$5(symbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = isObject(this) ? this.valueOf() : this;
      var string = symbolToString.call(symbol);
      if (has(EmptyStringDescriptionStore, symbol)) return '';
      var desc = native ? string.slice(7, -1) : string.replace(regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  _export({ global: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}

var HAS_SPECIES_SUPPORT$3 = arrayMethodHasSpeciesSupport('slice');

var SPECIES$4 = wellKnownSymbol('species');
var nativeSlice = [].slice;
var max$2 = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
_export({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT$3 }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = toLength(O.length);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (typeof Constructor == 'function' && (Constructor === Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES$4];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === Array || Constructor === undefined) {
        return nativeSlice.call(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? Array : Constructor)(max$2(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});

// `Number.isNaN` method
// https://tc39.es/ecma262/#sec-number.isnan
_export({ target: 'Number', stat: true }, {
  isNaN: function isNaN(number) {
    // eslint-disable-next-line no-self-compare -- NaN check
    return number != number;
  }
});

var styles$h = {"checkboxContainer":"checkbox-group-module_checkboxContainer__1vZXZ","checkboxWrapper":"checkbox-group-module_checkboxWrapper__2Suw5","singleColumn":"checkbox-group-module_singleColumn__CQxMp","checkbox":"checkbox-group-module_checkbox__2QrYi","showMore":"checkbox-group-module_showMore__3V9Zm","showMoreText":"checkbox-group-module_showMoreText__3caWz","toggleIcon":"checkbox-group-module_toggleIcon__3fXwA","iconShowMore":"checkbox-group-module_iconShowMore__3QRtV"};

var sortItems = function sortItems(items) {
  var stringValues = items.find(function (item) {
    return Number.isNaN(Number(item.label));
  });

  if (stringValues) {
    return items.sort(function (a, b) {
      if (a.label < b.label) {
        return -1;
      }

      return +1;
    });
  }

  return items.sort(function (a, b) {
    return Number(a.label) - Number(b.label);
  });
};

var component$j = function component(props) {
  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      showMore = _useState2[0],
      setShowMore = _useState2[1];

  var _useState3 = useState([]),
      _useState4 = _slicedToArray(_useState3, 2),
      checkBoxItems = _useState4[0],
      setCheckboxItems = _useState4[1];

  var maxShown = props.maxShown || undefined;
  useEffect(function () {
    var items = props.sortByName ? sortItems(props.items) : props.items;
    setCheckboxItems(items.slice(0, !showMore ? maxShown : undefined));
  }, [props.items, props.maxShown, props.sortByName]);
  useEffect(function () {
    var items = props.sortByName ? sortItems(props.items) : props.items;

    if (!showMore) {
      setCheckboxItems(items.slice(0, maxShown));
    } else {
      setCheckboxItems(items);
    }
  }, [showMore]);
  var checkboxClassNames = clsx(props.styling.getStyle(styles$h, 'checkbox'), props.singleColumn && props.styling.getStyle(styles$h, 'singleColumn'), props.fullWidth && props.styling.getStyle(styles$h, 'fullWidth'));

  var handleCheckboxChange = function handleCheckboxChange(e) {
    var id = e.currentTarget.name.slice(props.groupName.length);
    var selectedItem = props.items.find(function (item) {
      var type = typeof item.id;
      var newId = type === 'number' ? Number(id) : id;
      return item.id === newId;
    });

    if (selectedItem) {
      props.onChange([selectedItem], e.currentTarget.checked);
    }
  };

  return jsxs("div", Object.assign({
    className: props.styling.getStyle(styles$h, 'checkboxContainer')
  }, {
    children: [jsx("div", Object.assign({
      className: props.styling.getStyle(styles$h, 'checkboxWrapper')
    }, {
      children: checkBoxItems.length > 0 && jsx("ul", Object.assign({
        className: clsx(props.singleColumn && props.styling.getStyle(styles$h, 'singleColumn'))
      }, {
        children: checkBoxItems.map(function (item, key) {
          return jsx("li", {
            children: jsx("div", Object.assign({
              className: clsx(checkboxClassNames, itemIsChecked(item, props.selectedItems) && props.styling.getStyle(styles$h, 'checked'))
            }, {
              children: jsx(Checkbox, Object.assign({
                name: "".concat(props.groupName + item.id),
                onChange: handleCheckboxChange,
                checked: itemIsChecked(item, props.selectedItems),
                propStyles: props.checkboxStyles,
                fullWidth: props.fullWidth,
                disabled: props.disabled || itemIsDisabled(item, props.disabledItems)
              }, {
                children: item.description ? jsxs(Fragment, {
                  children: [jsx("strong", {
                    children: item.label
                  }, void 0), jsx("span", {
                    children: item.description
                  }, void 0)]
                }, void 0) : jsx(Fragment, {
                  children: item.label
                }, void 0)
              }), void 0)
            }), void 0)
          }, key);
        })
      }), void 0)
    }), void 0), maxShown && props.items.length > maxShown && jsxs("button", Object.assign({
      className: props.styling.getStyle(styles$h, 'showMore'),
      type: "button",
      onClick: function onClick() {
        return setShowMore(!showMore);
      }
    }, {
      children: [props.showMoreIcon && jsx("span", Object.assign({
        className: clsx(props.styling.getStyle(styles$h, 'toggleIcon'), showMore && props.styling.getStyle(styles$h, 'iconShowMore'))
      }, {
        children: props.showMoreIcon
      }), void 0), jsx("span", Object.assign({
        className: props.styling.getStyle(styles$h, 'showMoreText')
      }, {
        children: !showMore ? jsx(Fragment, {
          children: props.showMoreLabel || 'Meer tonen'
        }, void 0) : jsx(Fragment, {
          children: props.showLessLabel || 'Minder tonen'
        }, void 0)
      }), void 0)]
    }), void 0)]
  }), void 0);
};

var itemIsChecked = function itemIsChecked(item, selectedItems) {
  if (!selectedItems) return false;
  return selectedItems.findIndex(function (selectedItem) {
    return selectedItem.id === item.id;
  }) > -1;
};

var itemIsDisabled = function itemIsDisabled(item, disabledItems) {
  return itemIsChecked(item, disabledItems);
};

var CheckboxGroup = withStyling(component$j);

var styles$i = {"combobox":"combobox-module_combobox__17MJ2","canBeCleared":"combobox-module_canBeCleared__qt2Ds","isFocused":"combobox-module_isFocused__kqCVB","disabled":"combobox-module_disabled__1TEMo","content":"combobox-module_content__1meoR","tagWrapper":"combobox-module_tagWrapper__2cV37","inputWrapper":"combobox-module_inputWrapper__22eLV","input":"combobox-module_input__EaFz2","icon":"combobox-module_icon__1k941","actionButtons":"combobox-module_actionButtons__jrYDR","clear":"combobox-module_clear__kkSTF","isVisible":"combobox-module_isVisible__1MEbW","rotated":"combobox-module_rotated__3P5EI","dropdown":"combobox-module_dropdown__2P21l","dropdownItem":"combobox-module_dropdownItem__ASia8","isSelected":"combobox-module_isSelected__3Gvem","isHovering":"combobox-module_isHovering__2BUNC","noResults":"combobox-module_noResults__bnnuW","loaderWrapper":"combobox-module_loaderWrapper__2M4zq","loader":"combobox-module_loader__1_Mp9","load8":"combobox-module_load8__1Wuar"};

var BACKSPACE_KEY_CODE = 8;
var TAB_KEY_CODE = 9;
var KEY_CODE_ARROW_UP = 38;
var KEY_CODE_ARROW_DOWN = 40;
var KEY_CODE_ENTER = 13;

var component$k = function component(props) {
  var placeholderText = props.placeholderText,
      inputValue = props.inputValue,
      showSelectedItemsInDropdown = props.showSelectedItemsInDropdown,
      items = props.items,
      selectedItems = props.selectedItems,
      tagElement = props.tagElement,
      maxHeight = props.maxHeight,
      _props$isLoadingPlace = props.isLoadingPlaceholder,
      isLoadingPlaceholder = _props$isLoadingPlace === void 0 ? 'Resultaten laden...' : _props$isLoadingPlace,
      _props$isLoading = props.isLoading,
      isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$disableMultise = props.disableMultiselect,
      disableMultiselect = _props$disableMultise === void 0 ? false : _props$disableMultise,
      _props$noResultsPlace = props.noResultsPlaceholder,
      noResultsPlaceholder = _props$noResultsPlace === void 0 ? 'Geen resultaten' : _props$noResultsPlace,
      _props$disableOpenOnF = props.disableOpenOnFocus,
      disableOpenOnFocus = _props$disableOpenOnF === void 0 ? false : _props$disableOpenOnF,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn;

  var _useState = useState(props.items),
      _useState2 = _slicedToArray(_useState, 2),
      itemsToShowInDropdown = _useState2[0],
      setItemsToShowInDropdown = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isDropdownOpen = _useState4[0],
      setIsDropdownOpen = _useState4[1];

  var _useState5 = useState(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isInputSelected = _useState6[0],
      setIsInputSelected = _useState6[1];

  var _useState7 = useState(false),
      _useState8 = _slicedToArray(_useState7, 2),
      clickedOnTag = _useState8[0],
      setClickedOnTag = _useState8[1];

  var _useState9 = useState(undefined),
      _useState10 = _slicedToArray(_useState9, 2),
      focusedTagInDropdown = _useState10[0],
      setFocusedTagInDropdown = _useState10[1];

  var comboboxRef = useRef(null);
  var contentRef = useRef(null);
  var inputRef = useRef(null);
  var inputWrapperRef = useRef(null);
  var dropdownRef = useRef(null);
  var actionButtonsRef = useRef(null);
  useEffect(function () {
    document.addEventListener('click', handleAnyClick);
    document.addEventListener('keydown', handleAnyKeyDown);
    return function () {
      document.removeEventListener('click', handleAnyClick);
      document.removeEventListener('keydown', handleAnyKeyDown);
    };
  });
  useEffect(function () {
    if (showSelectedItemsInDropdown || !selectedItems || selectedItems.length === 0) {
      setItemsToShowInDropdown(props.items);
    } else {
      var filteredSelectedItems = items.filter(function (item) {
        return !selectedItems.find(function (selectedItem) {
          return selectedItem.id === item.id;
        });
      });
      setItemsToShowInDropdown(filteredSelectedItems);
    }
  }, [props.items, props.selectedItems]);
  useEffect(function () {
    if (!itemsToShowInDropdown || itemsToShowInDropdown.length === 0) {
      setFocusedTagInDropdown(undefined);
    }
  }, [itemsToShowInDropdown]);
  useEffect(function () {
    setInputValueToSelectedValueIfNoMultiselect();
  }, [props.selectedItems]);
  useOutsideClick([comboboxRef, dropdownRef], function () {
    if (!clickedOnTag) {
      setIsInputSelected(false);
      setInputValueToSelectedValueIfNoMultiselect();
    }

    if (isDropdownOpen) {
      setIsDropdownOpen(false);
    }
  }); // If it is a single select, make sure the input value is set to the selected tag value. This function is used when blurring the element.

  var setInputValueToSelectedValueIfNoMultiselect = function setInputValueToSelectedValueIfNoMultiselect() {
    if (disableMultiselect) {
      if (selectedItems && selectedItems.length > 0) {
        if (inputValue !== selectedItems[0].label) {
          props.onChangeInputValue(selectedItems[0].label);
        }
      } else {
        props.onChangeInputValue('');
      }
    }
  };

  var scrollInDropdownWrapper = function scrollInDropdownWrapper(newIndex, forward) {
    var _a, _b;

    var dropdownItemSpan = (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.children[newIndex];
    var dropdownItemSpanBoundingRects = dropdownItemSpan === null || dropdownItemSpan === void 0 ? void 0 : dropdownItemSpan.getBoundingClientRect();
    var dropdownRefDivBoundingRects = (_b = dropdownRef.current) === null || _b === void 0 ? void 0 : _b.getBoundingClientRect();

    if (dropdownItemSpanBoundingRects && dropdownRefDivBoundingRects) {
      var itemIsOutsideOfDropdown = dropdownItemSpanBoundingRects.bottom > dropdownRefDivBoundingRects.bottom || dropdownItemSpanBoundingRects.top < dropdownRefDivBoundingRects.top;

      if (itemIsOutsideOfDropdown) {
        if (dropdownRef.current) {
          dropdownRef.current.style.pointerEvents = 'none';
          dropdownItemSpan === null || dropdownItemSpan === void 0 ? void 0 : dropdownItemSpan.scrollIntoView(!forward); // Make sure the mouse hover isn't activated when scrolling (and thus accedentally focussing on another tag).

          setTimeout(function () {
            if (dropdownRef.current) {
              dropdownRef.current.style.pointerEvents = 'auto';
            }
          }, 100);
        }
      }
    }
  };

  var selectNextTagInList = function selectNextTagInList(forward) {
    if (!itemsToShowInDropdown || itemsToShowInDropdown.length === 0) return;
    var selectedIndex = focusedTagInDropdown || focusedTagInDropdown === 0 ? focusedTagInDropdown : -1;
    var maxItems = itemsToShowInDropdown.length - 1;
    var nextIndex = selectedIndex + 1 > maxItems ? 0 : selectedIndex + 1;
    var previousIndex = selectedIndex - 1 < 0 ? maxItems : selectedIndex - 1;

    if (forward) {
      setFocusedTagInDropdown(nextIndex);
      scrollInDropdownWrapper(nextIndex, forward);
    } else {
      setFocusedTagInDropdown(previousIndex);
      scrollInDropdownWrapper(previousIndex, forward);
    }
  };

  var handleAnyKeyDown = function handleAnyKeyDown(e) {
    if (isInputSelected) {
      if (!isDropdownOpen) {
        setIsDropdownOpen(true);
      }

      if (e.keyCode === KEY_CODE_ARROW_UP && isDropdownOpen) {
        selectNextTagInList(false);
      }

      if (e.keyCode === KEY_CODE_ARROW_DOWN && isDropdownOpen) {
        selectNextTagInList(true);
      }

      if (e.keyCode === KEY_CODE_ENTER && (focusedTagInDropdown || focusedTagInDropdown === 0) && isDropdownOpen) {
        handleTagClick(itemsToShowInDropdown[focusedTagInDropdown].id);

        if (!disableMultiselect) {
          props.onChangeInputValue('');
        }

        if (itemsToShowInDropdown.length - 1 === focusedTagInDropdown) {
          selectNextTagInList(false);
        }
      }
    }
  };

  var checkIfClickedOnOtherInteractiveElement = function checkIfClickedOnOtherInteractiveElement(target) {
    var _a, _b;

    var contentRefIsClicked = contentRef.current !== target;
    var contentRefContainsTarget = (_a = contentRef.current) === null || _a === void 0 ? void 0 : _a.contains(target);
    var targetIsNotInInputWrapper = !((_b = inputRef.current) === null || _b === void 0 ? void 0 : _b.contains(target));
    var targetIsNotTagWrapper = contentRef.current !== target.parentNode;
    return contentRefIsClicked && contentRefContainsTarget && targetIsNotInInputWrapper && targetIsNotTagWrapper || false;
  };

  var checkIfClickedOnDropdownTag = function checkIfClickedOnDropdownTag(target) {
    var _a;

    var targetIsInDropdownRef = (_a = dropdownRef.current) === null || _a === void 0 ? void 0 : _a.contains(target);
    var targetIsNotDropdownWrapper = contentRef.current !== target.parentNode;
    return targetIsNotDropdownWrapper && targetIsInDropdownRef || false;
  };

  var checkIfClickeOnActionButton = function checkIfClickeOnActionButton(target) {
    var _a;

    var targetIsInActionButtonWrapper = (_a = actionButtonsRef.current) === null || _a === void 0 ? void 0 : _a.contains(target);
    var targetIsNotActionButtonWrapper = actionButtonsRef.current !== target;
    return targetIsInActionButtonWrapper && targetIsNotActionButtonWrapper || false;
  };

  var handleAnyClick = function handleAnyClick(e) {
    var clickedTarget = e.target;
    var clickOnTag = checkIfClickedOnOtherInteractiveElement(clickedTarget);
    var clickOnDropdownTag = checkIfClickedOnDropdownTag(clickedTarget);
    setClickedOnTag(clickOnTag && clickOnDropdownTag || false);
  };

  var handleWrapperClick = function handleWrapperClick(e) {
    var clickOnTag = checkIfClickedOnOtherInteractiveElement(e.target);
    var clickOnDropdownTag = checkIfClickedOnDropdownTag(e.target);
    var clickOnActionButton = checkIfClickeOnActionButton(e.target);

    if (!clickOnTag && !clickOnDropdownTag && !clickOnActionButton && inputRef && inputRef.current) {
      inputRef.current.focus();
      setIsInputSelected(true);

      if (!disableOpenOnFocus) {
        setIsDropdownOpen(true);
      }
    }
  };

  var handleDropdownIconClick = function handleDropdownIconClick() {
    var _a;

    if (isDropdownOpen) {
      setIsDropdownOpen(false);
    } else {
      setIsDropdownOpen(true);
    }

    setIsInputSelected(true);
    (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.focus();
  };

  var handleTagClick = function handleTagClick(id) {
    var itemIsSelected = checkIfItemSelected(id, selectedItems);
    var isClearable = !(itemIsSelected && disableClearable);
    var itemIsSelectedInputNot = itemIsSelected && !isInputSelected;

    if (isClearable) {
      props.onChange([id], !itemIsSelected);
    }

    if (!disableCloseOnSelect && !itemIsSelected) {
      setIsDropdownOpen(false);
    }

    if (!itemIsSelectedInputNot && inputRef && inputRef.current) {
      inputRef.current.focus();
    }

    if (maxHeight && inputRef && inputRef.current) {
      inputRef.current.scrollIntoView();
    }
  };

  var handleInputChange = function handleInputChange(e) {
    props.onChangeInputValue(e.currentTarget.value);
  };

  var handleInputKeyDown = function handleInputKeyDown(e) {
    if (e.keyCode === BACKSPACE_KEY_CODE) {
      if ((inputValue === '' || ((inputValue === null || inputValue === void 0 ? void 0 : inputValue.length) || 0) === 1 && disableMultiselect) && selectedItems && !disableClearable) {
        if (selectedItems[selectedItems.length - 1]) {
          props.onChange([selectedItems[selectedItems.length - 1].id], false);
        }
      }
    }

    if (e.keyCode === TAB_KEY_CODE) {
      setIsInputSelected(false);
      setIsDropdownOpen(false);
      setInputValueToSelectedValueIfNoMultiselect();
    }
  };

  var removeAllTags = function removeAllTags() {
    if (selectedItems && !disableClearable) {
      var allSelectedItemIds = selectedItems.map(function (selectedItem) {
        return selectedItem.id;
      });
      props.onChange(allSelectedItemIds, false);
      props.onChangeInputValue('');

      if (inputRef && inputRef.current) {
        inputRef.current.focus();
      }
    }
  };

  var classNames = clsx(props.styling.getStyle(styles$i, 'combobox'), isInputSelected && props.styling.getStyle(styles$i, 'isFocused'), props.disabled && props.styling.getStyle(styles$i, 'disabled'));

  var handleInputFocus = function handleInputFocus() {
    setIsInputSelected(true);

    if (!disableOpenOnFocus && !isDropdownOpen) {
      setIsDropdownOpen(true);
    }
  };

  var renderMainCombobox = jsxs("div", Object.assign({
    className: classNames,
    role: "none",
    onClick: handleWrapperClick,
    onKeyDown: function onKeyDown() {
      return handleWrapperClick;
    },
    ref: comboboxRef,
    tabIndex: -1
  }, {
    children: [jsxs("div", Object.assign({
      className: props.styling.getStyle(styles$i, 'content'),
      ref: contentRef,
      style: maxHeight ? {
        maxHeight: maxHeight,
        overflowX: 'scroll'
      } : undefined
    }, {
      children: [props.icon && jsx("span", Object.assign({
        className: props.styling.getStyle(styles$i, 'icon')
      }, {
        children: props.icon
      }), void 0), selectedItems && !disableMultiselect && tagElement && tagElement(selectedItems, handleTagClick).map(function (singleTagElement) {
        return jsx("div", Object.assign({
          className: props.styling.getStyle(styles$i, 'tagWrapper')
        }, {
          children: singleTagElement
        }), singleTagElement.props.id);
      }), jsx("div", Object.assign({
        className: props.styling.getStyle(styles$i, 'inputWrapper'),
        ref: inputWrapperRef
      }, {
        children: jsx("input", {
          ref: inputRef,
          className: clsx(props.styling.getStyle(styles$i, 'input'), props.disabled && props.styling.getStyle(styles$i, 'disabled')),
          onFocus: handleInputFocus,
          type: "text",
          id: props.id,
          name: "fname",
          placeholder: placeholderText,
          onChange: handleInputChange,
          onKeyDown: handleInputKeyDown,
          value: inputValue,
          style: {
            width: props.wideInput ? 500 : undefined
          },
          autoComplete: "off",
          "data-lpignore": "true",
          disabled: props.disabled
        }, "input_".concat(props.id))
      }), void 0)]
    }), void 0), jsxs("div", Object.assign({
      className: props.styling.getStyle(styles$i, 'actionButtons'),
      ref: actionButtonsRef
    }, {
      children: [jsx("button", Object.assign({
        type: "button",
        onClick: removeAllTags,
        className: clsx(props.styling.getStyle(styles$i, 'clear'), !disableClearable && selectedItems && selectedItems.length > 0 && props.styling.getStyle(styles$i, 'canBeCleared'), isInputSelected && props.styling.getStyle(styles$i, 'isVisible')),
        tabIndex: -1
      }, {
        children: jsx("span", Object.assign({
          className: props.styling.getStyle(styles$i, 'icon')
        }, {
          children: DEFAULT_CLOSE_SVG
        }), void 0)
      }), void 0), !props.disabled && jsx("button", Object.assign({
        type: "button",
        onClick: handleDropdownIconClick,
        className: props.styling.getStyle(styles$i, 'popup'),
        tabIndex: -1
      }, {
        children: jsx("span", Object.assign({
          className: clsx(props.styling.getStyle(styles$i, 'icon'), isDropdownOpen && props.styling.getStyle(styles$i, 'rotated'))
        }, {
          children: DEFAULT_ARROW_SVG$1
        }), void 0)
      }), void 0), isLoading && isDropdownOpen && jsx("span", Object.assign({
        className: props.styling.getStyle(styles$i, 'loaderWrapper')
      }, {
        children: jsx("span", {
          className: props.styling.getStyle(styles$i, 'loader')
        }, void 0)
      }), void 0)]
    }), void 0)]
  }), props.id);

  return jsx(Popper, Object.assign({
    id: "combobox",
    toggleButton: renderMainCombobox,
    isOpen: isDropdownOpen,
    placementOffset: [0, 4],
    toggleButtonFullWidth: true,
    updatePopper: selectedItems,
    zIndex: props.zIndex
  }, {
    children: jsx(Fragment, {
      children: !props.showResultsOnEmptySearch && !inputValue ? jsx(Fragment, {}, void 0) : jsx("div", Object.assign({
        role: "none",
        className: props.styling.getStyle(styles$i, 'dropdown'),
        onClick: handleWrapperClick,
        onKeyDown: function onKeyDown() {
          return handleWrapperClick;
        },
        ref: dropdownRef,
        tabIndex: -1
      }, {
        children: itemsToShowInDropdown && itemsToShowInDropdown.length > 0 && !isLoading ? itemsToShowInDropdown.map(function (item, index) {
          return jsx("span", Object.assign({
            role: "button",
            className: clsx(props.styling.getStyle(styles$i, 'dropdownItem'), checkIfItemSelected(item.id, selectedItems) && props.styling.getStyle(styles$i, 'isSelected'), focusedTagInDropdown === index && props.styling.getStyle(styles$i, 'isHovering')),
            onKeyDown: function onKeyDown() {
              return handleTagClick(item.id);
            },
            onClick: function onClick() {
              return handleTagClick(item.id);
            },
            onMouseEnter: function onMouseEnter() {
              return setFocusedTagInDropdown(index);
            },
            tabIndex: -1
          }, {
            children: item.label
          }), item.id);
        }) : jsx("span", Object.assign({
          className: props.styling.getStyle(styles$i, 'noResults')
        }, {
          children: isLoading ? isLoadingPlaceholder : noResultsPlaceholder
        }), void 0)
      }), void 0)
    }, void 0)
  }), void 0);
};

var checkIfItemSelected = function checkIfItemSelected(id, selectedItems) {
  if (!selectedItems || selectedItems.length === 0) return false;
  return selectedItems.findIndex(function (selectedItem) {
    return selectedItem.id === id;
  }) > -1;
};

var DEFAULT_ARROW_SVG$1 = jsx("svg", Object.assign({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: jsx("path", {
    d: "M17 10L7 10L12 15L17 10Z",
    fill: "black"
  }, void 0)
}), void 0);

var DEFAULT_CLOSE_SVG = jsx("svg", Object.assign({
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, {
  children: jsx("path", {
    d: "M17 8.00714L15.9929 7L12 10.9929L8.00714 7L7 8.00714L10.9929 12L7 15.9929L8.00714 17L12 13.0071L15.9929 17L17 15.9929L13.0071 12L17 8.00714Z",
    fill: "black"
  }, void 0)
}), void 0);

var Combobox = withStyling(component$k);

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'minder dan een seconde',
    other: 'minder dan {{count}} seconden'
  },
  xSeconds: {
    one: '1 seconde',
    other: '{{count}} seconden'
  },
  halfAMinute: 'een halve minuut',
  lessThanXMinutes: {
    one: 'minder dan een minuut',
    other: 'minder dan {{count}} minuten'
  },
  xMinutes: {
    one: 'een minuut',
    other: '{{count}} minuten'
  },
  aboutXHours: {
    one: 'ongeveer 1 uur',
    other: 'ongeveer {{count}} uur'
  },
  xHours: {
    one: '1 uur',
    other: '{{count}} uur'
  },
  xDays: {
    one: '1 dag',
    other: '{{count}} dagen'
  },
  aboutXWeeks: {
    one: 'ongeveer 1 week',
    other: 'ongeveer {{count}} weken'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weken'
  },
  aboutXMonths: {
    one: 'ongeveer 1 maand',
    other: 'ongeveer {{count}} maanden'
  },
  xMonths: {
    one: '1 maand',
    other: '{{count}} maanden'
  },
  aboutXYears: {
    one: 'ongeveer 1 jaar',
    other: 'ongeveer {{count}} jaar'
  },
  xYears: {
    one: '1 jaar',
    other: '{{count}} jaar'
  },
  overXYears: {
    one: 'meer dan 1 jaar',
    other: 'meer dan {{count}} jaar'
  },
  almostXYears: {
    one: 'bijna 1 jaar',
    other: 'bijna {{count}} jaar'
  }
};
function formatDistance(token, count, options) {
  options = options || {};
  var result;

  if (typeof formatDistanceLocale[token] === 'string') {
    result = formatDistanceLocale[token];
  } else if (count === 1) {
    result = formatDistanceLocale[token].one;
  } else {
    result = formatDistanceLocale[token].other.replace('{{count}}', count);
  }

  if (options.addSuffix) {
    if (options.comparison > 0) {
      return 'over ' + result;
    } else {
      return result + ' geleden';
    }
  }

  return result;
}

function buildFormatLongFn(args) {
  return function (dirtyOptions) {
    var options = dirtyOptions || {};
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats = {
  full: 'EEEE d MMMM y',
  long: 'd MMMM y',
  medium: 'd MMM y',
  short: 'dd-MM-y'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};

var formatRelativeLocale = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: 'P'
};
function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale[token];
}

function buildLocalizeFn(args) {
  return function (dirtyIndex, dirtyOptions) {
    var options = dirtyOptions || {};
    var context = options.context ? String(options.context) : 'standalone';
    var valuesArray;

    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;

      var _width = options.width ? String(options.width) : args.defaultWidth;

      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }

    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    return valuesArray[index];
  };
}

var eraValues = {
  narrow: ['v.C.', 'n.C.'],
  abbreviated: ['v.Chr.', 'n.Chr.'],
  wide: ['voor Christus', 'na Christus']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['K1', 'K2', 'K3', 'K4'],
  wide: ['1e kwartaal', '2e kwartaal', '3e kwartaal', '4e kwartaal']
};
var monthValues = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['jan.', 'feb.', 'mrt.', 'apr.', 'mei', 'jun.', 'jul.', 'aug.', 'sep.', 'okt.', 'nov.', 'dec.'],
  wide: ['januari', 'februari', 'maart', 'april', 'mei', 'juni', 'juli', 'augustus', 'september', 'oktober', 'november', 'december']
};
var dayValues = {
  narrow: ['Z', 'M', 'D', 'W', 'D', 'V', 'Z'],
  short: ['zo', 'ma', 'di', 'wo', 'do', 'vr', 'za'],
  abbreviated: ['zon', 'maa', 'din', 'woe', 'don', 'vri', 'zat'],
  wide: ['zondag', 'maandag', 'dinsdag', 'woensdag', 'donderdag', 'vrijdag', 'zaterdag']
};
var dayPeriodValues = {
  narrow: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: 'AM',
    pm: 'PM',
    midnight: 'middernacht',
    noon: 'het middaguur',
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
};

function ordinalNumber(dirtyNumber) {
  var number = Number(dirtyNumber);
  return number + 'e';
}

var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function (quarter) {
      return Number(quarter) - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide'
  })
};

function buildMatchPatternFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var matchResult = string.match(args.matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);

    if (!parseResult) {
      return null;
    }

    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function buildMatchFn(args) {
  return function (dirtyString, dirtyOptions) {
    var string = String(dirtyString);
    var options = dirtyOptions || {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);

    if (!matchResult) {
      return null;
    }

    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var value;

    if (Object.prototype.toString.call(parsePatterns) === '[object Array]') {
      value = findIndex(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    } else {
      value = findKey(parsePatterns, function (pattern) {
        return pattern.test(matchedString);
      });
    }

    value = args.valueCallback ? args.valueCallback(value) : value;
    value = options.valueCallback ? options.valueCallback(value) : value;
    return {
      value: value,
      rest: string.slice(matchedString.length)
    };
  };
}

function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
}

function findIndex(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
}

var matchOrdinalNumberPattern = /^(\d+)e?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
};
var parseEraPatterns = {
  any: [/^v/, /^n/]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^jan/i, /^feb/i, /^m(r|a)/i, /^apr/i, /^mei/i, /^jun/i, /^jul/i, /^aug/i, /^sep/i, /^okt/i, /^nov/i, /^dec/i]
};
var matchDayPatterns = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
};
var parseDayPatterns = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
};
var matchDayPeriodPatterns = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
};
var match$1 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function (value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function (index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};

/**
 * @type {Locale}
 * @category Locales
 * @summary Dutch locale.
 * @language Dutch
 * @iso-639-2 nld
 * @author Jorik Tangelder [@jtangelder]{@link https://github.com/jtangelder}
 * @author Ruben Stolk [@rubenstolk]{@link https://github.com/rubenstolk}
 * @author Lode Vanhove [@bitcrumb]{@link https://github.com/bitcrumb}
 * @author Edo Rivai [@edorivai]{@link https://github.com/edorivai}
 * @author Niels Keurentjes [@curry684]{@link https://github.com/curry684}
 * @author Stefan Vermaas [@stefanvermaas]{@link https://github.com/stefanvermaas}
 */

var locale = {
  code: 'nl',
  formatDistance: formatDistance,
  formatLong: formatLong,
  formatRelative: formatRelative,
  localize: localize,
  match: match$1,
  options: {
    weekStartsOn: 1
    /* Monday */
    ,
    firstWeekContainsDate: 4
  }
};

var dateFormatList = function dateFormatList(initDateFormatOption, includeTime) {
  var dateList = includeTime ? dateFormatsWithTime : dateFormats$1;
  return [initDateFormatOption].concat(_toConsumableArray(dateList));
};
var dateFormats$1 = ['dd MM yyyy', 'dd MMM yyyy', 'dd MMMM yyyy ', 'dd', 'dd MM', 'dd MMM', 'dd MMMM', 'dd-MM-yyyy', 'dd-MMM-yyyy', 'dd-MMMM-yyyy', 'dd-MM', 'dd-MMM', 'dd-MMMM', 'dd/MM/yyyy', 'dd/MMM/yyyy', 'dd/MMMM/yyyy', 'dd/MM', 'dd/MMM', 'dd/MMMM', 'dd MM yy', 'dd MMM yy', 'dd MMMM yy', 'dd-MM-yy', 'dd-MMM-yy', 'dd-MMMM-yy', 'dd/MM/yy', 'dd/MMM/yy', 'dd/MMMM/yy'];
var dateFormatsWithTime = ['dd MM yyyy - HH:mm', 'dd MMM yyyy - HH:mm', 'dd MMMM yyyy - HH:mm', 'dd - HH:mm', 'dd MM - HH:mm', 'dd MMM - HH:mm', 'dd MMMM - HH:mm', 'dd-MM-yyyy - HH:mm', 'dd-MMM-yyyy - HH:mm', 'dd-MMMM-yyyy - HH:mm', 'dd-MM - HH:mm', 'dd-MMM - HH:mm', 'dd-MMMM - HH:mm', 'dd/MM/yyyy - HH:mm', 'dd/MMM/yyyy - HH:mm', 'dd/MMMM/yyyy - HH:mm', 'dd/MM - HH:mm', 'dd/MMM - HH:mm', 'dd/MMMM - HH:mm', 'dd MM yy - HH:mm', 'dd MMM yy - HH:mm', 'dd MMMM yy - HH:mm', 'dd-MM-yy - HH:mm', 'dd-MMM-yy - HH:mm', 'dd-MMMM-yy - HH:mm', 'dd/MM/yy - HH:mm', 'dd/MMM/yy - HH:mm', 'dd/MMMM/yy - HH:mm', 'dd MM yyyy - HHmm', 'dd MMM yyyy - HHmm', 'dd MMMM yyyy - HHmm', 'dd - HHmm', 'dd MM - HHmm', 'dd MMM - HHmm', 'dd MMMM - HHmm', 'dd-MM-yyyy - HHmm', 'dd-MMM-yyyy - HHmm', 'dd-MMMM-yyyy - HHmm', 'dd-MM - HHmm', 'dd-MMM - HHmm', 'dd-MMMM - HHmm', 'dd/MM/yyyy - HHmm', 'dd/MMM/yyyy - HHmm', 'dd/MMMM/yyyy - HHmm', 'dd/MM - HHmm', 'dd/MMM - HHmm', 'dd/MMMM - HHmm', 'dd MM yy - HHmm', 'dd MMM yy - HHmm', 'dd MMMM yy - HHmm', 'dd-MM-yy - HHmm', 'dd-MMM-yy - HHmm', 'dd-MMMM-yy - HHmm', 'dd/MM/yy - HHmm', 'dd/MMM/yy - HHmm', 'dd/MMMM/yy - HHmm', 'dd MM yyyy HHmm', 'dd MMM yyyy HHmm', 'dd MMMM yyyy HHmm', 'dd HHmm', 'dd MM HHmm', 'dd MMM HHmm', 'dd MMMM HHmm', 'dd-MM-yyyy HHmm', 'dd-MMM-yyyy HHmm', 'dd-MMMM-yyyy HHmm', 'dd-MM HHmm', 'dd-MMM HHmm', 'dd-MMMM HHmm', 'dd/MM/yyyy HHmm', 'dd/MMM/yyyy HHmm', 'dd/MMMM/yyyy HHmm', 'dd/MM HHmm', 'dd/MMM HHmm', 'dd/MMMM HHmm', 'dd MM yy HHmm', 'dd MMM yy HHmm', 'dd MMMM yy HHmm', 'dd-MM-yy HHmm', 'dd-MMM-yy HHmm', 'dd-MMMM-yy HHmm', 'dd/MM/yy HHmm', 'dd/MMM/yy HHmm', 'dd/MMMM/yy HHmm', 'dd MM yyyy HH:mm', 'dd MMM yyyy HH:mm', 'dd MMMM yyyy HH:mm', 'dd HH:mm', 'dd MM HH:mm', 'dd MMM HH:mm', 'dd MMMM HH:mm', 'dd-MM-yyyy HH:mm', 'dd-MMM-yyyy HH:mm', 'dd-MMMM-yyyy HH:mm', 'dd-MM HH:mm', 'dd-MMM HH:mm', 'dd-MMMM HH:mm', 'dd/MM/yyyy HH:mm', 'dd/MMM/yyyy HH:mm', 'dd/MMMM/yyyy HH:mm', 'dd/MM HH:mm', 'dd/MMM HH:mm', 'dd/MMMM HH:mm', 'dd MM yy HH:mm', 'dd MMM yy HH:mm', 'dd MMMM yy HH:mm', 'dd-MM-yy HH:mm', 'dd-MMM-yy HH:mm', 'dd-MMMM-yy HH:mm', 'dd/MM/yy HH:mm', 'dd/MMM/yy HH:mm', 'dd/MMMM/yy HH:mm'];

var styles$j = {"DatePickerComponent":"date-picker-module_DatePickerComponent__x1O5J","fullWidth":"date-picker-module_fullWidth__DE2f3"};

registerLocale('nl', locale);

var component$l = function component(props) {
  var _useState = useState(null),
      _useState2 = _slicedToArray(_useState, 2),
      startDate = _useState2[0],
      setStartDate = _useState2[1];

  var initDateFormat = props.initDateFormat || "dd MMM yyyy".concat(props.includeTimeInput ? ' - HH:mm' : '');
  var timeFormat = props.timeFormat || 'HH:mm';
  var timeInputLabel = props.timeInputLabel || 'Tijd';

  var value = props.value,
      onChange = props.onChange,
      otherProps = __rest(props, ["value", "onChange"]);

  useEffect(function () {
    setStartDate(getDateValue(value));
  }, [value]);

  var handleChange = function handleChange(date) {
    onChange(props.id, date);
  };

  return jsx("div", Object.assign({
    className: clsx(props.styling.getStyle(styles$j, 'DatePickerComponent'))
  }, {
    children: jsx(DatePickerComponent, Object.assign({}, otherProps, {
      id: props.id,
      onChange: handleChange,
      selected: startDate,
      placeholderText: props.placeholderText,
      showMonthDropdown: props.includeMonthDropdown,
      showYearDropdown: props.includeYearDropdown,
      showTimeInput: props.includeTimeInput,
      timeIntervals: props.timeIntervals,
      timeFormat: timeFormat,
      timeInputLabel: timeInputLabel,
      dateFormat: dateFormatList(initDateFormat, props.includeTimeInput),
      locale: "nl",
      minDate: props.minDate ? props.minDate : new Date(1900, 1, 1),
      open: props.neverOpen ? false : undefined,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }), void 0)
  }), void 0);
};

var getDateValue = function getDateValue(date) {
  if (!date) return null;

  if (typeof date === 'object') {
    return date;
  }

  return new Date(date);
};

var DatePicker = withStyling(component$l);

var styles$k = {"formGroup":"form-group-module_formGroup__hde6O","withSeparator":"form-group-module_withSeparator__KDobi","info":"form-group-module_info__2IRzo","title":"form-group-module_title__2kYSX","description":"form-group-module_description__2Ez88","formRows":"form-group-module_formRows__1vPS7"};

var component$m = function component(props) {
  var _a;

  var marginBottom = (_a = props.marginBottom) !== null && _a !== void 0 ? _a : 40;
  var marginStyles = Object.assign({
    marginBottom: "".concat(marginBottom, "px")
  }, props.separator && {
    paddingBottom: "".concat(marginBottom, "px")
  });
  var mainClassNames = clsx(props.className, props.styling.getStyle(styles$k, 'formGroup'), props.separator && props.styling.getStyle(styles$k, 'withSeparator'));
  return jsxs("div", Object.assign({
    className: mainClassNames,
    style: marginStyles
  }, {
    children: [(props.title || props.description) && jsxs("div", Object.assign({
      className: props.styling.getStyle(styles$k, 'info')
    }, {
      children: [jsx("span", Object.assign({
        className: props.styling.getStyle(styles$k, 'title')
      }, {
        children: props.title
      }), void 0), jsx("span", Object.assign({
        className: props.styling.getStyle(styles$k, 'description')
      }, {
        children: props.description
      }), void 0)]
    }), void 0), jsx("div", Object.assign({
      className: props.styling.getStyle(styles$k, 'formRows')
    }, {
      children: props.children
    }), void 0)]
  }), void 0);
};

var FormGroup = withStyling(component$m);

var styles$l = {"formItem":"form-item-module_formItem__3MfO_","errors":"form-item-module_errors__1iUa9","field":"form-item-module_field__2vK9-","extraInfo":"form-item-module_extraInfo__27NWi","helperText":"form-item-module_helperText__3lEup","isInvalid":"form-item-module_isInvalid__UrenP"};

var styles$m = {"formLabel":"form-label-module_formLabel__24Ogk","label":"form-label-module_label__iWb32","invalid":"form-label-module_invalid__O6s40","inlineLabel":"form-label-module_inlineLabel__z0WQI","optional":"form-label-module_optional__wtVBi","required":"form-label-module_required__3OfTt","inlineIndicator":"form-label-module_inlineIndicator__2BJuD","tooltip":"form-label-module_tooltip__1SuzP"};

var styles$n = {"formTooltip":"form-tooltip-module_formTooltip__24AcY","tooltip":"form-tooltip-module_tooltip__2MRQf","maxWidth":"form-tooltip-module_maxWidth__2F6FJ"};

var component$n = function component(props) {
  return jsxs("div", Object.assign({
    className: props.styling.getStyle(styles$n, 'formTooltip')
  }, {
    children: [jsx("span", Object.assign({
      "data-tip": props.content,
      "data-for": props.id,
      className: props.styling.getStyle(styles$n, 'tooltip')
    }, {
      children: renderHoveritem(props.hoverItem)
    }), void 0), jsx(ReactTooltip, {
      id: props.id,
      place: "top",
      effect: "solid",
      multiline: true,
      className: props.styling.getStyle(styles$n, 'maxWidth')
    }, void 0)]
  }), void 0);
};

var renderHoveritem = function renderHoveritem(hoverItem) {
  if (hoverItem) {
    return hoverItem;
  }

  return jsx("span", {
    children: "Info"
  }, void 0);
};

var FormTooltip = withStyling(component$n);

var component$o = function component(props) {
  var indicatorText = props.customIndicatorText || defaultIndicatorText(props.isRequired, props.showOptionalDefault);
  var requiredClassname = clsx(props.isRequired ? props.styling.getStyle(styles$m, 'required') : props.styling.getStyle(styles$m, 'optional'));

  var renderLabel = function renderLabel(title, id, hasChildLabel) {
    var inlineIndicatorText = props.optionalLabelInline && indicatorText && jsx("span", Object.assign({
      className: clsx(requiredClassname, styles$m.inlineIndicator)
    }, {
      children: indicatorText
    }), void 0);

    if (hasChildLabel) {
      return jsx(Fragment, {
        children: jsxs("span", Object.assign({
          className: clsx(props.styling.getStyle(styles$m, 'label'), props.styling.getStyle(styles$m, 'inlineLabel'))
        }, {
          children: [title, inlineIndicatorText]
        }), void 0)
      }, void 0);
    }

    return jsxs("label", Object.assign({
      className: clsx(props.styling.getStyle(styles$m, 'label'), props.styling.getStyle(styles$m, 'inlineLabel')),
      htmlFor: id
    }, {
      children: [title, inlineIndicatorText]
    }), void 0);
  };

  return jsxs("span", Object.assign({
    className: clsx(props.styling.getStyle(styles$m, 'formLabel'), props.className)
  }, {
    children: [renderLabel(props.title, props.id, props.hasChildLabel), !props.optionalLabelInline && indicatorText && jsx("span", Object.assign({
      className: requiredClassname
    }, {
      children: indicatorText
    }), void 0), props.tooltip && jsx("div", Object.assign({
      className: props.styling.getStyle(styles$m, 'tooltip')
    }, {
      children: jsx(FormTooltip, {
        id: "".concat(props.id, "-tooltip"),
        content: props.tooltip,
        hoverItem: props.tooltipHoverItem,
        propStyles: props.tooltipStyles
      }, void 0)
    }), void 0)]
  }), void 0);
};

var defaultIndicatorText = function defaultIndicatorText(isRequired, showOptionalDefault) {
  if (isRequired && !showOptionalDefault) {
    return '*';
  }

  if (!isRequired && showOptionalDefault) {
    return 'Optioneel';
  }

  return '';
};

var FormLabel = withStyling(component$o);

var component$p = function component(props) {
  var _a, _b;

  var childrenHaveOwnId = props.children.props.id;
  var minWidth = (_a = props.minWidth) !== null && _a !== void 0 ? _a : '180px';
  var maxWidth = (_b = props.maxWidth) !== null && _b !== void 0 ? _b : '100%';
  var formItemStyles = Object.assign({
    flex: "1 0 ".concat(minWidth),
    maxWidth: maxWidth
  }, props.marginBottom && {
    marginBottom: "".concat(props.marginBottom, "px")
  });
  var mainClassNames = clsx(props.className, props.styling.getStyle(styles$l, 'formItem'), props.errors && props.styling.getStyle(styles$l, 'isInvalid'));

  var renderErrors = function renderErrors(errors) {
    if (!errors) return '';
    return jsx("span", Object.assign({
      className: props.styling.getStyle(styles$l, 'errors')
    }, {
      children: errors.map(function (error, index) {
        return jsx("span", {
          children: error
        }, index);
      })
    }), void 0);
  };

  return jsxs("div", Object.assign({
    className: mainClassNames,
    style: formItemStyles
  }, {
    children: [props.label && jsx(FormLabel, {
      id: props.id,
      title: props.label,
      hasChildLabel: props.hasChildLabel,
      isRequired: props.isRequired,
      tooltip: props.tooltip,
      propStyles: props.labelStyles,
      showOptionalDefault: props.showOptionalDefault,
      customIndicatorText: props.customIndicatorText,
      tooltipHoverItem: props.tooltipHoverItem,
      className: props.labelClassName,
      tooltipStyles: props.tooltipStyles,
      optionalLabelInline: props.optionalLabelInline
    }, void 0), jsx("div", Object.assign({
      className: props.styling.getStyle(styles$l, 'field')
    }, {
      children: childrenHaveOwnId ? props.children : /*#__PURE__*/React.cloneElement(props.children, {
        id: props.id
      })
    }), void 0), (props.errors || props.helperText || props.safeSpaceForErrors) && jsxs("div", Object.assign({
      className: props.styling.getStyle(styles$l, 'extraInfo')
    }, {
      children: [renderErrors(props.errors), props.helperText && jsx("span", Object.assign({
        className: props.styling.getStyle(styles$l, 'helperText')
      }, {
        children: props.helperText
      }), void 0)]
    }), void 0)]
  }), void 0);
};

var FormItem = withStyling(component$p);

// `Array.isArray` method
// https://tc39.es/ecma262/#sec-array.isarray
_export({ target: 'Array', stat: true }, {
  isArray: isArray
});

var styles$o = {"formRow":"form-row-module_formRow__YLbAa","formRowWrapper":"form-row-module_formRowWrapper__JTO1v","formRowItem":"form-row-module_formRowItem__3rtlS"};

var component$q = function component(props) {
  var _a;

  var gutter = props.gutter || props.gutter === 0 ? props.gutter / 2 : 8;
  var children = Array.isArray(props.children) ? props.children : [props.children];
  var formItemMinWidth = (_a = props.formItemMinWidth) !== null && _a !== void 0 ? _a : '180px';
  var formRowItemStyles = {
    padding: "".concat(gutter, "px"),
    flex: "1 0 ".concat(formItemMinWidth)
  };
  return jsx("div", Object.assign({
    className: clsx(props.styling.getStyle(styles$o, 'formRow'), props.className)
  }, {
    children: jsx("div", Object.assign({
      className: props.styling.getStyle(styles$o, 'formRowWrapper'),
      style: {
        margin: "-".concat(gutter, "px")
      }
    }, {
      children: children.filter(Boolean).map(function (child, index) {
        return jsx("div", Object.assign({
          className: props.styling.getStyle(styles$o, 'formRowItem'),
          style: formRowItemStyles
        }, {
          children: child
        }), index);
      })
    }), void 0)
  }), void 0);
};

var FormRow = withStyling(component$q);

var styles$p = {"numberFieldInput":"number-field-module_numberFieldInput__3_JQj","error":"number-field-module_error__1o4qz","readOnly":"number-field-module_readOnly__3y7Ph","disabled":"number-field-module_disabled__3J0Ri","withIconLeft":"number-field-module_withIconLeft__1UpfR","withIconRight":"number-field-module_withIconRight__3DCOQ","icon":"number-field-module_icon__RhQ0Z","iconRight":"number-field-module_iconRight__Cm4gI"};

var component$r = function component(_a) {
  var ariaLabel = _a.ariaLabel,
      icon = _a.icon,
      _a$iconPosition = _a.iconPosition,
      iconPosition = _a$iconPosition === void 0 ? 'left' : _a$iconPosition,
      isInvalid = _a.isInvalid,
      emptyWhenZero = _a.emptyWhenZero,
      styling = _a.styling,
      wrapperClassName = _a.wrapperClassName,
      iconClassName = _a.iconClassName,
      css = _a.css,
      inputElementProps = __rest(_a, ["ariaLabel", "icon", "iconPosition", "isInvalid", "emptyWhenZero", "styling", "wrapperClassName", "iconClassName", "css"]);

  var inputClassNames = clsx(isInvalid && styling.getStyle(styles$p, 'error'), inputElementProps.readOnly && styling.getStyle(styles$p, 'readOnly'), inputElementProps.disabled && styling.getStyle(styles$p, 'disabled'), icon && (iconPosition === 'left' ? styling.getStyle(styles$p, 'withIconLeft') : styling.getStyle(styles$p, 'withIconRight')), inputElementProps.className);
  var inputWrapperClassNames = clsx(styling.getStyle(styles$p, 'numberFieldInput'), wrapperClassName);
  var iconClassNames = clsx(styling.getStyle(styles$p, 'icon'), iconPosition === 'right' && styling.getStyle(styles$p, 'iconRight'), iconClassName);
  return jsxs("div", Object.assign({
    className: inputWrapperClassNames
  }, {
    children: [jsx("input", Object.assign({}, inputElementProps, {
      "aria-label": ariaLabel || inputElementProps['aria-label'],
      className: inputClassNames,
      type: "number",
      value: emptyWhenZero && !inputElementProps.value ? '' : inputElementProps.value
    }), void 0), icon && jsx("span", Object.assign({
      className: iconClassNames
    }, {
      children: icon
    }), void 0)]
  }), void 0);
};

var NumberField = withStyling(component$r);

var styles$q = {"radioButton":"radio-button-module_radioButton___ye8x","label":"radio-button-module_label__1ezKZ","input":"radio-button-module_input__2Finh"};

var component$s = function component(_a) {
  var id = _a.id,
      checked = _a.checked,
      groupName = _a.groupName,
      fullWidth = _a.fullWidth,
      styling = _a.styling,
      children = _a.children,
      rest = __rest(_a, ["id", "checked", "groupName", "fullWidth", "styling", "children"]);

  var fullWidthStyle = fullWidth ? {
    width: '100%'
  } : {
    width: 'auto'
  };
  var radioButtonClassNames = clsx(styling.getStyle(styles$q, 'radioButton'));
  return jsxs("div", Object.assign({
    className: radioButtonClassNames,
    style: fullWidthStyle
  }, {
    children: [jsx("input", Object.assign({}, rest, {
      "aria-checked": checked,
      checked: checked,
      className: styling.getStyle(styles$q, 'input'),
      id: id,
      value: id,
      name: groupName,
      type: "radio"
    }), void 0), jsx("label", Object.assign({
      className: styling.getStyle(styles$q, 'label'),
      htmlFor: id,
      style: fullWidthStyle
    }, {
      children: children
    }), void 0)]
  }), void 0);
};

var RadioButton = withStyling(component$s);

var styles$r = {"radioButtonContainer":"radio-button-group-module_radioButtonContainer__2NiT9","radioButtonWrapper":"radio-button-group-module_radioButtonWrapper__OUkzc","radioButton":"radio-button-group-module_radioButton__2H0SY","singleColumn":"radio-button-group-module_singleColumn__27bBx","fullWidth":"radio-button-group-module_fullWidth__1l5EN"};

var component$t = function component(props) {
  var radioButtonClassnames = clsx(props.styling.getStyle(styles$r, 'radioButton'), props.singleColumn && props.styling.getStyle(styles$r, 'singleColumn'), props.fullWidth && props.styling.getStyle(styles$r, 'fullWidth'));

  var handleRadioButtonChange = function handleRadioButtonChange(e) {
    var selectedItem = props.items.find(function (item) {
      return item.id === e.currentTarget.id;
    });

    if (selectedItem) {
      props.onChange(selectedItem);
    }
  };

  return jsx("div", Object.assign({
    className: props.styling.getStyle(styles$r, 'radioButtonContainer')
  }, {
    children: jsx("div", Object.assign({
      className: props.styling.getStyle(styles$r, 'radioButtonWrapper')
    }, {
      children: props.items.length > 0 && props.items.map(function (item, key) {
        var _a, _b;

        return jsx("div", Object.assign({
          className: clsx(radioButtonClassnames, item.id === ((_a = props.selectedItem) === null || _a === void 0 ? void 0 : _a.id) && props.styling.getStyle(styles$r, 'checked'))
        }, {
          children: jsx(RadioButton, Object.assign({
            id: item.id,
            groupName: props.id,
            checked: item.id === ((_b = props.selectedItem) === null || _b === void 0 ? void 0 : _b.id),
            onChange: handleRadioButtonChange,
            propStyles: props.radioButtonStyles,
            fullWidth: props.fullWidth,
            disabled: props.disabled || itemIsDisabled$1(item, props.disabledItems)
          }, {
            children: item.description ? jsxs(Fragment, {
              children: [jsx("strong", {
                children: item.label
              }, void 0), jsx("span", {
                children: item.description
              }, void 0)]
            }, void 0) : jsx(Fragment, {
              children: item.label
            }, void 0)
          }), void 0)
        }), key);
      })
    }), void 0)
  }), void 0);
};

var RadioButtonGroup = withStyling(component$t);

var itemIsDisabled$1 = function itemIsDisabled(item, disabledItems) {
  if (!disabledItems) return false;
  return disabledItems.findIndex(function (disabledItem) {
    return disabledItem.id === item.id;
  }) > -1;
};

var styles$s = {"select":"select-module_select__2ce3t","fixCrossBrowserStyling":"select-module_fixCrossBrowserStyling__3AyGl","customSelect":"select-module_customSelect__1OkYZ","sizeMedium":"select-module_sizeMedium__2TRYu","sizeBig":"select-module_sizeBig__2s9td","fullWidth":"select-module_fullWidth__1SOaP","error":"select-module_error__3MOTi","placeholder":"select-module_placeholder__3RjJ_","option":"select-module_option__2N6mS"};

var component$u = function component(_a) {
  var onChange = _a.onChange,
      className = _a.className,
      disabled = _a.disabled,
      disabledOptions = _a.disabledOptions,
      value = _a.value,
      placeholder = _a.placeholder,
      hidePlaceholderStyle = _a.hidePlaceholderStyle,
      options = _a.options,
      isInvalid = _a.isInvalid,
      styling = _a.styling,
      fixCrossBrowserStyling = _a.fixCrossBrowserStyling,
      wrapperClassName = _a.wrapperClassName,
      enableCustom = _a.enableCustom,
      fullWidth = _a.fullWidth,
      _a$multiple = _a.multiple,
      multiple = _a$multiple === void 0 ? false : _a$multiple,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'small' : _a$size,
      rest = __rest(_a, ["onChange", "className", "disabled", "disabledOptions", "value", "placeholder", "hidePlaceholderStyle", "options", "isInvalid", "styling", "fixCrossBrowserStyling", "wrapperClassName", "enableCustom", "fullWidth", "multiple", "size"]);

  var _useState = useState(0),
      _useState2 = _slicedToArray(_useState, 2),
      forceUpdate = _useState2[0],
      setForceUpdate = _useState2[1];

  var selectClassnames = clsx(className, isInvalid && styling.getStyle(styles$s, 'error'), styling.getStyle(styles$s, 'select'), size !== 'small' && styling.getStyle(styles$s, "size".concat(capitalize(size))), fullWidth && styling.getStyle(styles$s, 'fullWidth'), fixCrossBrowserStyling && styling.getStyle(styles$s, 'fixCrossBrowserStyling'), !value && !hidePlaceholderStyle && styling.getStyle(styles$s, 'placeholder'));
  var wrapperClassnames = clsx(wrapperClassName, styling.getStyle(styles$s, 'customSelect'), disabled && styling.getStyle(styles$s, 'disabled'));
  var values = value || placeholder;

  var handleChange = function handleChange(event) {
    if (multiple) {
      // The counter makes sure the multiselect list is rerendered. On mobile this wil then update the selected items counter. Otherwise this won't work.
      setForceUpdate(forceUpdate + 1);
    }

    if (onChange) onChange(event);
  };

  var renderSelect = function renderSelect() {
    return jsxs("select", Object.assign({}, rest, {
      className: selectClassnames,
      onChange: handleChange,
      value: values,
      multiple: multiple,
      disabled: disabled
    }, {
      children: [placeholder && jsx("option", Object.assign({
        value: placeholder,
        className: styling.getStyle(styles$s, 'placeholder')
      }, {
        children: placeholder
      }), placeholder), options.map(function (option) {
        return jsx("option", Object.assign({
          value: option.id,
          className: styling.getStyle(styles$s, 'option'),
          disabled: optionIsDisabled(option, disabledOptions)
        }, {
          children: option.label
        }), "".concat(option.id, "-").concat(forceUpdate));
      })]
    }), void 0);
  };

  return enableCustom ? jsx("div", Object.assign({
    className: wrapperClassnames
  }, {
    children: renderSelect()
  }), void 0) : renderSelect();
};

var Select = withStyling(component$u);

var optionIsDisabled = function optionIsDisabled(option, disabledOptions) {
  if (!disabledOptions) return false;
  return disabledOptions.findIndex(function (disabledOption) {
    return disabledOption.id === option.id;
  }) > -1;
};

var floor$3 = Math.floor;
var replace = ''.replace;
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
var getSubstitution = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace.call(replacement, symbols, function (match, ch) {
    var capture;
    switch (ch.charAt(0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return str.slice(0, position);
      case "'": return str.slice(tailPos);
      case '<':
        capture = namedCaptures[ch.slice(1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor$3(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? ch.charAt(1) : captures[f - 1] + ch.charAt(1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};

var REPLACE = wellKnownSymbol('replace');
var max$3 = Math.max;
var min$4 = Math.min;

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegexpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = searchValue == undefined ? undefined : searchValue[REPLACE];
      return replacer !== undefined
        ? replacer.call(searchValue, O, replaceValue)
        : nativeReplace.call(String(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      if (
        typeof replaceValue === 'string' &&
        replaceValue.indexOf(UNSAFE_SUBSTITUTE) === -1 &&
        replaceValue.indexOf('$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, this, string, replaceValue);
        if (res.done) return res.value;
      }

      var rx = anObject(this);
      var S = String(string);

      var functionalReplace = typeof replaceValue === 'function';
      if (!functionalReplace) replaceValue = String(replaceValue);

      var global = rx.global;
      if (global) {
        var fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }
      var results = [];
      while (true) {
        var result = regexpExecAbstract(rx, S);
        if (result === null) break;

        results.push(result);
        if (!global) break;

        var matchStr = String(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = String(result[0]);
        var position = max$3(min$4(toInteger(result.index), S.length), 0);
        var captures = [];
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) captures.push(maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = [matched].concat(captures, position, S);
          if (namedCaptures !== undefined) replacerArgs.push(namedCaptures);
          var replacement = String(replaceValue.apply(undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += S.slice(nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }
      return accumulatedResult + S.slice(nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);

var UrlField = function UrlField(props) {
  var onBlur = function onBlur(e) {
    var value = e.target.value;
    fireChange(value);
  };

  var onKeyDown = function onKeyDown(e) {
    if (props.changeOnReturnKey && e.key === 'Enter') {
      var target = e.target;
      var value = target.value;
      fireChange(value);
    }
  };

  var fireChange = function fireChange(value) {
    var result = value.replace('http://', '');
    result = result.replace('https://', '');
    result = result.replace('www.', '');
    props.onCustomChange(result, props.id || '');
  };

  return jsx(TextField, Object.assign({}, props, {
    propStyles: props.styles,
    onBlur: onBlur,
    onKeyDown: onKeyDown
  }), void 0);
};

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
_export({ target: 'String', proto: true, forced: stringHtmlForced('small') }, {
  small: function small() {
    return createHtml(this, 'small', '', '');
  }
});

var getAlignment = function getAlignment(alignment) {
  if (alignment === 'start') return 'flex-start';
  if (alignment === 'end') return 'flex-end';
  if (alignment === 'center') return 'center';
  if (alignment === 'space-between') return 'space-between';
  if (alignment === 'space-around') return 'space-around';
  if (alignment === 'space-evenly') return 'space-evenly';
  return 'stretch';
};

var styles$t = {"flexCol":"flex-column-module_flexCol__3Sfjg","col-xs-1":"flex-column-module_col-xs-1__1QKuR","col-xs-2":"flex-column-module_col-xs-2__8YM-N","col-xs-3":"flex-column-module_col-xs-3__2tZD1","col-xs-4":"flex-column-module_col-xs-4__37bve","col-xs-5":"flex-column-module_col-xs-5__doOOZ","col-xs-6":"flex-column-module_col-xs-6__1ql-T","col-xs-7":"flex-column-module_col-xs-7__rAlH6","col-xs-8":"flex-column-module_col-xs-8__2lbE1","col-xs-9":"flex-column-module_col-xs-9__1SmRh","col-xs-10":"flex-column-module_col-xs-10__6Dfjh","col-xs-11":"flex-column-module_col-xs-11__1-nWV","col-xs-12":"flex-column-module_col-xs-12__EDBul","col-s-1":"flex-column-module_col-s-1__v66Uu","col-s-2":"flex-column-module_col-s-2__20YLN","col-s-3":"flex-column-module_col-s-3__1F6lI","col-s-4":"flex-column-module_col-s-4__2YuD8","col-s-5":"flex-column-module_col-s-5__1ZKRN","col-s-6":"flex-column-module_col-s-6__vp6sP","col-s-7":"flex-column-module_col-s-7__1WP-P","col-s-8":"flex-column-module_col-s-8__1SHDg","col-s-9":"flex-column-module_col-s-9__OqIHI","col-s-10":"flex-column-module_col-s-10__BmXjg","col-s-11":"flex-column-module_col-s-11__3xVu_","col-s-12":"flex-column-module_col-s-12__1y6F3","col-m-1":"flex-column-module_col-m-1__28dxP","col-m-2":"flex-column-module_col-m-2__cl-v3","col-m-3":"flex-column-module_col-m-3__3bIu-","col-m-4":"flex-column-module_col-m-4__2arkd","col-m-5":"flex-column-module_col-m-5__2XbHf","col-m-6":"flex-column-module_col-m-6__12QU1","col-m-7":"flex-column-module_col-m-7__1HVIT","col-m-8":"flex-column-module_col-m-8__B3EZL","col-m-9":"flex-column-module_col-m-9__2tGkY","col-m-10":"flex-column-module_col-m-10__2CxIb","col-m-11":"flex-column-module_col-m-11__3FhDx","col-m-12":"flex-column-module_col-m-12__1S_Oe","col-l-1":"flex-column-module_col-l-1__2you3","col-l-2":"flex-column-module_col-l-2__1g9dM","col-l-3":"flex-column-module_col-l-3__DcWJL","col-l-4":"flex-column-module_col-l-4__ojkCP","col-l-5":"flex-column-module_col-l-5__3oR5e","col-l-6":"flex-column-module_col-l-6__35TkP","col-l-7":"flex-column-module_col-l-7__31_x0","col-l-8":"flex-column-module_col-l-8__3Y0te","col-l-9":"flex-column-module_col-l-9__2d5yw","col-l-10":"flex-column-module_col-l-10__WuO3X","col-l-11":"flex-column-module_col-l-11__3O_1u","col-l-12":"flex-column-module_col-l-12__36A3e","col-xl-1":"flex-column-module_col-xl-1__16p4y","col-xl-2":"flex-column-module_col-xl-2__HISKK","col-xl-3":"flex-column-module_col-xl-3__1-Yxt","col-xl-4":"flex-column-module_col-xl-4__3zySr","col-xl-5":"flex-column-module_col-xl-5__8O9UJ","col-xl-6":"flex-column-module_col-xl-6__2pX6I","col-xl-7":"flex-column-module_col-xl-7__1S0-_","col-xl-8":"flex-column-module_col-xl-8__1bp1Z","col-xl-9":"flex-column-module_col-xl-9__3cSKn","col-xl-10":"flex-column-module_col-xl-10__1edLP","col-xl-11":"flex-column-module_col-xl-11__3KhO4","col-xl-12":"flex-column-module_col-xl-12__bFTnf"};

var component$v = function component(props) {
  var columns = props.columns,
      className = props.className;
  var gutter = props.gutter && props.gutter !== 0 ? props.gutter / 2 : 8;
  var children = Array.isArray(props.children) ? props.children : [props.children];
  var columnStyling = clsx(props.styling.getStyle(styles$t, 'flexCol'), columns && [columns.extraLarge && props.styling.getStyle(styles$t, "col-xl-".concat(columns.extraLarge)), columns.extraSmall && props.styling.getStyle(styles$t, "col-xs-".concat(columns.extraSmall)), columns.large && props.styling.getStyle(styles$t, "col-l-".concat(columns.large)), columns.medium && props.styling.getStyle(styles$t, "col-m-".concat(columns.medium)), columns.small && props.styling.getStyle(styles$t, "col-s-".concat(columns.small))], className);
  var styling = {
    padding: "".concat(gutter, "px"),
    alignItems: getAlignment(props.verticalAlign),
    justifyContent: getAlignment(props.horizontalAlign)
  };
  return jsx("div", Object.assign({
    className: columnStyling,
    style: styling
  }, {
    children: children
  }), void 0);
};

var FlexColumn = withStyling(component$v);

var styles$u = {"flexGrid":"flex-grid-module_flexGrid__3LLyr","flexGridWrapper":"flex-grid-module_flexGridWrapper__1BK59","flexItem":"flex-grid-module_flexItem__32BAF","fixedWidthCol-":"flex-grid-module_fixedWidthCol-__Ir9ib","fixedWidthCol-1":"flex-grid-module_fixedWidthCol-1__3usbD","fixedWidthCol-2":"flex-grid-module_fixedWidthCol-2__l7vNF","fixedWidthCol-3":"flex-grid-module_fixedWidthCol-3__Sykc_","fixedWidthCol-4":"flex-grid-module_fixedWidthCol-4__3-3Vs","fixedWidthCol-5":"flex-grid-module_fixedWidthCol-5__X4rMB","fixedWidthCol-6":"flex-grid-module_fixedWidthCol-6__3hwuu"};

var MAX_AMOUNT_OF_FIXED_COLUMNS = 6;
var DEFAULT_GUTTER_WIDTH = 16;

var component$w = function component(props) {
  var gutter = getGutter(props.gutter);
  var columns = limitColumns(props.isFluid, props.columns);
  var itemWidth = columns ? 100 / columns : 20;
  var itemMinWidth = props.itemMinWidth ? props.itemMinWidth : 0;
  var children = Array.isArray(props.children) ? props.children.filter(Boolean) : [props.children].filter(Boolean);
  var itemStyle = props.isFluid ? {
    padding: "".concat(gutter.vertical, "px ").concat(gutter.horizontal, "px"),
    flex: "1 1 ".concat(itemWidth, "%"),
    minWidth: "".concat(itemMinWidth, "px")
  } : {
    padding: "".concat(gutter.vertical, "px ").concat(gutter.horizontal, "px")
  };
  var flexItemClassnames = clsx(props.flexItemClassName, props.styling.getStyle(styles$u, 'flexItem'), props.isFluid || props.styling.getStyle(styles$u, "fixedWidthCol-".concat(columns)));
  return jsx("div", Object.assign({
    className: clsx(props.styling.getStyle(styles$u, 'flexGrid'), props.className)
  }, {
    children: jsx("div", Object.assign({
      className: clsx(props.styling.getStyle(styles$u, 'flexGridWrapper'), props.wrapperClassName),
      style: {
        margin: "-".concat(gutter.vertical, "px -").concat(gutter.horizontal, "px")
      }
    }, {
      children: children.map(function (child, index) {
        return jsx("div", Object.assign({
          className: flexItemClassnames,
          style: itemStyle
        }, {
          children: child
        }), index);
      })
    }), void 0)
  }), void 0);
};

var getGutter = function getGutter(gutter) {
  var _a, _b;

  var verticalGutter;
  var horizontalGutter;

  if (!gutter && gutter !== 0) {
    verticalGutter = DEFAULT_GUTTER_WIDTH;
    horizontalGutter = DEFAULT_GUTTER_WIDTH;
  } else if (typeof gutter === 'number') {
    verticalGutter = gutter;
    horizontalGutter = gutter;
  } else {
    verticalGutter = (_a = gutter.vertical) !== null && _a !== void 0 ? _a : DEFAULT_GUTTER_WIDTH;
    horizontalGutter = (_b = gutter.horizontal) !== null && _b !== void 0 ? _b : DEFAULT_GUTTER_WIDTH;
  }

  return {
    vertical: verticalGutter / 2,
    horizontal: horizontalGutter / 2
  };
};

var limitColumns = function limitColumns(isFluid, amountOfColumns) {
  if (!amountOfColumns) return undefined;

  if (!isFluid && amountOfColumns > MAX_AMOUNT_OF_FIXED_COLUMNS) {
    return MAX_AMOUNT_OF_FIXED_COLUMNS;
  }

  return amountOfColumns;
};

var FlexGrid = withStyling(component$w);

var styles$v = {"flexRow":"flex-row-module_flexRow__SfuO4","flexRowWrapper":"flex-row-module_flexRowWrapper__3IQ86","flexItem":"flex-row-module_flexItem__1oL5U"};

var component$x = function component(props) {
  var gutter = props.gutter && props.gutter !== 0 ? props.gutter : 8;
  var children = Array.isArray(props.children) ? props.children : [props.children];
  var styling = {
    margin: "-".concat(gutter / 2, "px"),
    alignItems: getAlignment(props.verticalAlign),
    justifyContent: getAlignment(props.horizontalAlign)
  };
  return jsx("div", Object.assign({
    className: props.styling.getStyle(styles$v, 'flexRow')
  }, {
    children: jsx("div", Object.assign({
      className: clsx(props.styling.getStyle(styles$v, 'flexRowWrapper'), props.className),
      style: styling
    }, {
      children: children.map(function (child, index) {
        return /*#__PURE__*/React.cloneElement(child, {
          key: index,
          gutter: gutter
        });
      })
    }), void 0)
  }), void 0);
};

var FlexRow = withStyling(component$x);

var styles$w = {"grid":"grid-module_grid__2fEdO"};

var component$y = function component(props) {
  var minItemWidth = props.minItemWidth ? props.minItemWidth : 120;
  var gutter = props.gutter && props.gutter !== 0 ? props.gutter : 8;
  return jsx("div", Object.assign({
    className: props.styling.getStyle(styles$w, 'grid'),
    style: {
      gridGap: "".concat(gutter, "px"),
      gridTemplateColumns: "repeat(auto-fill, minmax(".concat(minItemWidth, "px, 1fr))")
    }
  }, {
    children: props.children
  }), void 0);
};

var Grid = withStyling(component$y);

export { Border, ButtonBase, Checkbox, CheckboxGroup, Column, Combobox, Container, ContextMenu, DatePicker, DraggableComponent, FileUpload, FlexColumn, FlexGrid, FlexRow, FormGroup, FormItem, FormLabel, FormRow, FormTooltip, Grid, Icon, InteractiveLabel, Loader, Modal, NumberField, Pagination, PieChart, Popper, RadioButton, RadioButtonGroup, Select, SelectedLabelsList, StylingOverrideUtil, Table, TextArea, TextField, ToastContainer, UrlField, getAlignment, showToast, withStyling };
